"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllStates = exports.getStatesByCountryCode = exports.STATE_OPTIONS_BY_COUNTRY = void 0;
exports.STATE_OPTIONS_BY_COUNTRY = {
    AD: [
        {
            name: 'Andorra la Vella',
            code: "Parròquia d'Andorra la Vella",
            iso_code: 'AD-07',
        },
        { name: 'Canillo', code: 'Canillo', iso_code: 'AD-02' },
        { name: 'Encamp', code: 'Encamp', iso_code: 'AD-03' },
        {
            name: 'Escaldes-Engordany',
            code: 'Escaldes-Engordany',
            iso_code: 'AD-08',
        },
        { name: 'La Massana', code: 'La Massana', iso_code: 'AD-04' },
        { name: 'Ordino', code: 'Ordino', iso_code: 'AD-05' },
        {
            name: 'Sant Julià de Lòria',
            code: 'Sant Julià de Lòria',
            iso_code: 'AD-06',
        },
    ],
    AE: [
        {
            name: 'Abu Dhabi',
            local_name: 'أبو ظبي',
            code: 'Abu Dhabi',
            local_code: 'أبو ظبي',
            type: 'emirate',
            iso_code: 'AE-AZ',
        },
        {
            name: 'Sharjah',
            local_name: 'الشارقة',
            code: 'Sharjah',
            local_code: 'إمارة الشارقةّ',
            type: 'emirate',
            iso_code: 'AE-SH',
        },
        {
            name: 'Fujairah',
            local_name: 'الفجيرة',
            code: 'Fujairah',
            local_code: 'الفجيرة',
            type: 'emirate',
            iso_code: 'AE-FU',
        },
        {
            name: 'Umm Al Quwain',
            local_name: 'ام القيوين',
            code: 'Umm Al Quwain',
            local_code: 'ام القيوين',
            type: 'emirate',
            iso_code: 'AE-UQ',
        },
        {
            name: 'Dubai',
            local_name: 'دبي',
            code: 'Dubai',
            local_code: 'إمارة دبيّ',
            type: 'emirate',
            iso_code: 'AE-DU',
        },
        {
            name: 'Ras al Khaimah',
            local_name: 'رأس الخيمة',
            code: 'Ras al Khaimah',
            local_code: 'إمارة رأس الخيمة',
            type: 'emirate',
            iso_code: 'AE-RK',
        },
        {
            name: 'Ajman',
            local_name: 'عجمان',
            code: 'Ajman',
            local_code: 'عجمان',
            type: 'emirate',
            iso_code: 'AE-AJ',
        },
    ],
    AF: [],
    AG: [],
    AI: [],
    AL: [],
    AM: [
        {
            name: 'Aragatsotn',
            local_name: 'Արագածոտն',
            code: 'Aragatsotn',
            local_code: 'Արագածոտն',
            type: 'province',
            iso_code: 'AM-AG',
        },
        {
            name: 'Ararat',
            local_name: 'Արարատ',
            code: 'Ararat',
            local_code: 'Արարատ',
            type: 'province',
            iso_code: 'AM-AR',
        },
        {
            name: 'Armavir',
            local_name: 'Արմավիր',
            code: 'Armavir',
            local_code: 'Արմավիր',
            type: 'province',
            iso_code: 'AM-AV',
        },
        {
            name: 'Gegharkunik',
            local_name: 'Գեղարքունիք',
            code: 'Gegharkunik',
            local_code: 'Գեղարքունիք',
            type: 'province',
            iso_code: 'AM-GR',
        },
        {
            name: 'Yerevan',
            local_name: 'Երևան',
            code: 'Yerevan',
            local_code: 'Երևան',
            type: 'province',
            iso_code: 'AM-ER',
        },
        {
            name: 'Lori',
            local_name: 'Լոռի',
            code: 'Lori',
            local_code: 'Լոռի',
            type: 'province',
            iso_code: 'AM-LO',
        },
        {
            name: 'Kotayk',
            local_name: 'Կոտայք',
            code: 'Kotayk',
            local_code: 'Կոտայք',
            type: 'province',
            iso_code: 'AM-KT',
        },
        {
            name: 'Shirak',
            local_name: 'Շիրակ',
            code: 'Shirak',
            local_code: 'Շիրակ',
            type: 'province',
            iso_code: 'AM-SH',
        },
        {
            name: 'Syunik',
            local_name: 'Սյունիք',
            code: 'Syunik',
            local_code: 'Սյունիք',
            type: 'province',
            iso_code: 'AM-SU',
        },
        {
            name: 'Vayots Dzor',
            local_name: 'Վայոց ձոր',
            code: 'Vayots Dzor',
            local_code: 'Վայոց ձոր',
            type: 'province',
            iso_code: 'AM-VD',
        },
        {
            name: 'Tavush',
            local_name: 'Տավուշ',
            code: 'Tavush',
            local_code: 'Տավուշ',
            type: 'province',
            iso_code: 'AM-TV',
        },
    ],
    AO: [],
    AQ: [],
    AR: [
        {
            name: 'Buenos Aires',
            code: 'Buenos Aires',
            type: 'province',
            iso_code: 'AR-B',
        },
        {
            name: 'Catamarca',
            code: 'Catamarca',
            type: 'province',
            iso_code: 'AR-K',
        },
        { name: 'Chaco', code: 'Chaco', type: 'province', iso_code: 'AR-H' },
        { name: 'Chubut', code: 'Chubut', type: 'province', iso_code: 'AR-U' },
        {
            name: 'Ciudad Autónoma de Buenos Aires',
            code: 'Ciudad Autónoma de Buenos Aires',
            type: 'province',
            iso_code: 'AR-C',
        },
        { name: 'Córdoba', code: 'Córdoba', type: 'province', iso_code: 'AR-X' },
        {
            name: 'Corrientes',
            code: 'Corrientes',
            type: 'province',
            iso_code: 'AR-W',
        },
        {
            name: 'Entre Ríos',
            code: 'Entre Ríos',
            type: 'province',
            iso_code: 'AR-E',
        },
        { name: 'Formosa', code: 'Formosa', type: 'province', iso_code: 'AR-P' },
        { name: 'Jujuy', code: 'Jujuy', type: 'province', iso_code: 'AR-Y' },
        { name: 'La Pampa', code: 'La Pampa', type: 'province', iso_code: 'AR-L' },
        { name: 'La Rioja', code: 'La Rioja', type: 'province', iso_code: 'AR-F' },
        { name: 'Mendoza', code: 'Mendoza', type: 'province', iso_code: 'AR-M' },
        { name: 'Misiones', code: 'Misiones', type: 'province', iso_code: 'AR-N' },
        { name: 'Neuquén', code: 'Neuquén', type: 'province', iso_code: 'AR-Q' },
        {
            name: 'Río Negro',
            code: 'Río Negro',
            type: 'province',
            iso_code: 'AR-R',
        },
        { name: 'Salta', code: 'Salta', type: 'province', iso_code: 'AR-A' },
        { name: 'San Juan', code: 'San Juan', type: 'province', iso_code: 'AR-J' },
        { name: 'San Luis', code: 'San Luis', type: 'province', iso_code: 'AR-D' },
        {
            name: 'Santa Cruz',
            code: 'Santa Cruz',
            type: 'province',
            iso_code: 'AR-Z',
        },
        { name: 'Santa Fe', code: 'Santa Fe', type: 'province', iso_code: 'AR-S' },
        {
            name: 'Santiago del Estero',
            code: 'Santiago del Estero',
            type: 'province',
            iso_code: 'AR-G',
        },
        {
            name: 'Tierra del Fuego',
            code: 'Tierra del Fuego',
            type: 'province',
            iso_code: 'AR-V',
        },
        { name: 'Tucumán', code: 'Tucumán', type: 'province', iso_code: 'AR-T' },
    ],
    AS: [],
    AT: [],
    AU: [
        {
            name: 'Australian Capital Territory',
            code: 'ACT',
            type: 'state',
            iso_code: 'AU-ACT',
        },
        { name: 'New South Wales', code: 'NSW', type: 'state', iso_code: 'AU-NSW' },
        {
            name: 'Northern Territory',
            code: 'NT',
            type: 'state',
            iso_code: 'AU-NT',
        },
        { name: 'Queensland', code: 'QLD', type: 'state', iso_code: 'AU-QLD' },
        { name: 'South Australia', code: 'SA', type: 'state', iso_code: 'AU-SA' },
        { name: 'Tasmania', code: 'TAS', type: 'state', iso_code: 'AU-TAS' },
        { name: 'Victoria', code: 'VIC', type: 'state', iso_code: 'AU-VIC' },
        { name: 'Western Australia', code: 'WA', type: 'state', iso_code: 'AU-WA' },
    ],
    AW: [],
    AX: [],
    AZ: [],
    BA: [],
    BB: [],
    BD: [],
    BE: [],
    BF: [],
    BG: [],
    BH: [],
    BI: [],
    BJ: [],
    BL: [],
    BM: [],
    BN: [],
    BO: [],
    BQ: [],
    BR: [
        { name: 'Acre', code: 'AC', type: 'state', iso_code: 'BR-AC' },
        { name: 'Alagoas', code: 'AL', type: 'state', iso_code: 'BR-AL' },
        { name: 'Amapá', code: 'AP', type: 'state', iso_code: 'BR-AP' },
        { name: 'Amazonas', code: 'AM', type: 'state', iso_code: 'BR-AM' },
        { name: 'Bahia', code: 'BA', type: 'state', iso_code: 'BR-BA' },
        { name: 'Ceará', code: 'CE', type: 'state', iso_code: 'BR-CE' },
        { name: 'Distrito Federal', code: 'DF', type: 'state', iso_code: 'BR-DF' },
        { name: 'Espírito Santo', code: 'ES', type: 'state', iso_code: 'BR-ES' },
        { name: 'Goiás', code: 'GO', type: 'state', iso_code: 'BR-GO' },
        { name: 'Maranhão', code: 'MA', type: 'state', iso_code: 'BR-MA' },
        { name: 'Mato Grosso', code: 'MT', type: 'state', iso_code: 'BR-MT' },
        {
            name: 'Mato Grosso do Sul',
            code: 'MS',
            type: 'state',
            iso_code: 'BR-MS',
        },
        { name: 'Minas Gerais', code: 'MG', type: 'state', iso_code: 'BR-MG' },
        { name: 'Pará', code: 'PA', type: 'state', iso_code: 'BR-PA' },
        { name: 'Paraíba', code: 'PB', type: 'state', iso_code: 'BR-PB' },
        { name: 'Paraná', code: 'PR', type: 'state', iso_code: 'BR-PR' },
        { name: 'Pernambuco', code: 'PE', type: 'state', iso_code: 'BR-PE' },
        { name: 'Piauí', code: 'PI', type: 'state', iso_code: 'BR-PI' },
        { name: 'Rio de Janeiro', code: 'RJ', type: 'state', iso_code: 'BR-RJ' },
        {
            name: 'Rio Grande do Norte',
            code: 'RN',
            type: 'state',
            iso_code: 'BR-RN',
        },
        { name: 'Rio Grande do Sul', code: 'RS', type: 'state', iso_code: 'BR-RS' },
        { name: 'Rondônia', code: 'RO', type: 'state', iso_code: 'BR-RO' },
        { name: 'Roraima', code: 'RR', type: 'state', iso_code: 'BR-RR' },
        { name: 'Santa Catarina', code: 'SC', type: 'state', iso_code: 'BR-SC' },
        { name: 'São Paulo', code: 'SP', type: 'state', iso_code: 'BR-SP' },
        { name: 'Sergipe', code: 'SE', type: 'state', iso_code: 'BR-SE' },
        { name: 'Tocantins', code: 'TO', type: 'state', iso_code: 'BR-TO' },
    ],
    BS: [
        { name: 'Abaco Islands', code: 'Abaco', type: 'island' },
        { name: 'Acklins', code: 'Acklins', type: 'island', iso_code: 'BS-AK' },
        { name: 'Andros Island', code: 'Andros', type: 'island' },
        {
            name: 'Berry Islands',
            code: 'Berry Islands',
            type: 'island',
            iso_code: 'BS-BY',
        },
        { name: 'Bimini', code: 'Bimini', type: 'island', iso_code: 'BS-BI' },
        {
            name: 'Cat Island',
            code: 'Cat Island',
            type: 'island',
            iso_code: 'BS-CI',
        },
        { name: 'Crooked Island', code: 'Crooked Island', type: 'island' },
        { name: 'Eleuthera', code: 'Eleuthera', type: 'island' },
        {
            name: 'Exuma and Cays',
            code: 'Exuma',
            type: 'island',
            iso_code: 'BS-EX',
        },
        { name: 'Grand Bahama', code: 'Grand Bahama', type: 'island' },
        {
            name: 'Harbour Island',
            code: 'Harbour Island',
            type: 'island',
            iso_code: 'BS-HI',
        },
        { name: 'Inagua', code: 'Inagua', type: 'island', iso_code: 'BS-IN' },
        {
            name: 'Long Island',
            code: 'Long Island',
            type: 'island',
            iso_code: 'BS-LI',
        },
        { name: 'Mayaguana', code: 'Mayaguana', type: 'island', iso_code: 'BS-MG' },
        { name: 'New Providence', code: 'N.P.', type: 'island' },
        {
            name: 'Ragged Island',
            code: 'Ragged Island',
            type: 'island',
            iso_code: 'BS-RI',
        },
        { name: 'Rum Cay', code: 'Rum Cay', type: 'island', iso_code: 'BS-RC' },
        {
            name: 'San Salvador',
            code: 'San Salvador',
            type: 'island',
            iso_code: 'BS-SS',
        },
        {
            name: 'Spanish Wells',
            code: 'Spanish Wells',
            type: 'island',
            iso_code: 'BS-SW',
        },
    ],
    BT: [],
    BV: [],
    BW: [],
    BY: [],
    BZ: [],
    CA: [
        {
            name: 'Alberta',
            local_name: 'Alberta',
            code: 'AB',
            local_code: 'AB',
            type: 'province',
            iso_code: 'CA-AB',
        },
        {
            name: 'British Columbia',
            local_name: 'Colombie-Britannique',
            code: 'BC',
            local_code: 'BC',
            type: 'province',
            iso_code: 'CA-BC',
        },
        {
            name: 'Manitoba',
            local_name: 'Manitoba',
            code: 'MB',
            local_code: 'MB',
            type: 'province',
            iso_code: 'CA-MB',
        },
        {
            name: 'New Brunswick',
            local_name: 'Nouveau-Brunswick',
            code: 'NB',
            local_code: 'NB',
            type: 'province',
            iso_code: 'CA-NB',
        },
        {
            name: 'Newfoundland and Labrador',
            local_name: 'Terre-Neuve-et-Labrador',
            code: 'NL',
            local_code: 'NL',
            type: 'province',
            iso_code: 'CA-NL',
        },
        {
            name: 'Northwest Territories',
            local_name: 'Territoires du Nord-Ouest',
            code: 'NT',
            local_code: 'NT',
            type: 'province',
            iso_code: 'CA-NT',
        },
        {
            name: 'Nova Scotia',
            local_name: 'Nouvelle-Écosse',
            code: 'NS',
            local_code: 'NS',
            type: 'province',
            iso_code: 'CA-NS',
        },
        {
            name: 'Nunavut',
            local_name: 'Nunavut',
            code: 'NU',
            local_code: 'NU',
            type: 'province',
            iso_code: 'CA-NU',
        },
        {
            name: 'Ontario',
            local_name: 'Ontario',
            code: 'ON',
            local_code: 'ON',
            type: 'province',
            iso_code: 'CA-ON',
        },
        {
            name: 'Prince Edward Island',
            local_name: 'Île-du-Prince-Édouard',
            code: 'PE',
            local_code: 'PE',
            type: 'province',
            iso_code: 'CA-PE',
        },
        {
            name: 'Quebec',
            local_name: 'Québec',
            code: 'QC',
            local_code: 'QC',
            type: 'province',
            iso_code: 'CA-QC',
        },
        {
            name: 'Saskatchewan',
            local_name: 'Saskatchewan',
            code: 'SK',
            local_code: 'SK',
            type: 'province',
            iso_code: 'CA-SK',
        },
        {
            name: 'Yukon',
            local_name: 'Yukon',
            code: 'YT',
            local_code: 'YT',
            type: 'province',
            iso_code: 'CA-YT',
        },
    ],
    CC: [],
    CD: [],
    CF: [],
    CG: [],
    CH: [],
    CI: [],
    CK: [],
    CL: [
        {
            name: 'Antofagasta',
            code: 'Antofagasta',
            type: 'province',
            iso_code: 'CL-AN',
        },
        {
            name: 'Araucanía',
            code: 'Araucanía',
            type: 'province',
            iso_code: 'CL-AR',
        },
        {
            name: 'Arica y Parinacota',
            code: 'Arica y Parinacota',
            type: 'province',
            iso_code: 'CL-AP',
        },
        { name: 'Atacama', code: 'Atacama', type: 'province', iso_code: 'CL-AT' },
        {
            name: 'Aysén del General Carlos Ibáñez del Campo',
            code: 'Aysén',
            type: 'province',
            iso_code: 'CL-AI',
        },
        { name: 'Biobío', code: 'Biobío', type: 'province', iso_code: 'CL-BI' },
        { name: 'Coquimbo', code: 'Coquimbo', type: 'province', iso_code: 'CL-CO' },
        {
            name: "Libertador General Bernardo O'Higgins",
            code: "O'Higgins",
            type: 'province',
            iso_code: 'CL-LI',
        },
        {
            name: 'Los Lagos',
            code: 'Los Lagos',
            type: 'province',
            iso_code: 'CL-LL',
        },
        { name: 'Los Ríos', code: 'Los Ríos', type: 'province', iso_code: 'CL-LR' },
        {
            name: 'Magallanes y de la Antártica Chilena',
            code: 'Magallanes',
            type: 'province',
            iso_code: 'CL-MA',
        },
        { name: 'Maule', code: 'Maule', type: 'province', iso_code: 'CL-ML' },
        {
            name: 'Metropolitana de Santiago',
            code: 'Región Metropolitana',
            type: 'province',
            iso_code: 'CL-RM',
        },
        { name: 'Tarapacá', code: 'Tarapacá', type: 'province', iso_code: 'CL-TA' },
        {
            name: 'Valparaíso',
            code: 'Valparaíso',
            type: 'province',
            iso_code: 'CL-VS',
        },
    ],
    CM: [],
    CN: [
        {
            name: 'Anhui Sheng',
            local_name: '安徽省',
            code: 'Anhui Sheng',
            local_code: '安徽省',
            type: 'province',
            iso_code: 'CN-34',
        },
        {
            name: 'Macau',
            local_name: '澳门',
            code: 'Macau',
            local_code: '澳门',
            type: 'province',
            iso_code: 'CN-92',
        },
        {
            name: 'Beijing Shi',
            local_name: '北京市',
            code: 'Beijing Shi',
            local_code: '北京市',
            type: 'province',
            iso_code: 'CN-11',
        },
        {
            name: 'Chongqing Shi',
            local_name: '重庆市',
            code: 'Chongqing Shi',
            local_code: '重庆市',
            type: 'province',
            iso_code: 'CN-50',
        },
        {
            name: 'Fujian Sheng',
            local_name: '福建省',
            code: 'Fujian Sheng',
            local_code: '福建省',
            type: 'province',
            iso_code: 'CN-35',
        },
        {
            name: 'Gansu Sheng',
            local_name: '甘肃省',
            code: 'Gansu Sheng',
            local_code: '甘肃省',
            type: 'province',
            iso_code: 'CN-62',
        },
        {
            name: 'Guangdong Sheng',
            local_name: '广东省',
            code: 'Guangdong Sheng',
            local_code: '广东省',
            type: 'province',
            iso_code: 'CN-44',
        },
        {
            name: 'Guangxi Zhuangzuzizhiqu',
            local_name: '广西',
            code: 'Guangxi Zhuangzuzizhiqu',
            local_code: '广西壮族自治区',
            type: 'province',
            iso_code: 'CN-45',
        },
        {
            name: 'Guizhou Sheng',
            local_name: '贵州省',
            code: 'Guizhou Sheng',
            local_code: '贵州省',
            type: 'province',
            iso_code: 'CN-52',
        },
        {
            name: 'Hainan Sheng',
            local_name: '海南省',
            code: 'Hainan Sheng',
            local_code: '海南省',
            type: 'province',
            iso_code: 'CN-46',
        },
        {
            name: 'Hebei Sheng',
            local_name: '河北省',
            code: 'Hebei Sheng',
            local_code: '河北省',
            type: 'province',
            iso_code: 'CN-13',
        },
        {
            name: 'Henan Sheng',
            local_name: '河南省',
            code: 'Henan Sheng',
            local_code: '河南省',
            type: 'province',
            iso_code: 'CN-41',
        },
        {
            name: 'Heilongjiang Sheng',
            local_name: '黑龙江省',
            code: 'Heilongjiang Sheng',
            local_code: '黑龙江省',
            type: 'province',
            iso_code: 'CN-23',
        },
        {
            name: 'Hubei Sheng',
            local_name: '湖北省',
            code: 'Hubei Sheng',
            local_code: '湖北省',
            type: 'province',
            iso_code: 'CN-42',
        },
        {
            name: 'Hunan Sheng',
            local_name: '湖南省',
            code: 'Hunan Sheng',
            local_code: '湖南省',
            type: 'province',
            iso_code: 'CN-43',
        },
        {
            name: 'Jilin Sheng',
            local_name: '吉林省',
            code: 'Jilin Sheng',
            local_code: '吉林省',
            type: 'province',
            iso_code: 'CN-22',
        },
        {
            name: 'Jiangsu Sheng',
            local_name: '江苏省',
            code: 'Jiangsu Sheng',
            local_code: '江苏省',
            type: 'province',
            iso_code: 'CN-32',
        },
        {
            name: 'Jiangxi Sheng',
            local_name: '江西省',
            code: 'Jiangxi Sheng',
            local_code: '江西省',
            type: 'province',
            iso_code: 'CN-36',
        },
        {
            name: 'Liaoning Sheng',
            local_name: '辽宁省',
            code: 'Liaoning Sheng',
            local_code: '辽宁省',
            type: 'province',
            iso_code: 'CN-21',
        },
        {
            name: 'Neimenggu Zizhiqu',
            local_name: '内蒙古',
            code: 'Neimenggu Zizhiqu',
            local_code: '内蒙古自治区',
            type: 'province',
            iso_code: 'CN-15',
        },
        {
            name: 'Ningxia Huizuzizhiqu',
            local_name: '宁夏',
            code: 'Ningxia Huizuzizhiqu',
            local_code: '宁夏回族自治区',
            type: 'province',
            iso_code: 'CN-64',
        },
        {
            name: 'Qinghai Sheng',
            local_name: '青海省',
            code: 'Qinghai Sheng',
            local_code: '青海省',
            type: 'province',
            iso_code: 'CN-63',
        },
        {
            name: 'Shandong Sheng',
            local_name: '山东省',
            code: 'Shandong Sheng',
            local_code: '山东省',
            type: 'province',
            iso_code: 'CN-37',
        },
        {
            name: 'Shanxi Sheng',
            local_name: '山西省',
            code: 'Shanxi Sheng',
            local_code: '山西省',
            type: 'province',
            iso_code: 'CN-14',
        },
        {
            name: 'Shaanxi Sheng',
            local_name: '陕西省',
            code: 'Shaanxi Sheng',
            local_code: '陕西省',
            type: 'province',
            iso_code: 'CN-61',
        },
        {
            name: 'Shanghai Shi',
            local_name: '上海市',
            code: 'Shanghai Shi',
            local_code: '上海市',
            type: 'province',
            iso_code: 'CN-31',
        },
        {
            name: 'Sichuan Sheng',
            local_name: '四川省',
            code: 'Sichuan Sheng',
            local_code: '四川省',
            type: 'province',
            iso_code: 'CN-51',
        },
        {
            name: 'Taiwan',
            local_name: '台湾',
            code: 'Taiwan',
            local_code: '台湾',
            type: 'province',
            iso_code: 'CN-71',
        },
        {
            name: 'Tianjin Shi',
            local_name: '天津市',
            code: 'Tianjin Shi',
            local_code: '天津市',
            type: 'province',
            iso_code: 'CN-12',
        },
        {
            name: 'Xizang Zizhiqu',
            local_name: '西藏',
            code: 'Xizang Zizhiqu',
            local_code: '西藏自治区',
            type: 'province',
            iso_code: 'CN-54',
        },
        {
            name: 'Hong Kong',
            local_name: '香港',
            code: 'Hong Kong',
            local_code: '香港',
            type: 'province',
            iso_code: 'CN-91',
        },
        {
            name: 'Xinjiang Weiwuerzizhiqu',
            local_name: '新疆',
            code: 'Xinjiang Weiwuerzizhiqu',
            local_code: '新疆维吾尔自治区',
            type: 'province',
            iso_code: 'CN-65',
        },
        {
            name: 'Yunnan Sheng',
            local_name: '云南省',
            code: 'Yunnan Sheng',
            local_code: '云南省',
            type: 'province',
            iso_code: 'CN-53',
        },
        {
            name: 'Zhejiang Sheng',
            local_name: '浙江省',
            code: 'Zhejiang Sheng',
            local_code: '浙江省',
            type: 'province',
            iso_code: 'CN-33',
        },
    ],
    CO: [
        {
            name: 'Distrito Capital de Bogotá',
            code: 'DC',
            type: 'department',
            iso_code: 'CO-DC',
        },
        { name: 'Amazonas', code: 'AMA', type: 'department', iso_code: 'CO-AMA' },
        { name: 'Antioquia', code: 'ANT', type: 'department', iso_code: 'CO-ANT' },
        { name: 'Arauca', code: 'ARA', type: 'department', iso_code: 'CO-ARA' },
        { name: 'Atlántico', code: 'ATL', type: 'department', iso_code: 'CO-ATL' },
        { name: 'Bolívar', code: 'BOL', type: 'department', iso_code: 'CO-BOL' },
        { name: 'Boyacá', code: 'BOY', type: 'department', iso_code: 'CO-BOY' },
        { name: 'Caldas', code: 'CAL', type: 'department', iso_code: 'CO-CAL' },
        { name: 'Caquetá', code: 'CAQ', type: 'department', iso_code: 'CO-CAQ' },
        { name: 'Casanare', code: 'CAS', type: 'department', iso_code: 'CO-CAS' },
        { name: 'Cauca', code: 'CAU', type: 'department', iso_code: 'CO-CAU' },
        { name: 'Cesar', code: 'CES', type: 'department', iso_code: 'CO-CES' },
        { name: 'Córdoba', code: 'COR', type: 'department', iso_code: 'CO-COR' },
        {
            name: 'Cundinamarca',
            code: 'CUN',
            type: 'department',
            iso_code: 'CO-CUN',
        },
        { name: 'Chocó', code: 'CHO', type: 'department', iso_code: 'CO-CHO' },
        { name: 'Guanía', code: 'GUA', type: 'department', iso_code: 'CO-GUA' },
        { name: 'Guaviare', code: 'GUV', type: 'department', iso_code: 'CO-GUV' },
        { name: 'Huila', code: 'HUI', type: 'department', iso_code: 'CO-HUI' },
        { name: 'La Guajira', code: 'LAG', type: 'department', iso_code: 'CO-LAG' },
        { name: 'Magdalena', code: 'MAG', type: 'department', iso_code: 'CO-MAG' },
        { name: 'Meta', code: 'MET', type: 'department', iso_code: 'CO-MET' },
        { name: 'Nariño', code: 'NAR', type: 'department', iso_code: 'CO-NAR' },
        {
            name: 'Norte de Santander',
            code: 'NSA',
            type: 'department',
            iso_code: 'CO-NSA',
        },
        { name: 'Putumayo', code: 'PUT', type: 'department', iso_code: 'CO-PUT' },
        { name: 'Quindío', code: 'QUI', type: 'department', iso_code: 'CO-QUI' },
        { name: 'Risaralda', code: 'RIS', type: 'department', iso_code: 'CO-RIS' },
        {
            name: 'San Andrés, Providencia y Santa Catalina',
            code: 'SAP',
            type: 'department',
            iso_code: 'CO-SAP',
        },
        { name: 'Santander', code: 'SAN', type: 'department', iso_code: 'CO-SAN' },
        { name: 'Sucre', code: 'SUC', type: 'department', iso_code: 'CO-SUC' },
        { name: 'Tolima', code: 'TOL', type: 'department', iso_code: 'CO-TOL' },
        {
            name: 'Valle del Cauca',
            code: 'VAC',
            type: 'department',
            iso_code: 'CO-VAC',
        },
        { name: 'Vaupés', code: 'VAU', type: 'department', iso_code: 'CO-VAU' },
        { name: 'Vichada', code: 'VID', type: 'department', iso_code: 'CO-VID' },
    ],
    CR: [],
    CU: [
        { name: 'Artemisa', code: 'Artemisa', type: 'province', iso_code: 'CU-15' },
        { name: 'Camagüey', code: 'Camagüey', type: 'province', iso_code: 'CU-09' },
        {
            name: 'Ciego de Ávila',
            code: 'Ciego de Ávila',
            type: 'province',
            iso_code: 'CU-08',
        },
        {
            name: 'Cienfuegos',
            code: 'Cienfuegos',
            type: 'province',
            iso_code: 'CU-06',
        },
        { name: 'Granma', code: 'Granma', type: 'province', iso_code: 'CU-12' },
        {
            name: 'Guantánamo',
            code: 'Guantánamo',
            type: 'province',
            iso_code: 'CU-14',
        },
        { name: 'Holguín', code: 'Holguín', type: 'province', iso_code: 'CU-11' },
        {
            name: 'Isla de la Juventud',
            code: 'Isla de la Juventud',
            type: 'province',
            iso_code: 'CU-99',
        },
        {
            name: 'La Habana',
            code: 'La Habana',
            type: 'province',
            iso_code: 'CU-03',
        },
        {
            name: 'Las Tunas',
            code: 'Las Tunas',
            type: 'province',
            iso_code: 'CU-10',
        },
        { name: 'Matanzas', code: 'Matanzas', type: 'province', iso_code: 'CU-04' },
        {
            name: 'Mayabeque',
            code: 'Mayabeque',
            type: 'province',
            iso_code: 'CU-16',
        },
        {
            name: 'Pinar del Río',
            code: 'Pinar del Río',
            type: 'province',
            iso_code: 'CU-01',
        },
        {
            name: 'Sancti Spíritus',
            code: 'Sancti Spíritus',
            type: 'province',
            iso_code: 'CU-07',
        },
        {
            name: 'Santiago de Cuba',
            code: 'Santiago de Cuba',
            type: 'province',
            iso_code: 'CU-13',
        },
        {
            name: 'Villa Clara',
            code: 'Villa Clara',
            type: 'province',
            iso_code: 'CU-05',
        },
    ],
    CV: [
        { name: 'Boa Vista', code: 'Boa Vista', type: 'island', iso_code: 'CV-BV' },
        { name: 'Brava', code: 'Brava', type: 'island', iso_code: 'CV-BR' },
        { name: 'Fogo', code: 'Fogo', type: 'island' },
        { name: 'Maio', code: 'Maio', type: 'island', iso_code: 'CV-MA' },
        { name: 'Sal', code: 'Sal', type: 'island', iso_code: 'CV-SL' },
        { name: 'Santiago', code: 'Santiago', type: 'island' },
        { name: 'Santo Antão', code: 'Santo Antão', type: 'island' },
        { name: 'São Nicolau', code: 'São Nicolau', type: 'island' },
        {
            name: 'São Vicente',
            code: 'São Vicente',
            type: 'island',
            iso_code: 'CV-SV',
        },
    ],
    CW: [],
    CX: [],
    CY: [],
    CZ: [],
    DE: [],
    DJ: [],
    DK: [],
    DM: [],
    DO: [],
    DZ: [],
    EC: [],
    EE: [],
    EG: [
        {
            name: 'Aswan Governorate',
            local_name: 'أسوان',
            code: 'Aswan Governorate',
            local_code: 'أسوان',
            type: 'province',
            iso_code: 'EG-ASN',
        },
        {
            name: 'Asyut Governorate',
            local_name: 'أسيوط',
            code: 'Asyut Governorate',
            local_code: 'أسيوط',
            type: 'province',
            iso_code: 'EG-AST',
        },
        {
            name: 'Alexandria Governorate',
            local_name: 'الإسكندرية',
            code: 'Alexandria Governorate',
            local_code: 'الإسكندرية',
            type: 'province',
            iso_code: 'EG-ALX',
        },
        {
            name: 'Ismailia Governorate',
            local_name: 'الإسماعيلية',
            code: 'Ismailia Governorate',
            local_code: 'الإسماعيلية',
            type: 'province',
            iso_code: 'EG-IS',
        },
        {
            name: 'Luxor Governorate',
            local_name: 'الأقصر',
            code: 'Luxor Governorate',
            local_code: 'الأقصر',
            type: 'province',
            iso_code: 'EG-LX',
        },
        {
            name: 'Red Sea Governorate',
            local_name: 'البحر الأحمر',
            code: 'Red Sea Governorate',
            local_code: 'البحر الأحمر',
            type: 'province',
            iso_code: 'EG-BA',
        },
        {
            name: 'El Beheira Governorate',
            local_name: 'البحيرة',
            code: 'El Beheira Governorate',
            local_code: 'البحيرة',
            type: 'province',
            iso_code: 'EG-BH',
        },
        {
            name: 'Giza Governorate',
            local_name: 'الجيزة',
            code: 'Giza Governorate',
            local_code: 'الجيزة',
            type: 'province',
            iso_code: 'EG-GZ',
        },
        {
            name: 'Dakahlia Governorate',
            local_name: 'الدقهلية',
            code: 'Dakahlia Governorate',
            local_code: 'الدقهلية',
            type: 'province',
            iso_code: 'EG-DK',
        },
        {
            name: 'Suez Governorate',
            local_name: 'السويس',
            code: 'Suez Governorate',
            local_code: 'السويس',
            type: 'province',
            iso_code: 'EG-SUZ',
        },
        {
            name: 'Ash Sharqia Governorate',
            local_name: 'الشرقية',
            code: 'Ash Sharqia Governorate',
            local_code: 'الشرقية',
            type: 'province',
            iso_code: 'EG-SHR',
        },
        {
            name: 'Gharbia Governorate',
            local_name: 'الغربية',
            code: 'Gharbia Governorate',
            local_code: 'الغربية',
            type: 'province',
            iso_code: 'EG-GH',
        },
        {
            name: 'Faiyum Governorate',
            local_name: 'الفيوم',
            code: 'Faiyum Governorate',
            local_code: 'الفيوم',
            type: 'province',
            iso_code: 'EG-FYM',
        },
        {
            name: 'Cairo Governorate',
            local_name: 'القاهرة',
            code: 'Cairo Governorate',
            local_code: 'القاهرة',
            type: 'province',
            iso_code: 'EG-C',
        },
        {
            name: 'Qalyubia Governorate',
            local_name: 'القليوبية',
            code: 'Qalyubia Governorate',
            local_code: 'القليوبية',
            type: 'province',
            iso_code: 'EG-KB',
        },
        {
            name: 'Menofia Governorate',
            local_name: 'المنوفية',
            code: 'Menofia Governorate',
            local_code: 'المنوفية',
            type: 'province',
            iso_code: 'EG-MNF',
        },
        {
            name: 'Menia Governorate',
            local_name: 'المنيا',
            code: 'Menia Governorate',
            local_code: 'المنيا',
            type: 'province',
            iso_code: 'EG-MN',
        },
        {
            name: 'New Valley Governorate',
            local_name: 'الوادي الجديد',
            code: 'New Valley Governorate',
            local_code: 'الوادي الجديد',
            type: 'province',
            iso_code: 'EG-WAD',
        },
        {
            name: 'Beni Suef Governorate',
            local_name: 'بني سويف',
            code: 'Beni Suef Governorate',
            local_code: 'بني سويف',
            type: 'province',
            iso_code: 'EG-BNS',
        },
        {
            name: 'Port Said Governorate',
            local_name: 'بورسعيد',
            code: 'Port Said Governorate',
            local_code: 'بورسعيد',
            type: 'province',
            iso_code: 'EG-PTS',
        },
        {
            name: 'South Sinai Governorate',
            local_name: 'جنوب سيناء',
            code: 'South Sinai Governorate',
            local_code: 'جنوب سيناء',
            type: 'province',
            iso_code: 'EG-JS',
        },
        {
            name: 'Damietta Governorate',
            local_name: 'دمياط',
            code: 'Damietta Governorate',
            local_code: 'دمياط',
            type: 'province',
            iso_code: 'EG-DT',
        },
        {
            name: 'Sohag Governorate',
            local_name: 'سوهاج',
            code: 'Sohag Governorate',
            local_code: 'سوهاج',
            type: 'province',
            iso_code: 'EG-SHG',
        },
        {
            name: 'North Sinai Governorate',
            local_name: 'شمال سيناء',
            code: 'North Sinai Governorate',
            local_code: 'شمال سيناء',
            type: 'province',
            iso_code: 'EG-SIN',
        },
        {
            name: 'Qena Governorate',
            local_name: 'قنا',
            code: 'Qena Governorate',
            local_code: 'قنا',
            type: 'province',
            iso_code: 'EG-KN',
        },
        {
            name: 'Kafr El Sheikh Governorate',
            local_name: 'كفر الشيخ',
            code: 'Kafr El Sheikh Governorate',
            local_code: 'كفر الشيخ',
            type: 'province',
            iso_code: 'EG-KFS',
        },
        {
            name: 'Matrouh Governorate',
            local_name: 'مطروح',
            code: 'Matrouh Governorate',
            local_code: 'مطروح',
            type: 'province',
            iso_code: 'EG-MT',
        },
    ],
    EH: [],
    ER: [],
    ES: [
        { name: 'A Coruña', code: 'A Coruña', type: 'province', iso_code: 'ES-C' },
        { name: 'Álava', code: 'Álava', type: 'province', iso_code: 'ES-VI' },
        { name: 'Albacete', code: 'Albacete', type: 'province', iso_code: 'ES-AB' },
        { name: 'Alicante', code: 'Alicante', type: 'province', iso_code: 'ES-A' },
        { name: 'Almería', code: 'Almería', type: 'province', iso_code: 'ES-AL' },
        { name: 'Asturias', code: 'Asturias', type: 'province', iso_code: 'ES-O' },
        { name: 'Ávila', code: 'Ávila', type: 'province', iso_code: 'ES-AV' },
        { name: 'Badajoz', code: 'Badajoz', type: 'province', iso_code: 'ES-BA' },
        { name: 'Balears', code: 'Balears', type: 'province', iso_code: 'ES-PM' },
        {
            name: 'Barcelona',
            code: 'Barcelona',
            type: 'province',
            iso_code: 'ES-B',
        },
        { name: 'Burgos', code: 'Burgos', type: 'province', iso_code: 'ES-BU' },
        { name: 'Cáceres', code: 'Cáceres', type: 'province', iso_code: 'ES-CC' },
        { name: 'Cádiz', code: 'Cádiz', type: 'province', iso_code: 'ES-CA' },
        {
            name: 'Cantabria',
            code: 'Cantabria',
            type: 'province',
            iso_code: 'ES-S',
        },
        {
            name: 'Castellón',
            code: 'Castellón',
            type: 'province',
            iso_code: 'ES-CS',
        },
        { name: 'Ceuta', code: 'Ceuta', type: 'province', iso_code: 'ES-CE' },
        {
            name: 'Ciudad Real',
            code: 'Ciudad Real',
            type: 'province',
            iso_code: 'ES-CR',
        },
        { name: 'Córdoba', code: 'Córdoba', type: 'province', iso_code: 'ES-CO' },
        { name: 'Cuenca', code: 'Cuenca', type: 'province', iso_code: 'ES-CU' },
        { name: 'Girona', code: 'Girona', type: 'province', iso_code: 'ES-GI' },
        { name: 'Granada', code: 'Granada', type: 'province', iso_code: 'ES-GR' },
        {
            name: 'Guadalajara',
            code: 'Guadalajara',
            type: 'province',
            iso_code: 'ES-GU',
        },
        {
            name: 'Guipúzcoa',
            code: 'Guipúzcoa',
            type: 'province',
            iso_code: 'ES-SS',
        },
        { name: 'Huelva', code: 'Huelva', type: 'province', iso_code: 'ES-H' },
        { name: 'Huesca', code: 'Huesca', type: 'province', iso_code: 'ES-HU' },
        { name: 'Jaén', code: 'Jaén', type: 'province', iso_code: 'ES-J' },
        { name: 'La Rioja', code: 'La Rioja', type: 'province', iso_code: 'ES-LO' },
        {
            name: 'Las Palmas',
            code: 'Las Palmas',
            type: 'province',
            iso_code: 'ES-GC',
        },
        { name: 'León', code: 'León', type: 'province', iso_code: 'ES-LE' },
        { name: 'Lleida', code: 'Lleida', type: 'province', iso_code: 'ES-L' },
        { name: 'Lugo', code: 'Lugo', type: 'province', iso_code: 'ES-LU' },
        { name: 'Madrid', code: 'Madrid', type: 'province', iso_code: 'ES-M' },
        { name: 'Málaga', code: 'Málaga', type: 'province', iso_code: 'ES-MA' },
        { name: 'Melilla', code: 'Melilla', type: 'province', iso_code: 'ES-ML' },
        { name: 'Murcia', code: 'Murcia', type: 'province', iso_code: 'ES-MU' },
        { name: 'Navarra', code: 'Navarra', type: 'province', iso_code: 'ES-NA' },
        { name: 'Ourense', code: 'Ourense', type: 'province', iso_code: 'ES-OR' },
        { name: 'Palencia', code: 'Palencia', type: 'province', iso_code: 'ES-P' },
        {
            name: 'Pontevedra',
            code: 'Pontevedra',
            type: 'province',
            iso_code: 'ES-PO',
        },
        {
            name: 'Salamanca',
            code: 'Salamanca',
            type: 'province',
            iso_code: 'ES-SA',
        },
        {
            name: 'Santa Cruz de Tenerife',
            code: 'Santa Cruz de Tenerife',
            type: 'province',
            iso_code: 'ES-TF',
        },
        { name: 'Segovia', code: 'Segovia', type: 'province', iso_code: 'ES-SG' },
        { name: 'Sevilla', code: 'Sevilla', type: 'province', iso_code: 'ES-SE' },
        { name: 'Soria', code: 'Soria', type: 'province', iso_code: 'ES-SO' },
        {
            name: 'Tarragona',
            code: 'Tarragona',
            type: 'province',
            iso_code: 'ES-T',
        },
        { name: 'Teruel', code: 'Teruel', type: 'province', iso_code: 'ES-TE' },
        { name: 'Toledo', code: 'Toledo', type: 'province', iso_code: 'ES-TO' },
        { name: 'Valencia', code: 'Valencia', type: 'province', iso_code: 'ES-V' },
        {
            name: 'Valladolid',
            code: 'Valladolid',
            type: 'province',
            iso_code: 'ES-VA',
        },
        { name: 'Vizcaya', code: 'Vizcaya', type: 'province', iso_code: 'ES-BI' },
        { name: 'Zamora', code: 'Zamora', type: 'province', iso_code: 'ES-ZA' },
        { name: 'Zaragoza', code: 'Zaragoza', type: 'province', iso_code: 'ES-Z' },
    ],
    ET: [],
    FI: [],
    FJ: [],
    FK: [],
    FM: [],
    FO: [],
    FR: [],
    GA: [],
    GB: [],
    GD: [],
    GE: [],
    GF: [],
    GG: [],
    GH: [],
    GI: [],
    GL: [],
    GM: [],
    GN: [],
    GP: [],
    GQ: [],
    GR: [],
    GS: [],
    GT: [],
    GU: [],
    GW: [],
    GY: [],
    HK: [
        {
            name: 'Kowloon',
            local_name: '九龍',
            code: 'Kowloon',
            local_code: '九龍',
            type: 'area',
        },
        {
            name: 'Hong Kong Island',
            local_name: '香港島',
            code: 'Hong Kong Island',
            local_code: '香港島',
            type: 'area',
        },
        {
            name: 'New Territories',
            local_name: '新界',
            code: 'New Territories',
            local_code: '新界',
            type: 'area',
        },
    ],
    HM: [],
    HN: [],
    HR: [],
    HT: [],
    HU: [],
    ID: [
        { name: 'Aceh', code: 'Aceh', type: 'province', iso_code: 'ID-AC' },
        { name: 'Bali', code: 'Bali', type: 'province', iso_code: 'ID-BA' },
        { name: 'Banten', code: 'Banten', type: 'province', iso_code: 'ID-BT' },
        { name: 'Bengkulu', code: 'Bengkulu', type: 'province', iso_code: 'ID-BE' },
        {
            name: 'Daerah Istimewa Yogyakarta',
            code: 'Daerah Istimewa Yogyakarta',
            type: 'province',
            iso_code: 'ID-YO',
        },
        {
            name: 'DKI Jakarta',
            code: 'DKI Jakarta',
            type: 'province',
            iso_code: 'ID-JK',
        },
        {
            name: 'Gorontalo',
            code: 'Gorontalo',
            type: 'province',
            iso_code: 'ID-GO',
        },
        { name: 'Jambi', code: 'Jambi', type: 'province', iso_code: 'ID-JA' },
        {
            name: 'Jawa Barat',
            code: 'Jawa Barat',
            type: 'province',
            iso_code: 'ID-JB',
        },
        {
            name: 'Jawa Tengah',
            code: 'Jawa Tengah',
            type: 'province',
            iso_code: 'ID-JT',
        },
        {
            name: 'Jawa Timur',
            code: 'Jawa Timur',
            type: 'province',
            iso_code: 'ID-JI',
        },
        {
            name: 'Kalimantan Barat',
            code: 'Kalimantan Barat',
            type: 'province',
            iso_code: 'ID-KB',
        },
        {
            name: 'Kalimantan Selatan',
            code: 'Kalimantan Selatan',
            type: 'province',
            iso_code: 'ID-KS',
        },
        {
            name: 'Kalimantan Tengah',
            code: 'Kalimantan Tengah',
            type: 'province',
            iso_code: 'ID-KT',
        },
        {
            name: 'Kalimantan Timur',
            code: 'Kalimantan Timur',
            type: 'province',
            iso_code: 'ID-KI',
        },
        {
            name: 'Kalimantan Utara',
            code: 'Kalimantan Utara',
            type: 'province',
            iso_code: 'ID-KU',
        },
        {
            name: 'Kepulauan Bangka Belitung',
            code: 'Kepulauan Bangka Belitung',
            type: 'province',
            iso_code: 'ID-BB',
        },
        {
            name: 'Kepulauan Riau',
            code: 'Kepulauan Riau',
            type: 'province',
            iso_code: 'ID-KR',
        },
        { name: 'Lampung', code: 'Lampung', type: 'province', iso_code: 'ID-LA' },
        { name: 'Maluku', code: 'Maluku', type: 'province', iso_code: 'ID-MA' },
        {
            name: 'Maluku Utara',
            code: 'Maluku Utara',
            type: 'province',
            iso_code: 'ID-MU',
        },
        {
            name: 'Nusa Tenggara Barat',
            code: 'Nusa Tenggara Barat',
            type: 'province',
            iso_code: 'ID-NB',
        },
        {
            name: 'Nusa Tenggara Timur',
            code: 'Nusa Tenggara Timur',
            type: 'province',
            iso_code: 'ID-NT',
        },
        { name: 'Papua', code: 'Papua', type: 'province', iso_code: 'ID-PA' },
        {
            name: 'Papua Barat',
            code: 'Papua Barat',
            type: 'province',
            iso_code: 'ID-PB',
        },
        { name: 'Riau', code: 'Riau', type: 'province', iso_code: 'ID-RI' },
        {
            name: 'Sulawesi Barat',
            code: 'Sulawesi Barat',
            type: 'province',
            iso_code: 'ID-SR',
        },
        {
            name: 'Sulawesi Selatan',
            code: 'Sulawesi Selatan',
            type: 'province',
            iso_code: 'ID-SN',
        },
        {
            name: 'Sulawesi Tengah',
            code: 'Sulawesi Tengah',
            type: 'province',
            iso_code: 'ID-ST',
        },
        {
            name: 'Sulawesi Tenggara',
            code: 'Sulawesi Tenggara',
            type: 'province',
            iso_code: 'ID-SG',
        },
        {
            name: 'Sulawesi Utara',
            code: 'Sulawesi Utara',
            type: 'province',
            iso_code: 'ID-SA',
        },
        {
            name: 'Sumatera Barat',
            code: 'Sumatera Barat',
            type: 'province',
            iso_code: 'ID-SB',
        },
        {
            name: 'Sumatera Selatan',
            code: 'Sumatera Selatan',
            type: 'province',
            iso_code: 'ID-SS',
        },
        {
            name: 'Sumatera Utara',
            code: 'Sumatera Utara',
            type: 'province',
            iso_code: 'ID-SU',
        },
    ],
    IE: [
        {
            name: 'Co. Carlow',
            code: 'Co. Carlow',
            type: 'county',
            iso_code: 'IE-CW',
        },
        { name: 'Co. Cavan', code: 'Co. Cavan', type: 'county', iso_code: 'IE-CN' },
        { name: 'Co. Clare', code: 'Co. Clare', type: 'county', iso_code: 'IE-CE' },
        { name: 'Co. Cork', code: 'Co. Cork', type: 'county', iso_code: 'IE-C' },
        {
            name: 'Co. Donegal',
            code: 'Co. Donegal',
            type: 'county',
            iso_code: 'IE-DL',
        },
        {
            name: 'Co. Dublin',
            code: 'Co. Dublin',
            type: 'county',
            iso_code: 'IE-D',
        },
        {
            name: 'Co. Galway',
            code: 'Co. Galway',
            type: 'county',
            iso_code: 'IE-G',
        },
        { name: 'Co. Kerry', code: 'Co. Kerry', type: 'county', iso_code: 'IE-KY' },
        {
            name: 'Co. Kildare',
            code: 'Co. Kildare',
            type: 'county',
            iso_code: 'IE-KE',
        },
        {
            name: 'Co. Kilkenny',
            code: 'Co. Kilkenny',
            type: 'county',
            iso_code: 'IE-KK',
        },
        { name: 'Co. Laois', code: 'Co. Laois', type: 'county', iso_code: 'IE-LS' },
        {
            name: 'Co. Leitrim',
            code: 'Co. Leitrim',
            type: 'county',
            iso_code: 'IE-LM',
        },
        {
            name: 'Co. Limerick',
            code: 'Co. Limerick',
            type: 'county',
            iso_code: 'IE-LK',
        },
        {
            name: 'Co. Longford',
            code: 'Co. Longford',
            type: 'county',
            iso_code: 'IE-LD',
        },
        { name: 'Co. Louth', code: 'Co. Louth', type: 'county', iso_code: 'IE-LH' },
        { name: 'Co. Mayo', code: 'Co. Mayo', type: 'county', iso_code: 'IE-MO' },
        { name: 'Co. Meath', code: 'Co. Meath', type: 'county', iso_code: 'IE-MH' },
        {
            name: 'Co. Monaghan',
            code: 'Co. Monaghan',
            type: 'county',
            iso_code: 'IE-MN',
        },
        {
            name: 'Co. Offaly',
            code: 'Co. Offaly',
            type: 'county',
            iso_code: 'IE-OY',
        },
        {
            name: 'Co. Roscommon',
            code: 'Co. Roscommon',
            type: 'county',
            iso_code: 'IE-RN',
        },
        { name: 'Co. Sligo', code: 'Co. Sligo', type: 'county', iso_code: 'IE-SO' },
        {
            name: 'Co. Tipperary',
            code: 'Co. Tipperary',
            type: 'county',
            iso_code: 'IE-TA',
        },
        {
            name: 'Co. Waterford',
            code: 'Co. Waterford',
            type: 'county',
            iso_code: 'IE-WD',
        },
        {
            name: 'Co. Westmeath',
            code: 'Co. Westmeath',
            type: 'county',
            iso_code: 'IE-WH',
        },
        {
            name: 'Co. Wexford',
            code: 'Co. Wexford',
            type: 'county',
            iso_code: 'IE-WX',
        },
        {
            name: 'Co. Wicklow',
            code: 'Co. Wicklow',
            type: 'county',
            iso_code: 'IE-WW',
        },
    ],
    IL: [],
    IM: [],
    IN: [
        {
            name: 'Andaman & Nicobar',
            code: 'Andaman and Nicobar Islands',
            type: 'state',
            iso_code: 'IN-AN',
        },
        {
            name: 'Andhra Pradesh',
            code: 'Andhra Pradesh',
            type: 'state',
            iso_code: 'IN-AP',
        },
        {
            name: 'Arunachal Pradesh',
            code: 'Arunachal Pradesh',
            type: 'state',
            iso_code: 'IN-AR',
        },
        { name: 'Assam', code: 'Assam', type: 'state', iso_code: 'IN-AS' },
        { name: 'Bihar', code: 'Bihar', type: 'state', iso_code: 'IN-BR' },
        {
            name: 'Chandigarh',
            code: 'Chandigarh',
            type: 'state',
            iso_code: 'IN-CH',
        },
        {
            name: 'Chhattisgarh',
            code: 'Chhattisgarh',
            type: 'state',
            iso_code: 'IN-CT',
        },
        {
            name: 'Dadra & Nagar Haveli',
            code: 'Dadra and Nagar Haveli',
            type: 'state',
            iso_code: 'IN-DN',
        },
        {
            name: 'Daman & Diu',
            code: 'Daman and Diu',
            type: 'state',
            iso_code: 'IN-DD',
        },
        { name: 'Delhi', code: 'Delhi', type: 'state', iso_code: 'IN-DL' },
        { name: 'Goa', code: 'Goa', type: 'state', iso_code: 'IN-GA' },
        { name: 'Gujarat', code: 'Gujarat', type: 'state', iso_code: 'IN-GJ' },
        { name: 'Haryana', code: 'Haryana', type: 'state', iso_code: 'IN-HR' },
        {
            name: 'Himachal Pradesh',
            code: 'Himachal Pradesh',
            type: 'state',
            iso_code: 'IN-HP',
        },
        {
            name: 'Jammu & Kashmir',
            code: 'Jammu and Kashmir',
            type: 'state',
            iso_code: 'IN-JK',
        },
        { name: 'Jharkhand', code: 'Jharkhand', type: 'state', iso_code: 'IN-JH' },
        { name: 'Karnataka', code: 'Karnataka', type: 'state', iso_code: 'IN-KA' },
        { name: 'Kerala', code: 'Kerala', type: 'state', iso_code: 'IN-KL' },
        {
            name: 'Lakshadweep',
            code: 'Lakshadweep',
            type: 'state',
            iso_code: 'IN-LD',
        },
        {
            name: 'Madhya Pradesh',
            code: 'Madhya Pradesh',
            type: 'state',
            iso_code: 'IN-MP',
        },
        {
            name: 'Maharashtra',
            code: 'Maharashtra',
            type: 'state',
            iso_code: 'IN-MH',
        },
        { name: 'Manipur', code: 'Manipur', type: 'state', iso_code: 'IN-MN' },
        { name: 'Meghalaya', code: 'Meghalaya', type: 'state', iso_code: 'IN-ML' },
        { name: 'Mizoram', code: 'Mizoram', type: 'state', iso_code: 'IN-MZ' },
        { name: 'Nagaland', code: 'Nagaland', type: 'state', iso_code: 'IN-NL' },
        { name: 'Odisha', code: 'Odisha', type: 'state', iso_code: 'IN-OR' },
        {
            name: 'Puducherry',
            code: 'Puducherry',
            type: 'state',
            iso_code: 'IN-PY',
        },
        { name: 'Punjab', code: 'Punjab', type: 'state', iso_code: 'IN-PB' },
        { name: 'Rajasthan', code: 'Rajasthan', type: 'state', iso_code: 'IN-RJ' },
        { name: 'Sikkim', code: 'Sikkim', type: 'state', iso_code: 'IN-SK' },
        {
            name: 'Tamil Nadu',
            code: 'Tamil Nadu',
            type: 'state',
            iso_code: 'IN-TN',
        },
        { name: 'Telangana', code: 'Telangana', type: 'state', iso_code: 'IN-TG' },
        { name: 'Tripura', code: 'Tripura', type: 'state', iso_code: 'IN-TR' },
        {
            name: 'Uttar Pradesh',
            code: 'Uttar Pradesh',
            type: 'state',
            iso_code: 'IN-UP',
        },
        {
            name: 'Uttarakhand',
            code: 'Uttarakhand',
            type: 'state',
            iso_code: 'IN-UT',
        },
        {
            name: 'West Bengal',
            code: 'West Bengal',
            type: 'state',
            iso_code: 'IN-WB',
        },
    ],
    IO: [],
    IQ: [],
    IR: [
        {
            name: 'East Azerbaijan Province',
            local_name: 'استان آذربایجان شرقی',
            code: 'East Azerbaijan Province',
            local_code: 'استان آذربایجان شرقی',
            type: 'province',
            iso_code: 'IR-01',
        },
        {
            name: 'West Azerbaijan Province',
            local_name: 'استان آذربایجان غربی',
            code: 'West Azerbaijan Province',
            local_code: 'استان آذربایجان غربی',
            type: 'province',
            iso_code: 'IR-02',
        },
        {
            name: 'Ardabil Province',
            local_name: 'استان اردبیل',
            code: 'Ardabil Province',
            local_code: 'استان اردبیل',
            type: 'province',
            iso_code: 'IR-03',
        },
        {
            name: 'Isfahan Province',
            local_name: 'استان اصفهان',
            code: 'Isfahan Province',
            local_code: 'استان اصفهان',
            type: 'province',
            iso_code: 'IR-04',
        },
        {
            name: 'Alborz Province',
            local_name: 'استان البرز',
            code: 'Alborz Province',
            local_code: 'استان البرز',
            type: 'province',
            iso_code: 'IR-32',
        },
        {
            name: 'Ilam Province',
            local_name: 'استان ایلام',
            code: 'Ilam Province',
            local_code: 'استان ایلام',
            type: 'province',
            iso_code: 'IR-05',
        },
        {
            name: 'Bushehr Province',
            local_name: 'استان بوشهر',
            code: 'Bushehr Province',
            local_code: 'استان بوشهر',
            type: 'province',
            iso_code: 'IR-06',
        },
        {
            name: 'Tehran Province',
            local_name: 'استان تهران',
            code: 'Tehran Province',
            local_code: 'استان تهران',
            type: 'province',
            iso_code: 'IR-07',
        },
        {
            name: 'Chaharmahal and Bakhtiari Province',
            local_name: 'استان چهارمحال و بختیاری',
            code: 'Chaharmahal and Bakhtiari Province',
            local_code: 'استان چهارمحال و بختیاری',
            type: 'province',
            iso_code: 'IR-08',
        },
        {
            name: 'South Khorasan Province',
            local_name: 'استان خراسان جنوبی',
            code: 'South Khorasan Province',
            local_code: 'استان خراسان جنوبی',
            type: 'province',
            iso_code: 'IR-29',
        },
        {
            name: 'Razavi Khorasan Province',
            local_name: 'استان خراسان رضوی',
            code: 'Razavi Khorasan Province',
            local_code: 'استان خراسان رضوی',
            type: 'province',
            iso_code: 'IR-30',
        },
        {
            name: 'North Khorasan Province',
            local_name: 'استان خراسان شمالی',
            code: 'North Khorasan Province',
            local_code: 'استان خراسان شمالی',
            type: 'province',
            iso_code: 'IR-31',
        },
        {
            name: 'Khuzestan Province',
            local_name: 'استان خوزستان',
            code: 'Khuzestan Province',
            local_code: 'استان خوزستان',
            type: 'province',
            iso_code: 'IR-10',
        },
        {
            name: 'Zanjan Province',
            local_name: 'استان زنجان',
            code: 'Zanjan Province',
            local_code: 'استان زنجان',
            type: 'province',
            iso_code: 'IR-11',
        },
        {
            name: 'Semnan Province',
            local_name: 'استان سمنان',
            code: 'Semnan Province',
            local_code: 'استان سمنان',
            type: 'province',
            iso_code: 'IR-12',
        },
        {
            name: 'Sistan and Baluchestan Province',
            local_name: 'استان سیستان و بلوچستان',
            code: 'Sistan and Baluchestan Province',
            local_code: 'استان سیستان و بلوچستان',
            type: 'province',
            iso_code: 'IR-13',
        },
        {
            name: 'Fars Province',
            local_name: 'استان فارس',
            code: 'Fars Province',
            local_code: 'استان فارس',
            type: 'province',
            iso_code: 'IR-14',
        },
        {
            name: 'Qazvin Province',
            local_name: 'استان قزوین',
            code: 'Qazvin Province',
            local_code: 'استان قزوین',
            type: 'province',
            iso_code: 'IR-28',
        },
        {
            name: 'Qom Province',
            local_name: 'استان قم',
            code: 'Qom Province',
            local_code: 'استان قم',
            type: 'province',
            iso_code: 'IR-26',
        },
        {
            name: 'Kurdistan Province',
            local_name: 'استان کردستان',
            code: 'Kurdistan Province',
            local_code: 'استان کردستان',
            type: 'province',
            iso_code: 'IR-16',
        },
        {
            name: 'Kerman Province',
            local_name: 'استان کرمان',
            code: 'Kerman Province',
            local_code: 'استان کرمان',
            type: 'province',
            iso_code: 'IR-15',
        },
        {
            name: 'Kermanshah Province',
            local_name: 'استان کرمانشاه',
            code: 'Kermanshah Province',
            local_code: 'استان کرمانشاه',
            type: 'province',
            iso_code: 'IR-17',
        },
        {
            name: 'Kohgiluyeh and Boyer-Ahmad Province',
            local_name: 'استان کهگیلویه و بویراحمد',
            code: 'Kohgiluyeh and Boyer-Ahmad Province',
            local_code: 'استان کهگیلویه و بویراحمد',
            type: 'province',
            iso_code: 'IR-18',
        },
        {
            name: 'Golestan Province',
            local_name: 'استان گلستان',
            code: 'Golestan Province',
            local_code: 'استان گلستان',
            type: 'province',
            iso_code: 'IR-27',
        },
        {
            name: 'Gilan Province',
            local_name: 'استان گیلان',
            code: 'Gilan Province',
            local_code: 'استان گیلان',
            type: 'province',
            iso_code: 'IR-19',
        },
        {
            name: 'Lorestan Province',
            local_name: 'استان لرستان',
            code: 'Lorestan Province',
            local_code: 'استان لرستان',
            type: 'province',
            iso_code: 'IR-20',
        },
        {
            name: 'Mazandaran Province',
            local_name: 'استان مازندران',
            code: 'Mazandaran Province',
            local_code: 'استان مازندران',
            type: 'province',
            iso_code: 'IR-21',
        },
        {
            name: 'Markazi Province',
            local_name: 'استان مرکزی',
            code: 'Markazi Province',
            local_code: 'استان مرکزی',
            type: 'province',
            iso_code: 'IR-22',
        },
        {
            name: 'Hormozgan Province',
            local_name: 'استان هرمزگان',
            code: 'Hormozgan Province',
            local_code: 'استان هرمزگان',
            type: 'province',
            iso_code: 'IR-23',
        },
        {
            name: 'Hamadan Province',
            local_name: 'استان همدان',
            code: 'Hamadan Province',
            local_code: 'استان همدان',
            type: 'province',
            iso_code: 'IR-24',
        },
        {
            name: 'Yazd Province',
            local_name: 'استان یزد',
            code: 'Yazd Province',
            local_code: 'استان یزد',
            type: 'province',
            iso_code: 'IR-25',
        },
    ],
    IS: [],
    IT: [
        { name: 'Agrigento', code: 'AG', type: 'province', iso_code: 'IT-AG' },
        { name: 'Alessandria', code: 'AL', type: 'province', iso_code: 'IT-AL' },
        { name: 'Ancona', code: 'AN', type: 'province', iso_code: 'IT-AN' },
        { name: 'Aosta', code: 'AO', type: 'province', iso_code: 'IT-AO' },
        { name: 'Arezzo', code: 'AR', type: 'province', iso_code: 'IT-AR' },
        { name: 'Ascoli Piceno', code: 'AP', type: 'province', iso_code: 'IT-AP' },
        { name: 'Asti', code: 'AT', type: 'province', iso_code: 'IT-AT' },
        { name: 'Avellino', code: 'AV', type: 'province', iso_code: 'IT-AV' },
        { name: 'Bari', code: 'BA', type: 'province', iso_code: 'IT-BA' },
        {
            name: 'Barletta-Andria-Trani',
            code: 'BT',
            type: 'province',
            iso_code: 'IT-BT',
        },
        { name: 'Belluno', code: 'BL', type: 'province', iso_code: 'IT-BL' },
        { name: 'Benevento', code: 'BN', type: 'province', iso_code: 'IT-BN' },
        { name: 'Bergamo', code: 'BG', type: 'province', iso_code: 'IT-BG' },
        { name: 'Biella', code: 'BI', type: 'province', iso_code: 'IT-BI' },
        { name: 'Bologna', code: 'BO', type: 'province', iso_code: 'IT-BO' },
        { name: 'Bolzano', code: 'BZ', type: 'province', iso_code: 'IT-BZ' },
        { name: 'Brescia', code: 'BS', type: 'province', iso_code: 'IT-BS' },
        { name: 'Brindisi', code: 'BR', type: 'province', iso_code: 'IT-BR' },
        { name: 'Cagliari', code: 'CA', type: 'province', iso_code: 'IT-CA' },
        { name: 'Caltanissetta', code: 'CL', type: 'province', iso_code: 'IT-CL' },
        { name: 'Campobasso', code: 'CB', type: 'province', iso_code: 'IT-CB' },
        {
            name: 'Carbonia-Iglesias',
            code: 'CI',
            type: 'province',
            iso_code: 'IT-CI',
        },
        { name: 'Caserta', code: 'CE', type: 'province', iso_code: 'IT-CE' },
        { name: 'Catania', code: 'CT', type: 'province', iso_code: 'IT-CT' },
        { name: 'Catanzaro', code: 'CZ', type: 'province', iso_code: 'IT-CZ' },
        { name: 'Chieti', code: 'CH', type: 'province', iso_code: 'IT-CH' },
        { name: 'Como', code: 'CO', type: 'province', iso_code: 'IT-CO' },
        { name: 'Cosenza', code: 'CS', type: 'province', iso_code: 'IT-CS' },
        { name: 'Cremona', code: 'CR', type: 'province', iso_code: 'IT-CR' },
        { name: 'Crotone', code: 'KR', type: 'province', iso_code: 'IT-KR' },
        { name: 'Cuneo', code: 'CN', type: 'province', iso_code: 'IT-CN' },
        { name: 'Enna', code: 'EN', type: 'province', iso_code: 'IT-EN' },
        { name: 'Fermo', code: 'FM', type: 'province', iso_code: 'IT-FM' },
        { name: 'Ferrara', code: 'FE', type: 'province', iso_code: 'IT-FE' },
        { name: 'Firenze', code: 'FI', type: 'province', iso_code: 'IT-FI' },
        { name: 'Foggia', code: 'FG', type: 'province', iso_code: 'IT-FG' },
        { name: 'Forlì-Cesena', code: 'FC', type: 'province', iso_code: 'IT-FC' },
        { name: 'Frosinone', code: 'FR', type: 'province', iso_code: 'IT-FR' },
        { name: 'Genova', code: 'GE', type: 'province', iso_code: 'IT-GE' },
        { name: 'Gorizia', code: 'GO', type: 'province', iso_code: 'IT-GO' },
        { name: 'Grosseto', code: 'GR', type: 'province', iso_code: 'IT-GR' },
        { name: 'Imperia', code: 'IM', type: 'province', iso_code: 'IT-IM' },
        { name: 'Isernia', code: 'IS', type: 'province', iso_code: 'IT-IS' },
        { name: "L'Aquila", code: 'AQ', type: 'province', iso_code: 'IT-AQ' },
        { name: 'La Spezia', code: 'SP', type: 'province', iso_code: 'IT-SP' },
        { name: 'Latina', code: 'LT', type: 'province', iso_code: 'IT-LT' },
        { name: 'Lecce', code: 'LE', type: 'province', iso_code: 'IT-LE' },
        { name: 'Lecco', code: 'LC', type: 'province', iso_code: 'IT-LC' },
        { name: 'Livorno', code: 'LI', type: 'province', iso_code: 'IT-LI' },
        { name: 'Lodi', code: 'LO', type: 'province', iso_code: 'IT-LO' },
        { name: 'Lucca', code: 'LU', type: 'province', iso_code: 'IT-LU' },
        { name: 'Macerata', code: 'MC', type: 'province', iso_code: 'IT-MC' },
        { name: 'Mantova', code: 'MN', type: 'province', iso_code: 'IT-MN' },
        { name: 'Massa-Carrara', code: 'MS', type: 'province', iso_code: 'IT-MS' },
        { name: 'Matera', code: 'MT', type: 'province', iso_code: 'IT-MT' },
        {
            name: 'Medio Campidano',
            code: 'VS',
            type: 'province',
            iso_code: 'IT-VS',
        },
        { name: 'Messina', code: 'ME', type: 'province', iso_code: 'IT-ME' },
        { name: 'Milano', code: 'MI', type: 'province', iso_code: 'IT-MI' },
        { name: 'Modena', code: 'MO', type: 'province', iso_code: 'IT-MO' },
        {
            name: 'Monza e Brianza',
            code: 'MB',
            type: 'province',
            iso_code: 'IT-MB',
        },
        { name: 'Napoli', code: 'NA', type: 'province', iso_code: 'IT-NA' },
        { name: 'Novara', code: 'NO', type: 'province', iso_code: 'IT-NO' },
        { name: 'Nuoro', code: 'NU', type: 'province', iso_code: 'IT-NU' },
        { name: 'Ogliastra', code: 'OG', type: 'province', iso_code: 'IT-OG' },
        { name: 'Olbia-Tempio', code: 'OT', type: 'province', iso_code: 'IT-OT' },
        { name: 'Oristano', code: 'OR', type: 'province', iso_code: 'IT-OR' },
        { name: 'Padova', code: 'PD', type: 'province', iso_code: 'IT-PD' },
        { name: 'Palermo', code: 'PA', type: 'province', iso_code: 'IT-PA' },
        { name: 'Parma', code: 'PR', type: 'province', iso_code: 'IT-PR' },
        { name: 'Pavia', code: 'PV', type: 'province', iso_code: 'IT-PV' },
        { name: 'Perugia', code: 'PG', type: 'province', iso_code: 'IT-PG' },
        {
            name: 'Pesaro e Urbino',
            code: 'PU',
            type: 'province',
            iso_code: 'IT-PU',
        },
        { name: 'Pescara', code: 'PE', type: 'province', iso_code: 'IT-PE' },
        { name: 'Piacenza', code: 'PC', type: 'province', iso_code: 'IT-PC' },
        { name: 'Pisa', code: 'PI', type: 'province', iso_code: 'IT-PI' },
        { name: 'Pistoia', code: 'PT', type: 'province', iso_code: 'IT-PT' },
        { name: 'Pordenone', code: 'PN', type: 'province', iso_code: 'IT-PN' },
        { name: 'Potenza', code: 'PZ', type: 'province', iso_code: 'IT-PZ' },
        { name: 'Prato', code: 'PO', type: 'province', iso_code: 'IT-PO' },
        { name: 'Ragusa', code: 'RG', type: 'province', iso_code: 'IT-RG' },
        { name: 'Ravenna', code: 'RA', type: 'province', iso_code: 'IT-RA' },
        {
            name: 'Reggio Calabria',
            code: 'RC',
            type: 'province',
            iso_code: 'IT-RC',
        },
        { name: 'Reggio Emilia', code: 'RE', type: 'province', iso_code: 'IT-RE' },
        { name: 'Rieti', code: 'RI', type: 'province', iso_code: 'IT-RI' },
        { name: 'Rimini', code: 'RN', type: 'province', iso_code: 'IT-RN' },
        { name: 'Roma', code: 'RM', type: 'province', iso_code: 'IT-RM' },
        { name: 'Rovigo', code: 'RO', type: 'province', iso_code: 'IT-RO' },
        { name: 'Salerno', code: 'SA', type: 'province', iso_code: 'IT-SA' },
        { name: 'Sassari', code: 'SS', type: 'province', iso_code: 'IT-SS' },
        { name: 'Savona', code: 'SV', type: 'province', iso_code: 'IT-SV' },
        { name: 'Siena', code: 'SI', type: 'province', iso_code: 'IT-SI' },
        { name: 'Siracusa', code: 'SR', type: 'province', iso_code: 'IT-SR' },
        { name: 'Sondrio', code: 'SO', type: 'province', iso_code: 'IT-SO' },
        { name: 'Taranto', code: 'TA', type: 'province', iso_code: 'IT-TA' },
        { name: 'Teramo', code: 'TE', type: 'province', iso_code: 'IT-TE' },
        { name: 'Terni', code: 'TR', type: 'province', iso_code: 'IT-TR' },
        { name: 'Torino', code: 'TO', type: 'province', iso_code: 'IT-TO' },
        { name: 'Trapani', code: 'TP', type: 'province', iso_code: 'IT-TP' },
        { name: 'Trento', code: 'TN', type: 'province', iso_code: 'IT-TN' },
        { name: 'Treviso', code: 'TV', type: 'province', iso_code: 'IT-TV' },
        { name: 'Trieste', code: 'TS', type: 'province', iso_code: 'IT-TS' },
        { name: 'Udine', code: 'UD', type: 'province', iso_code: 'IT-UD' },
        { name: 'Varese', code: 'VA', type: 'province', iso_code: 'IT-VA' },
        { name: 'Venezia', code: 'VE', type: 'province', iso_code: 'IT-VE' },
        {
            name: 'Verbano-Cusio-Ossola',
            code: 'VB',
            type: 'province',
            iso_code: 'IT-VB',
        },
        { name: 'Vercelli', code: 'VC', type: 'province', iso_code: 'IT-VC' },
        { name: 'Verona', code: 'VR', type: 'province', iso_code: 'IT-VR' },
        { name: 'Vibo Valentia', code: 'VV', type: 'province', iso_code: 'IT-VV' },
        { name: 'Vicenza', code: 'VI', type: 'province', iso_code: 'IT-VI' },
        { name: 'Viterbo', code: 'VT', type: 'province', iso_code: 'IT-VT' },
    ],
    JE: [],
    JM: [
        { name: 'Clarendon', code: 'Clarendon', type: 'parish', iso_code: 'JM-13' },
        { name: 'Hanover', code: 'Hanover', type: 'parish', iso_code: 'JM-09' },
        { name: 'Kingston', code: 'Kingston', type: 'parish', iso_code: 'JM-01' },
        {
            name: 'Manchester',
            code: 'Manchester',
            type: 'parish',
            iso_code: 'JM-12',
        },
        { name: 'Portland', code: 'Portland', type: 'parish', iso_code: 'JM-04' },
        {
            name: 'St. Andrew',
            code: 'St. Andrew',
            type: 'parish',
            iso_code: 'JM-02',
        },
        { name: 'St. Ann', code: 'St. Ann', type: 'parish', iso_code: 'JM-06' },
        {
            name: 'St. Catherine',
            code: 'St. Catherine',
            type: 'parish',
            iso_code: 'JM-14',
        },
        {
            name: 'St. Elizabeth',
            code: 'St. Elizabeth',
            type: 'parish',
            iso_code: 'JM-11',
        },
        { name: 'St. James', code: 'St. James', type: 'parish', iso_code: 'JM-08' },
        { name: 'St. Mary', code: 'St. Mary', type: 'parish', iso_code: 'JM-05' },
        {
            name: 'St. Thomas',
            code: 'St. Thomas',
            type: 'parish',
            iso_code: 'JM-03',
        },
        { name: 'Trelawny', code: 'Trelawny', type: 'parish', iso_code: 'JM-07' },
        {
            name: 'Westmoreland',
            code: 'Westmoreland',
            type: 'parish',
            iso_code: 'JM-10',
        },
    ],
    JO: [],
    JP: [
        {
            name: 'Hokkaido',
            local_name: '北海道',
            code: 'Hokkaido',
            local_code: '北海道',
            type: 'prefecture',
            iso_code: 'JP-01',
        },
        {
            name: 'Aomori',
            local_name: '青森県',
            code: 'Aomori',
            local_code: '青森県',
            type: 'prefecture',
            iso_code: 'JP-02',
        },
        {
            name: 'Iwate',
            local_name: '岩手県',
            code: 'Iwate',
            local_code: '岩手県',
            type: 'prefecture',
            iso_code: 'JP-03',
        },
        {
            name: 'Miyagi',
            local_name: '宮城県',
            code: 'Miyagi',
            local_code: '宮城県',
            type: 'prefecture',
            iso_code: 'JP-04',
        },
        {
            name: 'Akita',
            local_name: '秋田県',
            code: 'Akita',
            local_code: '秋田県',
            type: 'prefecture',
            iso_code: 'JP-05',
        },
        {
            name: 'Yamagata',
            local_name: '山形県',
            code: 'Yamagata',
            local_code: '山形県',
            type: 'prefecture',
            iso_code: 'JP-06',
        },
        {
            name: 'Fukushima',
            local_name: '福島県',
            code: 'Fukushima',
            local_code: '福島県',
            type: 'prefecture',
            iso_code: 'JP-07',
        },
        {
            name: 'Ibaraki',
            local_name: '茨城県',
            code: 'Ibaraki',
            local_code: '茨城県',
            type: 'prefecture',
            iso_code: 'JP-08',
        },
        {
            name: 'Tochigi',
            local_name: '栃木県',
            code: 'Tochigi',
            local_code: '栃木県',
            type: 'prefecture',
            iso_code: 'JP-09',
        },
        {
            name: 'Gunma',
            local_name: '群馬県',
            code: 'Gunma',
            local_code: '群馬県',
            type: 'prefecture',
            iso_code: 'JP-10',
        },
        {
            name: 'Saitama',
            local_name: '埼玉県',
            code: 'Saitama',
            local_code: '埼玉県',
            type: 'prefecture',
            iso_code: 'JP-11',
        },
        {
            name: 'Chiba',
            local_name: '千葉県',
            code: 'Chiba',
            local_code: '千葉県',
            type: 'prefecture',
            iso_code: 'JP-12',
        },
        {
            name: 'Tokyo',
            local_name: '東京都',
            code: 'Tokyo',
            local_code: '東京都',
            type: 'prefecture',
            iso_code: 'JP-13',
        },
        {
            name: 'Kanagawa',
            local_name: '神奈川県',
            code: 'Kanagawa',
            local_code: '神奈川県',
            type: 'prefecture',
            iso_code: 'JP-14',
        },
        {
            name: 'Niigata',
            local_name: '新潟県',
            code: 'Niigata',
            local_code: '新潟県',
            type: 'prefecture',
            iso_code: 'JP-15',
        },
        {
            name: 'Toyama',
            local_name: '富山県',
            code: 'Toyama',
            local_code: '富山県',
            type: 'prefecture',
            iso_code: 'JP-16',
        },
        {
            name: 'Ishikawa',
            local_name: '石川県',
            code: 'Ishikawa',
            local_code: '石川県',
            type: 'prefecture',
            iso_code: 'JP-17',
        },
        {
            name: 'Fukui',
            local_name: '福井県',
            code: 'Fukui',
            local_code: '福井県',
            type: 'prefecture',
            iso_code: 'JP-18',
        },
        {
            name: 'Yamanashi',
            local_name: '山梨県',
            code: 'Yamanashi',
            local_code: '山梨県',
            type: 'prefecture',
            iso_code: 'JP-19',
        },
        {
            name: 'Nagano',
            local_name: '長野県',
            code: 'Nagano',
            local_code: '長野県',
            type: 'prefecture',
            iso_code: 'JP-20',
        },
        {
            name: 'Gifu',
            local_name: '岐阜県',
            code: 'Gifu',
            local_code: '岐阜県',
            type: 'prefecture',
            iso_code: 'JP-21',
        },
        {
            name: 'Shizuoka',
            local_name: '静岡県',
            code: 'Shizuoka',
            local_code: '静岡県',
            type: 'prefecture',
            iso_code: 'JP-22',
        },
        {
            name: 'Aichi',
            local_name: '愛知県',
            code: 'Aichi',
            local_code: '愛知県',
            type: 'prefecture',
            iso_code: 'JP-23',
        },
        {
            name: 'Mie',
            local_name: '三重県',
            code: 'Mie',
            local_code: '三重県',
            type: 'prefecture',
            iso_code: 'JP-24',
        },
        {
            name: 'Shiga',
            local_name: '滋賀県',
            code: 'Shiga',
            local_code: '滋賀県',
            type: 'prefecture',
            iso_code: 'JP-25',
        },
        {
            name: 'Kyoto',
            local_name: '京都府',
            code: 'Kyoto',
            local_code: '京都府',
            type: 'prefecture',
            iso_code: 'JP-26',
        },
        {
            name: 'Osaka',
            local_name: '大阪府',
            code: 'Osaka',
            local_code: '大阪府',
            type: 'prefecture',
            iso_code: 'JP-27',
        },
        {
            name: 'Hyogo',
            local_name: '兵庫県',
            code: 'Hyogo',
            local_code: '兵庫県',
            type: 'prefecture',
            iso_code: 'JP-28',
        },
        {
            name: 'Nara',
            local_name: '奈良県',
            code: 'Nara',
            local_code: '奈良県',
            type: 'prefecture',
            iso_code: 'JP-29',
        },
        {
            name: 'Wakayama',
            local_name: '和歌山県',
            code: 'Wakayama',
            local_code: '和歌山県',
            type: 'prefecture',
            iso_code: 'JP-30',
        },
        {
            name: 'Tottori',
            local_name: '鳥取県',
            code: 'Tottori',
            local_code: '鳥取県',
            type: 'prefecture',
            iso_code: 'JP-31',
        },
        {
            name: 'Shimane',
            local_name: '島根県',
            code: 'Shimane',
            local_code: '島根県',
            type: 'prefecture',
            iso_code: 'JP-32',
        },
        {
            name: 'Okayama',
            local_name: '岡山県',
            code: 'Okayama',
            local_code: '岡山県',
            type: 'prefecture',
            iso_code: 'JP-33',
        },
        {
            name: 'Hiroshima',
            local_name: '広島県',
            code: 'Hiroshima',
            local_code: '広島県',
            type: 'prefecture',
            iso_code: 'JP-34',
        },
        {
            name: 'Yamaguchi',
            local_name: '山口県',
            code: 'Yamaguchi',
            local_code: '山口県',
            type: 'prefecture',
            iso_code: 'JP-35',
        },
        {
            name: 'Tokushima',
            local_name: '徳島県',
            code: 'Tokushima',
            local_code: '徳島県',
            type: 'prefecture',
            iso_code: 'JP-36',
        },
        {
            name: 'Kagawa',
            local_name: '香川県',
            code: 'Kagawa',
            local_code: '香川県',
            type: 'prefecture',
            iso_code: 'JP-37',
        },
        {
            name: 'Ehime',
            local_name: '愛媛県',
            code: 'Ehime',
            local_code: '愛媛県',
            type: 'prefecture',
            iso_code: 'JP-38',
        },
        {
            name: 'Kochi',
            local_name: '高知県',
            code: 'Kochi',
            local_code: '高知県',
            type: 'prefecture',
            iso_code: 'JP-39',
        },
        {
            name: 'Fukuoka',
            local_name: '福岡県',
            code: 'Fukuoka',
            local_code: '福岡県',
            type: 'prefecture',
            iso_code: 'JP-40',
        },
        {
            name: 'Saga',
            local_name: '佐賀県',
            code: 'Saga',
            local_code: '佐賀県',
            type: 'prefecture',
            iso_code: 'JP-41',
        },
        {
            name: 'Nagasaki',
            local_name: '長崎県',
            code: 'Nagasaki',
            local_code: '長崎県',
            type: 'prefecture',
            iso_code: 'JP-42',
        },
        {
            name: 'Kumamoto',
            local_name: '熊本県',
            code: 'Kumamoto',
            local_code: '熊本県',
            type: 'prefecture',
            iso_code: 'JP-43',
        },
        {
            name: 'Oita',
            local_name: '大分県',
            code: 'Oita',
            local_code: '大分県',
            type: 'prefecture',
            iso_code: 'JP-44',
        },
        {
            name: 'Miyazaki',
            local_name: '宮崎県',
            code: 'Miyazaki',
            local_code: '宮崎県',
            type: 'prefecture',
            iso_code: 'JP-45',
        },
        {
            name: 'Kagoshima',
            local_name: '鹿児島県',
            code: 'Kagoshima',
            local_code: '鹿児島県',
            type: 'prefecture',
            iso_code: 'JP-46',
        },
        {
            name: 'Okinawa',
            local_name: '沖縄県',
            code: 'Okinawa',
            local_code: '沖縄県',
            type: 'prefecture',
            iso_code: 'JP-47',
        },
    ],
    KE: [],
    KG: [],
    KH: [],
    KI: [],
    KM: [],
    KN: [
        { name: 'Nevis', code: 'Nevis', type: 'island', iso_code: 'KN-N' },
        { name: 'St. Kitts', code: 'St. Kitts', type: 'island', iso_code: 'KN-K' },
    ],
    KP: [
        {
            name: 'Kangwon',
            local_name: '강원도',
            code: 'Kangwon',
            local_code: '강원도',
            type: 'province',
            iso_code: 'KP-07',
        },
        {
            name: 'Rason',
            local_name: '라선 특별시',
            code: 'Rason',
            local_code: '라선 특별시',
            type: 'province',
            iso_code: 'KP-13',
        },
        {
            name: 'Ryanggang',
            local_name: '량강도',
            code: 'Ryanggang',
            local_code: '량강도',
            type: 'province',
            iso_code: 'KP-10',
        },
        {
            name: 'Chagang',
            local_name: '자강도',
            code: 'Chagang',
            local_code: '자강도',
            type: 'province',
            iso_code: 'KP-04',
        },
        {
            name: 'South Pyongan',
            local_name: '평안 남도',
            code: 'South Pyongan',
            local_code: '평안 남도',
            type: 'province',
            iso_code: 'KP-02',
        },
        {
            name: 'North Pyongan',
            local_name: '평안 북도',
            code: 'North Pyongan',
            local_code: '평안 북도',
            type: 'province',
            iso_code: 'KP-03',
        },
        {
            name: 'Pyongyang',
            local_name: '평양 직할시',
            code: 'Pyongyang',
            local_code: '평양 직할시',
            type: 'province',
            iso_code: 'KP-01',
        },
        {
            name: 'South Hamgyong',
            local_name: '함경 남도',
            code: 'South Hamgyong',
            local_code: '함경 남도',
            type: 'province',
            iso_code: 'KP-08',
        },
        {
            name: 'North Hamgyong',
            local_name: '함경 북도',
            code: 'North Hamgyong',
            local_code: '함경 북도',
            type: 'province',
            iso_code: 'KP-09',
        },
        {
            name: 'South Hwanghae',
            local_name: '황해남도',
            code: 'South Hwanghae',
            local_code: '황해남도',
            type: 'province',
            iso_code: 'KP-05',
        },
        {
            name: 'North Hwanghae',
            local_name: '황해북도',
            code: 'North Hwanghae',
            local_code: '황해북도',
            type: 'province',
            iso_code: 'KP-06',
        },
    ],
    KR: [
        {
            name: 'Gangwon-do',
            local_name: '강원',
            code: 'Gangwon-do',
            local_code: '강원도',
            type: 'do_si',
            iso_code: 'KR-42',
        },
        {
            name: 'Gyeonggi-do',
            local_name: '경기',
            code: 'Gyeonggi-do',
            local_code: '경기도',
            type: 'do_si',
            iso_code: 'KR-41',
        },
        {
            name: 'Gyeongsangnam-do',
            local_name: '경남',
            code: 'Gyeongsangnam-do',
            local_code: '경상남도',
            type: 'do_si',
            iso_code: 'KR-48',
        },
        {
            name: 'Gyeongsangbuk-do',
            local_name: '경북',
            code: 'Gyeongsangbuk-do',
            local_code: '경상북도',
            type: 'do_si',
            iso_code: 'KR-47',
        },
        {
            name: 'Gwangju',
            local_name: '광주',
            code: 'Gwangju',
            local_code: '광주광역시',
            type: 'do_si',
            iso_code: 'KR-29',
        },
        {
            name: 'Daegu',
            local_name: '대구',
            code: 'Daegu',
            local_code: '대구광역시',
            type: 'do_si',
            iso_code: 'KR-27',
        },
        {
            name: 'Daejeon',
            local_name: '대전',
            code: 'Daejeon',
            local_code: '대전광역시',
            type: 'do_si',
            iso_code: 'KR-30',
        },
        {
            name: 'Busan',
            local_name: '부산',
            code: 'Busan',
            local_code: '부산광역시',
            type: 'do_si',
            iso_code: 'KR-26',
        },
        {
            name: 'Seoul',
            local_name: '서울',
            code: 'Seoul',
            local_code: '서울특별시',
            type: 'do_si',
            iso_code: 'KR-11',
        },
        {
            name: 'Sejong',
            local_name: '세종',
            code: 'Sejong',
            local_code: '세종특별자치시',
            type: 'do_si',
            iso_code: 'KR-50',
        },
        {
            name: 'Ulsan',
            local_name: '울산',
            code: 'Ulsan',
            local_code: '울산광역시',
            type: 'do_si',
            iso_code: 'KR-31',
        },
        {
            name: 'Incheon',
            local_name: '인천',
            code: 'Incheon',
            local_code: '인천광역시',
            type: 'do_si',
            iso_code: 'KR-28',
        },
        {
            name: 'Jeollanam-do',
            local_name: '전남',
            code: 'Jeollanam-do',
            local_code: '전라남도',
            type: 'do_si',
            iso_code: 'KR-46',
        },
        {
            name: 'Jeollabuk-do',
            local_name: '전북',
            code: 'Jeollabuk-do',
            local_code: '전라북도',
            type: 'do_si',
            iso_code: 'KR-45',
        },
        {
            name: 'Jeju-do',
            local_name: '제주',
            code: 'Jeju-do',
            local_code: '제주특별자치도',
            type: 'do_si',
            iso_code: 'KR-49',
        },
        {
            name: 'Chungcheongnam-do',
            local_name: '충남',
            code: 'Chungcheongnam-do',
            local_code: '충청남도',
            type: 'do_si',
            iso_code: 'KR-44',
        },
        {
            name: 'Chungcheongbuk-do',
            local_name: '충북',
            code: 'Chungcheongbuk-do',
            local_code: '충청북도',
            type: 'do_si',
            iso_code: 'KR-43',
        },
    ],
    KW: [],
    KY: [
        { name: 'Cayman Brac', code: 'Cayman Brac', type: 'island' },
        { name: 'Grand Cayman', code: 'Grand Cayman', type: 'island' },
        { name: 'Little Cayman', code: 'Little Cayman', type: 'island' },
    ],
    KZ: [],
    LA: [],
    LB: [],
    LC: [],
    LI: [],
    LK: [],
    LR: [],
    LS: [],
    LT: [],
    LU: [],
    LV: [],
    LY: [],
    MA: [],
    MC: [],
    MD: [],
    ME: [],
    MF: [],
    MG: [],
    MH: [],
    MK: [],
    ML: [],
    MM: [],
    MN: [],
    MO: [],
    MP: [],
    MQ: [],
    MR: [],
    MS: [],
    MT: [],
    MU: [],
    MV: [],
    MW: [],
    MX: [
        { name: 'Aguascalientes', code: 'Ags.', type: 'state', iso_code: 'MX-AGU' },
        {
            name: 'Baja California',
            code: 'B.C.',
            type: 'state',
            iso_code: 'MX-BCN',
        },
        {
            name: 'Baja California Sur',
            code: 'B.C.S.',
            type: 'state',
            iso_code: 'MX-BCS',
        },
        { name: 'Campeche', code: 'Camp.', type: 'state', iso_code: 'MX-CAM' },
        { name: 'Chiapas', code: 'Chis.', type: 'state', iso_code: 'MX-CHP' },
        { name: 'Chihuahua', code: 'Chih.', type: 'state', iso_code: 'MX-CHH' },
        {
            name: 'Ciudad de México',
            code: 'CDMX',
            type: 'state',
            iso_code: 'MX-CMX',
        },
        {
            name: 'Coahuila de Zaragoza',
            code: 'Coah.',
            type: 'state',
            iso_code: 'MX-COA',
        },
        { name: 'Colima', code: 'Col.', type: 'state', iso_code: 'MX-COL' },
        { name: 'Durango', code: 'Dgo.', type: 'state', iso_code: 'MX-DUR' },
        {
            name: 'Estado de México',
            code: 'Méx.',
            type: 'state',
            iso_code: 'MX-MEX',
        },
        { name: 'Guanajuato', code: 'Gto.', type: 'state', iso_code: 'MX-GUA' },
        { name: 'Guerrero', code: 'Gro.', type: 'state', iso_code: 'MX-GRO' },
        { name: 'Hidalgo', code: 'Hgo.', type: 'state', iso_code: 'MX-HID' },
        { name: 'Jalisco', code: 'Jal.', type: 'state', iso_code: 'MX-JAL' },
        { name: 'Michoacán', code: 'Mich.', type: 'state', iso_code: 'MX-MIC' },
        { name: 'Morelos', code: 'Mor.', type: 'state', iso_code: 'MX-MOR' },
        { name: 'Nayarit', code: 'Nay.', type: 'state', iso_code: 'MX-NAY' },
        { name: 'Nuevo León', code: 'N.L.', type: 'state', iso_code: 'MX-NLE' },
        { name: 'Oaxaca', code: 'Oax.', type: 'state', iso_code: 'MX-OAX' },
        { name: 'Puebla', code: 'Pue.', type: 'state', iso_code: 'MX-PUE' },
        { name: 'Querétaro', code: 'Qro.', type: 'state', iso_code: 'MX-QUE' },
        { name: 'Quintana Roo', code: 'Q.R.', type: 'state', iso_code: 'MX-ROO' },
        {
            name: 'San Luis Potosí',
            code: 'S.L.P.',
            type: 'state',
            iso_code: 'MX-SLP',
        },
        { name: 'Sinaloa', code: 'Sin.', type: 'state', iso_code: 'MX-SIN' },
        { name: 'Sonora', code: 'Son.', type: 'state', iso_code: 'MX-SON' },
        { name: 'Tabasco', code: 'Tab.', type: 'state', iso_code: 'MX-TAB' },
        { name: 'Tamaulipas', code: 'Tamps.', type: 'state', iso_code: 'MX-TAM' },
        { name: 'Tlaxcala', code: 'Tlax.', type: 'state', iso_code: 'MX-TLA' },
        { name: 'Veracruz', code: 'Ver.', type: 'state', iso_code: 'MX-VER' },
        { name: 'Yucatán', code: 'Yuc.', type: 'state', iso_code: 'MX-YUC' },
        { name: 'Zacatecas', code: 'Zac.', type: 'state', iso_code: 'MX-ZAC' },
    ],
    MY: [
        { name: 'Johor', code: 'Johor', type: 'state', iso_code: 'MY-01' },
        { name: 'Kedah', code: 'Kedah', type: 'state', iso_code: 'MY-02' },
        { name: 'Kelantan', code: 'Kelantan', type: 'state', iso_code: 'MY-03' },
        {
            name: 'Kuala Lumpur',
            code: 'Kuala Lumpur',
            type: 'state',
            iso_code: 'MY-14',
        },
        { name: 'Labuan', code: 'Labuan', type: 'state', iso_code: 'MY-15' },
        { name: 'Melaka', code: 'Melaka', type: 'state', iso_code: 'MY-04' },
        {
            name: 'Negeri Sembilan',
            code: 'Negeri Sembilan',
            type: 'state',
            iso_code: 'MY-05',
        },
        { name: 'Pahang', code: 'Pahang', type: 'state', iso_code: 'MY-06' },
        { name: 'Perak', code: 'Perak', type: 'state', iso_code: 'MY-08' },
        { name: 'Perlis', code: 'Perlis', type: 'state', iso_code: 'MY-09' },
        {
            name: 'Pulau Pinang',
            code: 'Pulau Pinang',
            type: 'state',
            iso_code: 'MY-07',
        },
        { name: 'Putrajaya', code: 'Putrajaya', type: 'state', iso_code: 'MY-16' },
        { name: 'Sabah', code: 'Sabah', type: 'state', iso_code: 'MY-12' },
        { name: 'Sarawak', code: 'Sarawak', type: 'state', iso_code: 'MY-13' },
        { name: 'Selangor', code: 'Selangor', type: 'state', iso_code: 'MY-10' },
        {
            name: 'Terengganu',
            code: 'Terengganu',
            type: 'state',
            iso_code: 'MY-11',
        },
    ],
    MZ: [
        {
            name: 'Cabo Delgado',
            code: 'Cabo Delgado',
            type: 'province',
            iso_code: 'MZ-P',
        },
        {
            name: 'Cidade de Maputo',
            code: 'Cidade de Maputo',
            type: 'province',
            iso_code: 'MZ-MPM',
        },
        { name: 'Gaza', code: 'Gaza', type: 'province', iso_code: 'MZ-G' },
        {
            name: 'Inhambane',
            code: 'Inhambane',
            type: 'province',
            iso_code: 'MZ-I',
        },
        { name: 'Manica', code: 'Manica', type: 'province', iso_code: 'MZ-B' },
        { name: 'Maputo', code: 'Maputo', type: 'province', iso_code: 'MZ-L' },
        { name: 'Nampula', code: 'Nampula', type: 'province', iso_code: 'MZ-N' },
        { name: 'Niassa', code: 'Niassa', type: 'province', iso_code: 'MZ-A' },
        { name: 'Sofala', code: 'Sofala', type: 'province', iso_code: 'MZ-S' },
        { name: 'Tete', code: 'Tete', type: 'province', iso_code: 'MZ-T' },
        { name: 'Zambezia', code: 'Zambezia', type: 'province', iso_code: 'MZ-Q' },
    ],
    NA: [],
    NC: [],
    NE: [],
    NF: [],
    NG: [
        { name: 'Abia', code: 'Abia', type: 'state', iso_code: 'NG-AB' },
        { name: 'Adamawa', code: 'Adamawa', type: 'state', iso_code: 'NG-AD' },
        { name: 'Akwa Ibom', code: 'Akwa Ibom', type: 'state', iso_code: 'NG-AK' },
        { name: 'Anambra', code: 'Anambra', type: 'state', iso_code: 'NG-AN' },
        { name: 'Bauchi', code: 'Bauchi', type: 'state', iso_code: 'NG-BA' },
        { name: 'Bayelsa', code: 'Bayelsa', type: 'state', iso_code: 'NG-BY' },
        { name: 'Benue', code: 'Benue', type: 'state', iso_code: 'NG-BE' },
        { name: 'Borno', code: 'Borno', type: 'state', iso_code: 'NG-BO' },
        {
            name: 'Cross River',
            code: 'Cross River',
            type: 'state',
            iso_code: 'NG-CR',
        },
        { name: 'Delta', code: 'Delta', type: 'state', iso_code: 'NG-DE' },
        { name: 'Ebonyi', code: 'Ebonyi', type: 'state', iso_code: 'NG-EB' },
        { name: 'Edo', code: 'Edo', type: 'state', iso_code: 'NG-ED' },
        { name: 'Ekiti', code: 'Ekiti', type: 'state', iso_code: 'NG-EK' },
        { name: 'Enugu', code: 'Enugu', type: 'state', iso_code: 'NG-EN' },
        {
            name: 'Federal Capital Territory',
            code: 'Federal Capital Territory',
            type: 'state',
            iso_code: 'NG-FC',
        },
        { name: 'Gombe', code: 'Gombe', type: 'state', iso_code: 'NG-GO' },
        { name: 'Imo', code: 'Imo', type: 'state', iso_code: 'NG-IM' },
        { name: 'Jigawa', code: 'Jigawa', type: 'state', iso_code: 'NG-JI' },
        { name: 'Kaduna', code: 'Kaduna', type: 'state', iso_code: 'NG-KD' },
        { name: 'Kano', code: 'Kano', type: 'state', iso_code: 'NG-KN' },
        { name: 'Katsina', code: 'Katsina', type: 'state', iso_code: 'NG-KT' },
        { name: 'Kebbi', code: 'Kebbi', type: 'state', iso_code: 'NG-KE' },
        { name: 'Kogi', code: 'Kogi', type: 'state', iso_code: 'NG-KO' },
        { name: 'Kwara', code: 'Kwara', type: 'state', iso_code: 'NG-KW' },
        { name: 'Lagos', code: 'Lagos', type: 'state', iso_code: 'NG-LA' },
        { name: 'Nasarawa', code: 'Nasarawa', type: 'state', iso_code: 'NG-NA' },
        { name: 'Niger', code: 'Niger', type: 'state', iso_code: 'NG-NI' },
        {
            name: 'Ogun State',
            code: 'Ogun State',
            type: 'state',
            iso_code: 'NG-OG',
        },
        { name: 'Ondo', code: 'Ondo', type: 'state', iso_code: 'NG-ON' },
        { name: 'Osun', code: 'Osun', type: 'state', iso_code: 'NG-OS' },
        { name: 'Oyo', code: 'Oyo', type: 'state', iso_code: 'NG-OY' },
        { name: 'Plateau', code: 'Plateau', type: 'state', iso_code: 'NG-PL' },
        { name: 'Rivers', code: 'Rivers', type: 'state', iso_code: 'NG-RI' },
        { name: 'Sokoto', code: 'Sokoto', type: 'state', iso_code: 'NG-SO' },
        { name: 'Taraba', code: 'Taraba', type: 'state', iso_code: 'NG-TA' },
        { name: 'Yobe', code: 'Yobe', type: 'state', iso_code: 'NG-YO' },
        { name: 'Zamfara', code: 'Zamfara', type: 'state', iso_code: 'NG-ZA' },
    ],
    NI: [
        { name: 'Boaco', code: 'Boaco', type: 'department', iso_code: 'NI-BO' },
        { name: 'Carazo', code: 'Carazo', type: 'department', iso_code: 'NI-CA' },
        {
            name: 'Chinandega',
            code: 'Chinandega',
            type: 'department',
            iso_code: 'NI-CI',
        },
        {
            name: 'Chontales',
            code: 'Chontales',
            type: 'department',
            iso_code: 'NI-CO',
        },
        { name: 'Estelí', code: 'Estelí', type: 'department', iso_code: 'NI-ES' },
        { name: 'Granada', code: 'Granada', type: 'department', iso_code: 'NI-GR' },
        {
            name: 'Jinotega',
            code: 'Jinotega',
            type: 'department',
            iso_code: 'NI-JI',
        },
        { name: 'León', code: 'León', type: 'department', iso_code: 'NI-LE' },
        { name: 'Madriz', code: 'Madriz', type: 'department', iso_code: 'NI-MD' },
        { name: 'Managua', code: 'Managua', type: 'department', iso_code: 'NI-MN' },
        { name: 'Masaya', code: 'Masaya', type: 'department', iso_code: 'NI-MS' },
        {
            name: 'Matagalpa',
            code: 'Matagalpa',
            type: 'department',
            iso_code: 'NI-MT',
        },
        {
            name: 'Nueva Segovia',
            code: 'Nueva Segovia',
            type: 'department',
            iso_code: 'NI-NS',
        },
        {
            name: 'Región Autónoma de la Costa Caribe Norte',
            code: 'Región Autónoma de la Costa Caribe Norte',
            type: 'department',
            iso_code: 'NI-AN',
        },
        {
            name: 'Región Autónoma de la Costa Caribe Sur',
            code: 'Región Autónoma de la Costa Caribe Sur',
            type: 'department',
            iso_code: 'NI-AS',
        },
        {
            name: 'Río San Juan',
            code: 'Río San Juan',
            type: 'department',
            iso_code: 'NI-SJ',
        },
        { name: 'Rivas', code: 'Rivas', type: 'department', iso_code: 'NI-RI' },
    ],
    NL: [],
    NO: [],
    NP: [],
    NR: [
        {
            name: 'Aiwo District',
            code: 'Aiwo District',
            type: 'district',
            iso_code: 'NR-01',
        },
        {
            name: 'Anabar District',
            code: 'Anabar District',
            type: 'district',
            iso_code: 'NR-02',
        },
        {
            name: 'Anetan District',
            code: 'Anetan District',
            type: 'district',
            iso_code: 'NR-03',
        },
        {
            name: 'Anibare District',
            code: 'Anibare District',
            type: 'district',
            iso_code: 'NR-04',
        },
        {
            name: 'Baiti District',
            code: 'Baiti District',
            type: 'district',
            iso_code: 'NR-05',
        },
        {
            name: 'Boe District',
            code: 'Boe District',
            type: 'district',
            iso_code: 'NR-06',
        },
        {
            name: 'Buada District',
            code: 'Buada District',
            type: 'district',
            iso_code: 'NR-07',
        },
        {
            name: 'Denigomodu District',
            code: 'Denigomodu District',
            type: 'district',
            iso_code: 'NR-08',
        },
        {
            name: 'Ewa District',
            code: 'Ewa District',
            type: 'district',
            iso_code: 'NR-09',
        },
        {
            name: 'Ijuw District',
            code: 'Ijuw District',
            type: 'district',
            iso_code: 'NR-10',
        },
        {
            name: 'Meneng District',
            code: 'Meneng District',
            type: 'district',
            iso_code: 'NR-11',
        },
        {
            name: 'Nibok District',
            code: 'Nibok District',
            type: 'district',
            iso_code: 'NR-12',
        },
        {
            name: 'Uaboe District',
            code: 'Uaboe District',
            type: 'district',
            iso_code: 'NR-13',
        },
        {
            name: 'Yaren District',
            code: 'Yaren District',
            type: 'district',
            iso_code: 'NR-14',
        },
    ],
    NU: [],
    NZ: [],
    OM: [],
    PA: [],
    PE: [
        {
            name: 'Amazonas',
            code: 'Amazonas',
            type: 'province',
            iso_code: 'PE-AMA',
        },
        { name: 'Áncash', code: 'Áncash', type: 'province', iso_code: 'PE-ANC' },
        {
            name: 'Apurímac',
            code: 'Apurímac',
            type: 'province',
            iso_code: 'PE-APU',
        },
        {
            name: 'Arequipa',
            code: 'Arequipa',
            type: 'province',
            iso_code: 'PE-ARE',
        },
        {
            name: 'Ayacucho',
            code: 'Ayacucho',
            type: 'province',
            iso_code: 'PE-AYA',
        },
        {
            name: 'Cajamarca',
            code: 'Cajamarca',
            type: 'province',
            iso_code: 'PE-CAJ',
        },
        { name: 'Callao', code: 'Callao', type: 'province', iso_code: 'PE-CAL' },
        { name: 'Cuzco', code: 'Cuzco', type: 'province', iso_code: 'PE-CUS' },
        {
            name: 'Gobierno Regional de Lima',
            code: 'Gobierno Regional de Lima',
            type: 'province',
            iso_code: 'PE-LIM',
        },
        {
            name: 'Huancavelica',
            code: 'Huancavelica',
            type: 'province',
            iso_code: 'PE-HUV',
        },
        { name: 'Huánuco', code: 'Huánuco', type: 'province', iso_code: 'PE-HUC' },
        { name: 'Ica', code: 'Ica', type: 'province', iso_code: 'PE-ICA' },
        { name: 'Junín', code: 'Junín', type: 'province', iso_code: 'PE-JUN' },
        {
            name: 'La Libertad',
            code: 'La Libertad',
            type: 'province',
            iso_code: 'PE-LAL',
        },
        {
            name: 'Lambayeque',
            code: 'Lambayeque',
            type: 'province',
            iso_code: 'PE-LAM',
        },
        { name: 'Loreto', code: 'Loreto', type: 'province', iso_code: 'PE-LOR' },
        {
            name: 'Madre de Dios',
            code: 'Madre de Dios',
            type: 'province',
            iso_code: 'PE-MDD',
        },
        {
            name: 'Moquegua',
            code: 'Moquegua',
            type: 'province',
            iso_code: 'PE-MOQ',
        },
        {
            name: 'Municipalidad Metropolitana de Lima',
            code: 'Municipalidad Metropolitana de Lima',
            type: 'province',
            iso_code: 'PE-LMA',
        },
        { name: 'Pasco', code: 'Pasco', type: 'province', iso_code: 'PE-PAS' },
        { name: 'Piura', code: 'Piura', type: 'province', iso_code: 'PE-PIU' },
        { name: 'Puno', code: 'Puno', type: 'province', iso_code: 'PE-PUN' },
        {
            name: 'San Martín',
            code: 'San Martín',
            type: 'province',
            iso_code: 'PE-SAM',
        },
        { name: 'Tacna', code: 'Tacna', type: 'province', iso_code: 'PE-TAC' },
        { name: 'Tumbes', code: 'Tumbes', type: 'province', iso_code: 'PE-TUM' },
        { name: 'Ucayali', code: 'Ucayali', type: 'province', iso_code: 'PE-UCA' },
    ],
    PF: [],
    PG: [],
    PH: [
        { name: 'Abra', code: 'Abra', type: 'province', iso_code: 'PH-ABR' },
        {
            name: 'Agusan del Norte',
            code: 'Agusan del Norte',
            type: 'province',
            iso_code: 'PH-AGN',
        },
        {
            name: 'Agusan del Sur',
            code: 'Agusan del Sur',
            type: 'province',
            iso_code: 'PH-AGS',
        },
        { name: 'Aklan', code: 'Aklan', type: 'province', iso_code: 'PH-AKL' },
        { name: 'Albay', code: 'Albay', type: 'province', iso_code: 'PH-ALB' },
        { name: 'Antique', code: 'Antique', type: 'province', iso_code: 'PH-ANT' },
        { name: 'Apayao', code: 'Apayao', type: 'province', iso_code: 'PH-APA' },
        { name: 'Aurora', code: 'Aurora', type: 'province', iso_code: 'PH-AUR' },
        { name: 'Basilan', code: 'Basilan', type: 'province', iso_code: 'PH-BAS' },
        { name: 'Bataan', code: 'Bataan', type: 'province', iso_code: 'PH-BAN' },
        { name: 'Batanes', code: 'Batanes', type: 'province', iso_code: 'PH-BTN' },
        {
            name: 'Batangas',
            code: 'Batangas',
            type: 'province',
            iso_code: 'PH-BTG',
        },
        { name: 'Benguet', code: 'Benguet', type: 'province', iso_code: 'PH-BEN' },
        { name: 'Biliran', code: 'Biliran', type: 'province', iso_code: 'PH-BIL' },
        { name: 'Bohol', code: 'Bohol', type: 'province', iso_code: 'PH-BOH' },
        {
            name: 'Bukidnon',
            code: 'Bukidnon',
            type: 'province',
            iso_code: 'PH-BUK',
        },
        { name: 'Bulacan', code: 'Bulacan', type: 'province', iso_code: 'PH-BUL' },
        { name: 'Cagayan', code: 'Cagayan', type: 'province', iso_code: 'PH-CAG' },
        {
            name: 'Camarines Norte',
            code: 'Camarines Norte',
            type: 'province',
            iso_code: 'PH-CAN',
        },
        {
            name: 'Camarines Sur',
            code: 'Camarines Sur',
            type: 'province',
            iso_code: 'PH-CAS',
        },
        {
            name: 'Camiguin',
            code: 'Camiguin',
            type: 'province',
            iso_code: 'PH-CAM',
        },
        { name: 'Capiz', code: 'Capiz', type: 'province', iso_code: 'PH-CAP' },
        {
            name: 'Catanduanes',
            code: 'Catanduanes',
            type: 'province',
            iso_code: 'PH-CAT',
        },
        { name: 'Cavite', code: 'Cavite', type: 'province', iso_code: 'PH-CAV' },
        { name: 'Cebu', code: 'Cebu', type: 'province', iso_code: 'PH-CEB' },
        {
            name: 'Compostela Valley',
            code: 'Compostela Valley',
            type: 'province',
            iso_code: 'PH-COM',
        },
        {
            name: 'Cotabato',
            code: 'Cotabato',
            type: 'province',
            iso_code: 'PH-NCO',
        },
        {
            name: 'Davao del Norte',
            code: 'Davao del Norte',
            type: 'province',
            iso_code: 'PH-DAV',
        },
        {
            name: 'Davao del Sur',
            code: 'Davao del Sur',
            type: 'province',
            iso_code: 'PH-DAS',
        },
        {
            name: 'Davao Occidental',
            code: 'Davao Occidental',
            type: 'province',
            iso_code: 'PH-DVO',
        },
        {
            name: 'Davao Oriental',
            code: 'Davao Oriental',
            type: 'province',
            iso_code: 'PH-DAO',
        },
        {
            name: 'Dinagat Islands',
            code: 'Dinagat Islands',
            type: 'province',
            iso_code: 'PH-DIN',
        },
        {
            name: 'Eastern Samar',
            code: 'Eastern Samar',
            type: 'province',
            iso_code: 'PH-EAS',
        },
        {
            name: 'Guimaras',
            code: 'Guimaras',
            type: 'province',
            iso_code: 'PH-GUI',
        },
        { name: 'Ifugao', code: 'Ifugao', type: 'province', iso_code: 'PH-IFU' },
        {
            name: 'Ilocos Norte',
            code: 'Ilocos Norte',
            type: 'province',
            iso_code: 'PH-ILN',
        },
        {
            name: 'Ilocos Sur',
            code: 'Ilocos Sur',
            type: 'province',
            iso_code: 'PH-ILS',
        },
        { name: 'Iloilo', code: 'Iloilo', type: 'province', iso_code: 'PH-ILI' },
        { name: 'Isabela', code: 'Isabela', type: 'province', iso_code: 'PH-ISA' },
        { name: 'Kalinga', code: 'Kalinga', type: 'province', iso_code: 'PH-KAL' },
        {
            name: 'La Union',
            code: 'La Union',
            type: 'province',
            iso_code: 'PH-LUN',
        },
        { name: 'Laguna', code: 'Laguna', type: 'province', iso_code: 'PH-LAG' },
        {
            name: 'Lanao del Norte',
            code: 'Lanao del Norte',
            type: 'province',
            iso_code: 'PH-LAN',
        },
        {
            name: 'Lanao del Sur',
            code: 'Lanao del Sur',
            type: 'province',
            iso_code: 'PH-LAS',
        },
        { name: 'Leyte', code: 'Leyte', type: 'province', iso_code: 'PH-LEY' },
        {
            name: 'Maguindanao',
            code: 'Maguindanao',
            type: 'province',
            iso_code: 'PH-MAG',
        },
        {
            name: 'Marinduque',
            code: 'Marinduque',
            type: 'province',
            iso_code: 'PH-MAD',
        },
        { name: 'Masbate', code: 'Masbate', type: 'province', iso_code: 'PH-MAS' },
        {
            name: 'Metro Manila',
            code: 'Metro Manila',
            type: 'province',
            iso_code: 'PH-00',
        },
        {
            name: 'Mindoro Occidental',
            code: 'Mindoro Occidental',
            type: 'province',
            iso_code: 'PH-MDC',
        },
        {
            name: 'Mindoro Oriental',
            code: 'Mindoro Oriental',
            type: 'province',
            iso_code: 'PH-MDR',
        },
        {
            name: 'Misamis Occidental',
            code: 'Misamis Occidental',
            type: 'province',
            iso_code: 'PH-MSC',
        },
        {
            name: 'Misamis Oriental',
            code: 'Misamis Oriental',
            type: 'province',
            iso_code: 'PH-MSR',
        },
        {
            name: 'Mountain Province',
            code: 'Mountain Province',
            type: 'province',
            iso_code: 'PH-MOU',
        },
        {
            name: 'Negros Occidental',
            code: 'Negros Occidental',
            type: 'province',
            iso_code: 'PH-NEC',
        },
        {
            name: 'Negros Oriental',
            code: 'Negros Oriental',
            type: 'province',
            iso_code: 'PH-NER',
        },
        {
            name: 'Northern Samar',
            code: 'Northern Samar',
            type: 'province',
            iso_code: 'PH-NSA',
        },
        {
            name: 'Nueva Ecija',
            code: 'Nueva Ecija',
            type: 'province',
            iso_code: 'PH-NUE',
        },
        {
            name: 'Nueva Vizcaya',
            code: 'Nueva Vizcaya',
            type: 'province',
            iso_code: 'PH-NUV',
        },
        { name: 'Palawan', code: 'Palawan', type: 'province', iso_code: 'PH-PLW' },
        {
            name: 'Pampanga',
            code: 'Pampanga',
            type: 'province',
            iso_code: 'PH-PAM',
        },
        {
            name: 'Pangasinan',
            code: 'Pangasinan',
            type: 'province',
            iso_code: 'PH-PAN',
        },
        {
            name: 'Quezon Province',
            code: 'Quezon Province',
            type: 'province',
            iso_code: 'PH-QUE',
        },
        { name: 'Quirino', code: 'Quirino', type: 'province', iso_code: 'PH-QUI' },
        { name: 'Rizal', code: 'Rizal', type: 'province', iso_code: 'PH-RIZ' },
        { name: 'Romblon', code: 'Romblon', type: 'province', iso_code: 'PH-ROM' },
        { name: 'Samar', code: 'Samar', type: 'province', iso_code: 'PH-WSA' },
        {
            name: 'Sarangani',
            code: 'Sarangani',
            type: 'province',
            iso_code: 'PH-SAR',
        },
        {
            name: 'Siquijor',
            code: 'Siquijor',
            type: 'province',
            iso_code: 'PH-SIG',
        },
        {
            name: 'Sorsogon',
            code: 'Sorsogon',
            type: 'province',
            iso_code: 'PH-SOR',
        },
        {
            name: 'South Cotabato',
            code: 'South Cotabato',
            type: 'province',
            iso_code: 'PH-SCO',
        },
        {
            name: 'Southern Leyte',
            code: 'Southern Leyte',
            type: 'province',
            iso_code: 'PH-SLE',
        },
        {
            name: 'Sultan Kudarat',
            code: 'Sultan Kudarat',
            type: 'province',
            iso_code: 'PH-SUK',
        },
        { name: 'Sulu', code: 'Sulu', type: 'province', iso_code: 'PH-SLU' },
        {
            name: 'Surigao del Norte',
            code: 'Surigao del Norte',
            type: 'province',
            iso_code: 'PH-SUN',
        },
        {
            name: 'Surigao del Sur',
            code: 'Surigao del Sur',
            type: 'province',
            iso_code: 'PH-SUR',
        },
        { name: 'Tarlac', code: 'Tarlac', type: 'province', iso_code: 'PH-TAR' },
        {
            name: 'Tawi-Tawi',
            code: 'Tawi-Tawi',
            type: 'province',
            iso_code: 'PH-TAW',
        },
        {
            name: 'Zambales',
            code: 'Zambales',
            type: 'province',
            iso_code: 'PH-ZMB',
        },
        {
            name: 'Zamboanga del Norte',
            code: 'Zamboanga del Norte',
            type: 'province',
            iso_code: 'PH-ZAN',
        },
        {
            name: 'Zamboanga del Sur',
            code: 'Zamboanga del Sur',
            type: 'province',
            iso_code: 'PH-ZAS',
        },
        {
            name: 'Zamboanga Sibuguey',
            code: 'Zamboanga Sibuguey',
            type: 'province',
            iso_code: 'PH-ZSI',
        },
    ],
    PK: [],
    PL: [],
    PM: [],
    PN: [],
    PR: [],
    PS: [],
    PT: [],
    PW: [],
    PY: [],
    QA: [],
    RE: [],
    RO: [],
    RS: [],
    RU: [
        {
            name: 'Altayskiy kray',
            local_name: 'Алтайский край',
            code: 'Altayskiy kray',
            local_code: 'Алтайский край',
            type: 'oblast',
            iso_code: 'RU-ALT',
        },
        {
            name: "Amurskaya oblast'",
            local_name: 'Амурская область',
            code: "Amurskaya oblast'",
            local_code: 'Амурская область',
            type: 'oblast',
            iso_code: 'RU-AMU',
        },
        {
            name: "Arkhangelskaya oblast'",
            local_name: 'Архангельская область',
            code: "Arkhangelskaya oblast'",
            local_code: 'Архангельская область',
            type: 'oblast',
            iso_code: 'RU-ARK',
        },
        {
            name: "Astrakhanskaya oblast'",
            local_name: 'Астраханская область',
            code: "Astrakhanskaya oblast'",
            local_code: 'Астраханская область',
            type: 'oblast',
            iso_code: 'RU-AST',
        },
        {
            name: "Belgorodskaya oblast'",
            local_name: 'Белгородская область',
            code: "Belgorodskaya oblast'",
            local_code: 'Белгородская область',
            type: 'oblast',
            iso_code: 'RU-BEL',
        },
        {
            name: "Bryanskaya oblast'",
            local_name: 'Брянская область',
            code: "Bryanskaya oblast'",
            local_code: 'Брянская область',
            type: 'oblast',
            iso_code: 'RU-BRY',
        },
        {
            name: "Vladimirskaya oblast'",
            local_name: 'Владимирская область',
            code: "Vladimirskaya oblast'",
            local_code: 'Владимирская область',
            type: 'oblast',
            iso_code: 'RU-VLA',
        },
        {
            name: "Volgogradskaya oblast'",
            local_name: 'Волгоградская область',
            code: "Volgogradskaya oblast'",
            local_code: 'Волгоградская область',
            type: 'oblast',
            iso_code: 'RU-VGG',
        },
        {
            name: "Vologodskaya oblast'",
            local_name: 'Вологодская область',
            code: "Vologodskaya oblast'",
            local_code: 'Вологодская область',
            type: 'oblast',
            iso_code: 'RU-VLG',
        },
        {
            name: "Voronezhskaya oblast'",
            local_name: 'Воронежская область',
            code: "Voronezhskaya oblast'",
            local_code: 'Воронежская область',
            type: 'oblast',
            iso_code: 'RU-VOR',
        },
        {
            name: "Evreyskaya avtonomnaya oblast'",
            local_name: 'Еврейская автономная область',
            code: "Evreyskaya avtonomnaya oblast'",
            local_code: 'Еврейская автономная область',
            type: 'oblast',
            iso_code: 'RU-YEV',
        },
        {
            name: 'Zabaykalskiy kray',
            local_name: 'Забайкальский край',
            code: 'Zabaykalskiy kray',
            local_code: 'Забайкальский край',
            type: 'oblast',
            iso_code: 'RU-ZAB',
        },
        {
            name: "Ivanovskaya oblast'",
            local_name: 'Ивановская область',
            code: "Ivanovskaya oblast'",
            local_code: 'Ивановская область',
            type: 'oblast',
            iso_code: 'RU-IVA',
        },
        {
            name: "Irkutskaya oblast'",
            local_name: 'Иркутская область',
            code: "Irkutskaya oblast'",
            local_code: 'Иркутская область',
            type: 'oblast',
            iso_code: 'RU-IRK',
        },
        {
            name: 'Kabardino-Balkarskaya Republits',
            local_name: 'Кабардино-Балкарская Республика',
            code: 'Kabardino-Balkarskaya Republits',
            local_code: 'Кабардино-Балкарская Республика',
            type: 'oblast',
            iso_code: 'RU-KB',
        },
        {
            name: "Kaliningradskaya oblast'",
            local_name: 'Калининградская область',
            code: "Kaliningradskaya oblast'",
            local_code: 'Калининградская область',
            type: 'oblast',
            iso_code: 'RU-KGD',
        },
        {
            name: "Kaluzhskaya oblast'",
            local_name: 'Калужская область',
            code: "Kaluzhskaya oblast'",
            local_code: 'Калужская область',
            type: 'oblast',
            iso_code: 'RU-KLU',
        },
        {
            name: 'Kamchatskiy kray',
            local_name: 'Камчатский край',
            code: 'Kamchatskiy kray',
            local_code: 'Камчатский край',
            type: 'oblast',
            iso_code: 'RU-KAM',
        },
        {
            name: 'Karachaevo-Cherkesskaya Republits',
            local_name: 'Карачаево-Черкесская Республика',
            code: 'Karachaevo-Cherkesskaya Republits',
            local_code: 'Карачаево-Черкесская Республика',
            type: 'oblast',
            iso_code: 'RU-KC',
        },
        {
            name: "Kemerovskaya oblast'",
            local_name: 'Кемеровская область',
            code: "Kemerovskaya oblast'",
            local_code: 'Кемеровская область',
            type: 'oblast',
            iso_code: 'RU-KEM',
        },
        {
            name: "Kirovskaya oblast'",
            local_name: 'Кировская область',
            code: "Kirovskaya oblast'",
            local_code: 'Кировская область',
            type: 'oblast',
            iso_code: 'RU-KIR',
        },
        {
            name: "Kostromskaya oblast'",
            local_name: 'Костромская область',
            code: "Kostromskaya oblast'",
            local_code: 'Костромская область',
            type: 'oblast',
            iso_code: 'RU-KOS',
        },
        {
            name: 'Krasnodarskiy kray',
            local_name: 'Краснодарский край',
            code: 'Krasnodarskiy kray',
            local_code: 'Краснодарский край',
            type: 'oblast',
            iso_code: 'RU-KDA',
        },
        {
            name: 'Krasnoyarskiy kray',
            local_name: 'Красноярский край',
            code: 'Krasnoyarskiy kray',
            local_code: 'Красноярский край',
            type: 'oblast',
            iso_code: 'RU-KYA',
        },
        {
            name: "Kurganskaya oblast'",
            local_name: 'Курганская область',
            code: "Kurganskaya oblast'",
            local_code: 'Курганская область',
            type: 'oblast',
            iso_code: 'RU-KGN',
        },
        {
            name: "Kurskaya oblast'",
            local_name: 'Курская область',
            code: "Kurskaya oblast'",
            local_code: 'Курская область',
            type: 'oblast',
            iso_code: 'RU-KRS',
        },
        {
            name: "Leningradskaya oblast'",
            local_name: 'Ленинградская область',
            code: "Leningradskaya oblast'",
            local_code: 'Ленинградская область',
            type: 'oblast',
            iso_code: 'RU-LEN',
        },
        {
            name: "Lipetskaya oblast'",
            local_name: 'Липецкая область',
            code: "Lipetskaya oblast'",
            local_code: 'Липецкая область',
            type: 'oblast',
            iso_code: 'RU-LIP',
        },
        {
            name: "Magadanskaya oblast'",
            local_name: 'Магаданская область',
            code: "Magadanskaya oblast'",
            local_code: 'Магаданская область',
            type: 'oblast',
            iso_code: 'RU-MAG',
        },
        {
            name: 'Moskva',
            local_name: 'Москва',
            code: 'Moskva',
            local_code: 'Москва',
            type: 'oblast',
            iso_code: 'RU-MOW',
        },
        {
            name: "Moskovskaya oblast'",
            local_name: 'Московская область',
            code: "Moskovskaya oblast'",
            local_code: 'Московская область',
            type: 'oblast',
            iso_code: 'RU-MOS',
        },
        {
            name: "Murmanskaya oblast'",
            local_name: 'Мурманская область',
            code: "Murmanskaya oblast'",
            local_code: 'Мурманская область',
            type: 'oblast',
            iso_code: 'RU-MUR',
        },
        {
            name: 'Nenetskiy',
            local_name: 'Ненецкий автономный округ',
            code: 'Nenetskiy',
            local_code: 'Ненецкий автономный округ',
            type: 'oblast',
            iso_code: 'RU-NEN',
        },
        {
            name: "Nizhegorodskaya oblast'",
            local_name: 'Нижегородская область',
            code: "Nizhegorodskaya oblast'",
            local_code: 'Нижегородская область',
            type: 'oblast',
            iso_code: 'RU-NIZ',
        },
        {
            name: "Novgorodskaya oblast'",
            local_name: 'Новгородская область',
            code: "Novgorodskaya oblast'",
            local_code: 'Новгородская область',
            type: 'oblast',
            iso_code: 'RU-NGR',
        },
        {
            name: "Novosibirskaya oblast'",
            local_name: 'Новосибирская область',
            code: "Novosibirskaya oblast'",
            local_code: 'Новосибирская область',
            type: 'oblast',
            iso_code: 'RU-NVS',
        },
        {
            name: "Omskaya oblast'",
            local_name: 'Омская область',
            code: "Omskaya oblast'",
            local_code: 'Омская область',
            type: 'oblast',
            iso_code: 'RU-OMS',
        },
        {
            name: "Orenburgskaya oblast'",
            local_name: 'Оренбургская область',
            code: "Orenburgskaya oblast'",
            local_code: 'Оренбургская область',
            type: 'oblast',
            iso_code: 'RU-ORE',
        },
        {
            name: "Orlovskaya oblast'",
            local_name: 'Орловская область',
            code: "Orlovskaya oblast'",
            local_code: 'Орловская область',
            type: 'oblast',
            iso_code: 'RU-ORL',
        },
        {
            name: "Penzenskaya oblast'",
            local_name: 'Пензенская область',
            code: "Penzenskaya oblast'",
            local_code: 'Пензенская область',
            type: 'oblast',
            iso_code: 'RU-PNZ',
        },
        {
            name: 'Permskiy kray',
            local_name: 'Пермский край',
            code: 'Permskiy kray',
            local_code: 'Пермский край',
            type: 'oblast',
            iso_code: 'RU-PER',
        },
        {
            name: 'Primorskiy kray',
            local_name: 'Приморский край',
            code: 'Primorskiy kray',
            local_code: 'Приморский край',
            type: 'oblast',
            iso_code: 'RU-PRI',
        },
        {
            name: "Pskovskaya oblast'",
            local_name: 'Псковская область',
            code: "Pskovskaya oblast'",
            local_code: 'Псковская область',
            type: 'oblast',
            iso_code: 'RU-PSK',
        },
        {
            name: 'Respublika Adygeya',
            local_name: 'Республика Адыгея',
            code: 'Respublika Adygeya',
            local_code: 'Республика Адыгея',
            type: 'oblast',
            iso_code: 'RU-AD',
        },
        {
            name: 'Altay Republits',
            local_name: 'Республика Алтай',
            code: 'Altay Republits',
            local_code: 'Республика Алтай',
            type: 'oblast',
            iso_code: 'RU-AL',
        },
        {
            name: 'Bashkortostan Republits',
            local_name: 'Республика Башкортостан',
            code: 'Bashkortostan Republits',
            local_code: 'Республика Башкортостан',
            type: 'oblast',
            iso_code: 'RU-BA',
        },
        {
            name: 'Buryatiya Republits',
            local_name: 'Республика Бурятия',
            code: 'Buryatiya Republits',
            local_code: 'Республика Бурятия',
            type: 'oblast',
            iso_code: 'RU-BU',
        },
        {
            name: 'Dagestan Republits',
            local_name: 'Республика Дагестан',
            code: 'Dagestan Republits',
            local_code: 'Республика Дагестан',
            type: 'oblast',
            iso_code: 'RU-DA',
        },
        {
            name: 'Ingushetiya Republits',
            local_name: 'Республика Ингушетия',
            code: 'Ingushetiya Republits',
            local_code: 'Республика Ингушетия',
            type: 'oblast',
            iso_code: 'RU-IN',
        },
        {
            name: 'Respublika Kalmykiya',
            local_name: 'Республика Калмыкия',
            code: 'Respublika Kalmykiya',
            local_code: 'Республика Калмыкия',
            type: 'oblast',
            iso_code: 'RU-KL',
        },
        {
            name: 'Kareliya Republits',
            local_name: 'Республика Карелия',
            code: 'Kareliya Republits',
            local_code: 'Республика Карелия',
            type: 'oblast',
            iso_code: 'RU-KR',
        },
        {
            name: 'Komi Republits',
            local_name: 'Республика Коми',
            code: 'Komi Republits',
            local_code: 'Республика Коми',
            type: 'oblast',
            iso_code: 'RU-KO',
        },
        {
            name: 'Respublika Krym',
            local_name: 'Республика Крым',
            code: 'Respublika Krym',
            local_code: 'Автономна Республіка Крим',
            type: 'oblast',
        },
        {
            name: 'Respublika Mariy El',
            local_name: 'Республика Марий Эл',
            code: 'Respublika Mariy El',
            local_code: 'Республика Марий Эл',
            type: 'oblast',
            iso_code: 'RU-ME',
        },
        {
            name: 'Respublika Mordoviya',
            local_name: 'Республика Мордовия',
            code: 'Respublika Mordoviya',
            local_code: 'Республика Мордовия',
            type: 'oblast',
            iso_code: 'RU-MO',
        },
        {
            name: 'Sakha (Yakutiya) Republits',
            local_name: 'Республика Саха (Якутия)',
            code: 'Sakha (Yakutiya) Republits',
            local_code: 'Республика Саха (Якутия)',
            type: 'oblast',
            iso_code: 'RU-SA',
        },
        {
            name: 'Respublika Severnaya Osetiya-Alaniya',
            local_name: 'Республика Северная Осетия-Алания',
            code: 'Respublika Severnaya Osetiya-Alaniya',
            local_code: 'Республика Северная Осетия-Алания',
            type: 'oblast',
            iso_code: 'RU-SE',
        },
        {
            name: 'Respublika Tatarstan',
            local_name: 'Республика Татарстан',
            code: 'Respublika Tatarstan',
            local_code: 'Республика Татарстан',
            type: 'oblast',
            iso_code: 'RU-TA',
        },
        {
            name: 'Tyva Republits',
            local_name: 'Республика Тыва',
            code: 'Tyva Republits',
            local_code: 'Республика Тыва',
            type: 'oblast',
            iso_code: 'RU-TY',
        },
        {
            name: 'Respublika Udmurtiya',
            local_name: 'Республика Удмуртия',
            code: 'Respublika Udmurtiya',
            local_code: 'Республика Удмуртия',
            type: 'oblast',
            iso_code: 'RU-UD',
        },
        {
            name: 'Khakasiya Republits',
            local_name: 'Республика Хакасия',
            code: 'Khakasiya Republits',
            local_code: 'Республика Хакасия',
            type: 'oblast',
            iso_code: 'RU-KK',
        },
        {
            name: "Rostovskaya oblast'",
            local_name: 'Ростовская область',
            code: "Rostovskaya oblast'",
            local_code: 'Ростовская область',
            type: 'oblast',
            iso_code: 'RU-ROS',
        },
        {
            name: "Ryazanskaya oblast'",
            local_name: 'Рязанская область',
            code: "Ryazanskaya oblast'",
            local_code: 'Рязанская область',
            type: 'oblast',
            iso_code: 'RU-RYA',
        },
        {
            name: "Samarskaya oblast'",
            local_name: 'Самарская область',
            code: "Samarskaya oblast'",
            local_code: 'Самарская область',
            type: 'oblast',
            iso_code: 'RU-SAM',
        },
        {
            name: 'Sankt-Peterburg',
            local_name: 'Санкт-Петербург',
            code: 'Sankt-Peterburg',
            local_code: 'Санкт-Петербург',
            type: 'oblast',
            iso_code: 'RU-SPE',
        },
        {
            name: "Saratovskaya oblast'",
            local_name: 'Саратовская область',
            code: "Saratovskaya oblast'",
            local_code: 'Саратовская область',
            type: 'oblast',
            iso_code: 'RU-SAR',
        },
        {
            name: "Sakhalinskaya oblast'",
            local_name: 'Сахалинская область',
            code: "Sakhalinskaya oblast'",
            local_code: 'Сахалинская область',
            type: 'oblast',
            iso_code: 'RU-SAK',
        },
        {
            name: "Sverdlovskaya oblast'",
            local_name: 'Свердловская область',
            code: "Sverdlovskaya oblast'",
            local_code: 'Свердловская область',
            type: 'oblast',
            iso_code: 'RU-SVE',
        },
        {
            name: "Sevastopol'",
            local_name: 'Севастополь',
            code: "Sevastopol'",
            local_code: 'Севастополь',
            type: 'oblast',
        },
        {
            name: "Smolenskaya oblast'",
            local_name: 'Смоленская область',
            code: "Smolenskaya oblast'",
            local_code: 'Смоленская область',
            type: 'oblast',
            iso_code: 'RU-SMO',
        },
        {
            name: 'Stavropolskiy kray',
            local_name: 'Ставропольский край',
            code: 'Stavropolskiy kray',
            local_code: 'Ставропольский край',
            type: 'oblast',
            iso_code: 'RU-STA',
        },
        {
            name: "Tambovskaya oblast'",
            local_name: 'Тамбовская область',
            code: "Tambovskaya oblast'",
            local_code: 'Тамбовская область',
            type: 'oblast',
            iso_code: 'RU-TAM',
        },
        {
            name: "Tverskaya oblast'",
            local_name: 'Тверская область',
            code: "Tverskaya oblast'",
            local_code: 'Тверская область',
            type: 'oblast',
            iso_code: 'RU-TVE',
        },
        {
            name: "Tomskaya oblast'",
            local_name: 'Томская область',
            code: "Tomskaya oblast'",
            local_code: 'Томская область',
            type: 'oblast',
            iso_code: 'RU-TOM',
        },
        {
            name: "Tulskaya oblast'",
            local_name: 'Тульская область',
            code: "Tulskaya oblast'",
            local_code: 'Тульская область',
            type: 'oblast',
            iso_code: 'RU-TUL',
        },
        {
            name: "Tyumenskaya oblast'",
            local_name: 'Тюменская область',
            code: "Tyumenskaya oblast'",
            local_code: 'Тюменская область',
            type: 'oblast',
            iso_code: 'RU-TYU',
        },
        {
            name: "Ulyanovskaya oblast'",
            local_name: 'Ульяновская область',
            code: "Ulyanovskaya oblast'",
            local_code: 'Ульяновская область',
            type: 'oblast',
            iso_code: 'RU-ULY',
        },
        {
            name: 'Khabarovskiy kray',
            local_name: 'Хабаровский край',
            code: 'Khabarovskiy kray',
            local_code: 'Хабаровский край',
            type: 'oblast',
            iso_code: 'RU-KHA',
        },
        {
            name: 'Khanty-Mansiyskiy avtonomnyy okrug',
            local_name: 'Ханты-Мансийский автономный округ',
            code: 'Khanty-Mansiyskiy avtonomnyy okrug',
            local_code: 'Ханты-Мансийский автономный округ',
            type: 'oblast',
            iso_code: 'RU-KHM',
        },
        {
            name: "Chelyabinskaya oblast'",
            local_name: 'Челябинская область',
            code: "Chelyabinskaya oblast'",
            local_code: 'Челябинская область',
            type: 'oblast',
            iso_code: 'RU-CHE',
        },
        {
            name: 'Chechenskaya Republits',
            local_name: 'Чеченская Республика',
            code: 'Chechenskaya Republits',
            local_code: 'Чеченская Республика',
            type: 'oblast',
            iso_code: 'RU-CE',
        },
        {
            name: 'Chuvashia',
            local_name: 'Чувашская Республика',
            code: 'Chuvashia',
            local_code: 'Чувашская Республика',
            type: 'oblast',
            iso_code: 'RU-CU',
        },
        {
            name: 'Chukotskiy',
            local_name: 'Чукотский автономный округ',
            code: 'Chukotskiy',
            local_code: 'Чукотский автономный округ',
            type: 'oblast',
            iso_code: 'RU-CHU',
        },
        {
            name: 'Yamalo-Nenetskiy',
            local_name: 'Ямало-Ненецкий автономный округ',
            code: 'Yamalo-Nenetskiy',
            local_code: 'Ямало-Ненецкий автономный округ',
            type: 'oblast',
            iso_code: 'RU-YAN',
        },
        {
            name: "Yaroslavskaya oblast'",
            local_name: 'Ярославская область',
            code: "Yaroslavskaya oblast'",
            local_code: 'Ярославская область',
            type: 'oblast',
            iso_code: 'RU-YAR',
        },
    ],
    RW: [],
    SA: [],
    SB: [],
    SC: [],
    SD: [],
    SE: [],
    SG: [],
    SH: [],
    SI: [],
    SJ: [],
    SK: [],
    SL: [],
    SM: [],
    SN: [],
    SO: [
        { name: 'Awdal', code: 'AD', type: 'province', iso_code: 'SO-AW' },
        { name: 'Bakool', code: 'BK', type: 'province', iso_code: 'SO-BK' },
        { name: 'Banaadir', code: 'BN', type: 'province', iso_code: 'SO-BN' },
        { name: 'Bari', code: 'BR', type: 'province', iso_code: 'SO-BR' },
        { name: 'Bay', code: 'BY', type: 'province', iso_code: 'SO-BY' },
        { name: 'Galguduud', code: 'GG', type: 'province', iso_code: 'SO-GA' },
        { name: 'Gedo', code: 'GD', type: 'province', iso_code: 'SO-GE' },
        { name: 'Hiiraan', code: 'HR', type: 'province', iso_code: 'SO-HI' },
        { name: 'Jubbada Dhexe', code: 'JD', type: 'province', iso_code: 'SO-JD' },
        { name: 'Jubbada Hoose', code: 'JH', type: 'province', iso_code: 'SO-JH' },
        { name: 'Mudug', code: 'MD', type: 'province', iso_code: 'SO-MU' },
        { name: 'Nugaal', code: 'NG', type: 'province', iso_code: 'SO-NU' },
        { name: 'Sanaag', code: 'SG', type: 'province', iso_code: 'SO-SA' },
        {
            name: 'Shabeellaha Dhexe',
            code: 'SD',
            type: 'province',
            iso_code: 'SO-SD',
        },
        {
            name: 'Shabeellaha Hoose',
            code: 'SH',
            type: 'province',
            iso_code: 'SO-SH',
        },
        { name: 'Sool', code: 'SL', type: 'province', iso_code: 'SO-SO' },
        { name: 'Togdheer', code: 'TG', type: 'province', iso_code: 'SO-TO' },
        {
            name: 'Woqooyi Galbeed',
            code: 'WG',
            type: 'province',
            iso_code: 'SO-WO',
        },
    ],
    SR: [
        {
            name: 'Brokopondo',
            code: 'Brokopondo',
            type: 'province',
            iso_code: 'SR-BR',
        },
        {
            name: 'Commewijne',
            code: 'Commewijne',
            type: 'province',
            iso_code: 'SR-CM',
        },
        { name: 'Coronie', code: 'Coronie', type: 'province', iso_code: 'SR-CR' },
        {
            name: 'Marowijne',
            code: 'Marowijne',
            type: 'province',
            iso_code: 'SR-MA',
        },
        { name: 'Nickerie', code: 'Nickerie', type: 'province', iso_code: 'SR-NI' },
        { name: 'Para', code: 'Para', type: 'province', iso_code: 'SR-PR' },
        {
            name: 'Paramaribo',
            code: 'Paramaribo',
            type: 'province',
            iso_code: 'SR-PM',
        },
        {
            name: 'Saramacca',
            code: 'Saramacca',
            type: 'province',
            iso_code: 'SR-SA',
        },
        {
            name: 'Sipaliwini',
            code: 'Sipaliwini',
            type: 'province',
            iso_code: 'SR-SI',
        },
        { name: 'Wanica', code: 'Wanica', type: 'province', iso_code: 'SR-WA' },
    ],
    SS: [],
    ST: [],
    SV: [
        {
            name: 'Ahuachapán',
            code: 'Ahuachapan',
            type: 'province',
            iso_code: 'SV-AH',
        },
        { name: 'Cabañas', code: 'Cabanas', type: 'province', iso_code: 'SV-CA' },
        {
            name: 'Chalatenango',
            code: 'Calatenango',
            type: 'province',
            iso_code: 'SV-CH',
        },
        {
            name: 'Cuscatlán',
            code: 'Cuscatlan',
            type: 'province',
            iso_code: 'SV-CU',
        },
        {
            name: 'La Libertad',
            code: 'La Libertad',
            type: 'province',
            iso_code: 'SV-LI',
        },
        { name: 'La Paz', code: 'La Paz', type: 'province', iso_code: 'SV-PA' },
        { name: 'La Unión', code: 'La Union', type: 'province', iso_code: 'SV-UN' },
        { name: 'Morazán', code: 'Morazan', type: 'province', iso_code: 'SV-MO' },
        {
            name: 'San Miguel',
            code: 'San Miguel',
            type: 'province',
            iso_code: 'SV-SM',
        },
        {
            name: 'San Salvador',
            code: 'San Salvador',
            type: 'province',
            iso_code: 'SV-SS',
        },
        {
            name: 'San Vicente',
            code: 'San Vicente',
            type: 'province',
            iso_code: 'SV-SV',
        },
        {
            name: 'Santa Ana',
            code: 'Santa Ana',
            type: 'province',
            iso_code: 'SV-SA',
        },
        {
            name: 'Sonsonate',
            code: 'Sonsonate',
            type: 'province',
            iso_code: 'SV-SO',
        },
        { name: 'Usulután', code: 'Usulutan', type: 'province', iso_code: 'SV-US' },
    ],
    SX: [],
    SY: [],
    SZ: [],
    TC: [],
    TD: [],
    TF: [],
    TG: [],
    TH: [
        {
            name: 'Krabi',
            local_name: 'กระบี่',
            code: 'Krabi',
            local_code: 'กระบี่',
            type: 'province',
            iso_code: 'TH-81',
        },
        {
            name: 'Bangkok',
            local_name: 'กรุงเทพมหานคร',
            code: 'Bangkok',
            local_code: 'กรุงเทพมหานคร',
            type: 'province',
            iso_code: 'TH-10',
        },
        {
            name: 'Kanchanaburi',
            local_name: 'กาญจนบุรี',
            code: 'Kanchanaburi',
            local_code: 'กาญจนบุรี',
            type: 'province',
            iso_code: 'TH-71',
        },
        {
            name: 'Kalasin',
            local_name: 'กาฬสินธุ์',
            code: 'Kalasin',
            local_code: 'กาฬสินธุ์',
            type: 'province',
            iso_code: 'TH-46',
        },
        {
            name: 'Kamphaeng Phet',
            local_name: 'กำแพงเพชร',
            code: 'Kamphaeng Phet',
            local_code: 'กำแพงเพชร',
            type: 'province',
            iso_code: 'TH-62',
        },
        {
            name: 'Khon Kaen',
            local_name: 'ขอนแก่น',
            code: 'Khon Kaen',
            local_code: 'ขอนแก่น',
            type: 'province',
            iso_code: 'TH-40',
        },
        {
            name: 'Bueng Kan',
            local_name: 'จังหวัด บึงกาฬ',
            code: 'Bueng Kan',
            local_code: 'จังหวัด บึงกาฬ',
            type: 'province',
            iso_code: 'TH-38',
        },
        {
            name: 'Chanthaburi',
            local_name: 'จันทบุรี',
            code: 'Chanthaburi',
            local_code: 'จันทบุรี',
            type: 'province',
            iso_code: 'TH-22',
        },
        {
            name: 'Chachoengsao',
            local_name: 'ฉะเชิงเทรา',
            code: 'Chachoengsao',
            local_code: 'ฉะเชิงเทรา',
            type: 'province',
            iso_code: 'TH-24',
        },
        {
            name: 'Chon Buri',
            local_name: 'ชลบุรี',
            code: 'Chon Buri',
            local_code: 'ชลบุรี',
            type: 'province',
            iso_code: 'TH-20',
        },
        {
            name: 'Chai Nat',
            local_name: 'ชัยนาท',
            code: 'Chai Nat',
            local_code: 'ชัยนาท',
            type: 'province',
            iso_code: 'TH-18',
        },
        {
            name: 'Chaiyaphum',
            local_name: 'ชัยภูมิ',
            code: 'Chaiyaphum',
            local_code: 'ชัยภูมิ',
            type: 'province',
            iso_code: 'TH-36',
        },
        {
            name: 'Chumpon',
            local_name: 'ชุมพร',
            code: 'Chumpon',
            local_code: 'ชุมพร',
            type: 'province',
            iso_code: 'TH-86',
        },
        {
            name: 'Chiang Rai',
            local_name: 'เชียงราย',
            code: 'Chiang Rai',
            local_code: 'เชียงราย',
            type: 'province',
            iso_code: 'TH-57',
        },
        {
            name: 'Chiang Mai',
            local_name: 'เชียงใหม่',
            code: 'Chiang Mai',
            local_code: 'เชียงใหม่',
            type: 'province',
            iso_code: 'TH-50',
        },
        {
            name: 'Trang',
            local_name: 'ตรัง',
            code: 'Trang',
            local_code: 'ตรัง',
            type: 'province',
            iso_code: 'TH-92',
        },
        {
            name: 'Trat',
            local_name: 'ตราด',
            code: 'Trat',
            local_code: 'ตราด',
            type: 'province',
            iso_code: 'TH-23',
        },
        {
            name: 'Tak',
            local_name: 'ตาก',
            code: 'Tak',
            local_code: 'ตาก',
            type: 'province',
            iso_code: 'TH-63',
        },
        {
            name: 'Nakhon Nayok',
            local_name: 'นครนายก',
            code: 'Nakhon Nayok',
            local_code: 'นครนายก',
            type: 'province',
            iso_code: 'TH-26',
        },
        {
            name: 'Nakhon Pathom',
            local_name: 'นครปฐม',
            code: 'Nakhon Pathom',
            local_code: 'นครปฐม',
            type: 'province',
            iso_code: 'TH-73',
        },
        {
            name: 'Nakhon Phanom',
            local_name: 'นครพนม',
            code: 'Nakhon Phanom',
            local_code: 'นครพนม',
            type: 'province',
            iso_code: 'TH-48',
        },
        {
            name: 'Nakhon Ratchasima',
            local_name: 'นครราชสีมา',
            code: 'Nakhon Ratchasima',
            local_code: 'นครราชสีมา',
            type: 'province',
            iso_code: 'TH-30',
        },
        {
            name: 'Nakhon Si Thammarat',
            local_name: 'นครศรีธรรมราช',
            code: 'Nakhon Si Thammarat',
            local_code: 'นครศรีธรรมราช',
            type: 'province',
            iso_code: 'TH-80',
        },
        {
            name: 'Nakhon Sawan',
            local_name: 'นครสวรรค์',
            code: 'Nakhon Sawan',
            local_code: 'นครสวรรค์',
            type: 'province',
            iso_code: 'TH-60',
        },
        {
            name: 'Nonthaburi',
            local_name: 'นนทบุรี',
            code: 'Nonthaburi',
            local_code: 'นนทบุรี',
            type: 'province',
            iso_code: 'TH-12',
        },
        {
            name: 'Narathiwat',
            local_name: 'นราธิวาส',
            code: 'Narathiwat',
            local_code: 'นราธิวาส',
            type: 'province',
            iso_code: 'TH-96',
        },
        {
            name: 'Nan',
            local_name: 'น่าน',
            code: 'Nan',
            local_code: 'น่าน',
            type: 'province',
            iso_code: 'TH-55',
        },
        {
            name: 'Buri Ram',
            local_name: 'บุรีรัมย์',
            code: 'Buri Ram',
            local_code: 'บุรีรัมย์',
            type: 'province',
            iso_code: 'TH-31',
        },
        {
            name: 'Pathum Thani',
            local_name: 'ปทุมธานี',
            code: 'Pathum Thani',
            local_code: 'ปทุมธานี',
            type: 'province',
            iso_code: 'TH-13',
        },
        {
            name: 'Prachuap Khiri Khan',
            local_name: 'ประจวบคีรีขันธ์',
            code: 'Prachuap Khiri Khan',
            local_code: 'ประจวบคีรีขันธ์',
            type: 'province',
            iso_code: 'TH-77',
        },
        {
            name: 'Prachin Buri',
            local_name: 'ปราจีนบุรี',
            code: 'Prachin Buri',
            local_code: 'ปราจีนบุรี',
            type: 'province',
            iso_code: 'TH-25',
        },
        {
            name: 'Pattani',
            local_name: 'ปัตตานี',
            code: 'Pattani',
            local_code: 'ปัตตานี',
            type: 'province',
            iso_code: 'TH-94',
        },
        {
            name: 'Phra Nakhon Si Ayutthaya',
            local_name: 'พระนครศรีอยุธยา',
            code: 'Phra Nakhon Si Ayutthaya',
            local_code: 'พระนครศรีอยุธยา',
            type: 'province',
            iso_code: 'TH-14',
        },
        {
            name: 'Phayao',
            local_name: 'พะเยา',
            code: 'Phayao',
            local_code: 'พะเยา',
            type: 'province',
            iso_code: 'TH-56',
        },
        {
            name: 'Phang Nga',
            local_name: 'พังงา',
            code: 'Phang Nga',
            local_code: 'พังงา',
            type: 'province',
            iso_code: 'TH-82',
        },
        {
            name: 'Phattalung',
            local_name: 'พัทลุง',
            code: 'Phattalung',
            local_code: 'พัทลุง',
            type: 'province',
            iso_code: 'TH-93',
        },
        {
            name: 'Phichit',
            local_name: 'พิจิตร',
            code: 'Phichit',
            local_code: 'พิจิตร',
            type: 'province',
            iso_code: 'TH-66',
        },
        {
            name: 'Phitsanulok',
            local_name: 'พิษณุโลก',
            code: 'Phitsanulok',
            local_code: 'พิษณุโลก',
            type: 'province',
            iso_code: 'TH-65',
        },
        {
            name: 'Phetchaburi',
            local_name: 'เพชรบุรี',
            code: 'Phetchaburi',
            local_code: 'เพชรบุรี',
            type: 'province',
            iso_code: 'TH-76',
        },
        {
            name: 'Phetchabun',
            local_name: 'เพชรบูรณ์',
            code: 'Phetchabun',
            local_code: 'เพชรบูรณ์',
            type: 'province',
            iso_code: 'TH-67',
        },
        {
            name: 'Phrae',
            local_name: 'แพร่',
            code: 'Phrae',
            local_code: 'แพร่',
            type: 'province',
            iso_code: 'TH-54',
        },
        {
            name: 'Phuket',
            local_name: 'ภูเก็ต',
            code: 'Phuket',
            local_code: 'ภูเก็ต',
            type: 'province',
            iso_code: 'TH-83',
        },
        {
            name: 'Maha Sarakham',
            local_name: 'มหาสารคาม',
            code: 'Maha Sarakham',
            local_code: 'มหาสารคาม',
            type: 'province',
            iso_code: 'TH-44',
        },
        {
            name: 'Mukdahan',
            local_name: 'มุกดาหาร',
            code: 'Mukdahan',
            local_code: 'มุกดาหาร',
            type: 'province',
            iso_code: 'TH-49',
        },
        {
            name: 'Mae Hong Son',
            local_name: 'แม่ฮ่องสอน',
            code: 'Mae Hong Son',
            local_code: 'แม่ฮ่องสอน',
            type: 'province',
            iso_code: 'TH-58',
        },
        {
            name: 'Yasothon',
            local_name: 'ยโสธร',
            code: 'Yasothon',
            local_code: 'ยโสธร',
            type: 'province',
            iso_code: 'TH-35',
        },
        {
            name: 'Yala',
            local_name: 'ยะลา',
            code: 'Yala',
            local_code: 'ยะลา',
            type: 'province',
            iso_code: 'TH-95',
        },
        {
            name: 'Roi Et',
            local_name: 'ร้อยเอ็ด',
            code: 'Roi Et',
            local_code: 'ร้อยเอ็ด',
            type: 'province',
            iso_code: 'TH-45',
        },
        {
            name: 'Ranong',
            local_name: 'ระนอง',
            code: 'Ranong',
            local_code: 'ระนอง',
            type: 'province',
            iso_code: 'TH-85',
        },
        {
            name: 'Rayong',
            local_name: 'ระยอง',
            code: 'Rayong',
            local_code: 'ระยอง',
            type: 'province',
            iso_code: 'TH-21',
        },
        {
            name: 'Ratchaburi',
            local_name: 'ราชบุรี',
            code: 'Ratchaburi',
            local_code: 'ราชบุรี',
            type: 'province',
            iso_code: 'TH-70',
        },
        {
            name: 'Lop Buri',
            local_name: 'ลพบุรี',
            code: 'Lop Buri',
            local_code: 'ลพบุรี',
            type: 'province',
            iso_code: 'TH-16',
        },
        {
            name: 'Lampang',
            local_name: 'ลำปาง',
            code: 'Lampang',
            local_code: 'ลำปาง',
            type: 'province',
            iso_code: 'TH-52',
        },
        {
            name: 'Lamphun',
            local_name: 'ลำพูน',
            code: 'Lamphun',
            local_code: 'ลำพูน',
            type: 'province',
            iso_code: 'TH-51',
        },
        {
            name: 'Loei',
            local_name: 'เลย',
            code: 'Loei',
            local_code: 'เลย',
            type: 'province',
            iso_code: 'TH-42',
        },
        {
            name: 'Si Sa Ket',
            local_name: 'ศรีสะเกษ',
            code: 'Si Sa Ket',
            local_code: 'ศรีสะเกษ',
            type: 'province',
            iso_code: 'TH-33',
        },
        {
            name: 'Sakon Nakhon',
            local_name: 'สกลนคร',
            code: 'Sakon Nakhon',
            local_code: 'สกลนคร',
            type: 'province',
            iso_code: 'TH-47',
        },
        {
            name: 'Songkhla',
            local_name: 'สงขลา',
            code: 'Songkhla',
            local_code: 'สงขลา',
            type: 'province',
            iso_code: 'TH-90',
        },
        {
            name: 'Satun',
            local_name: 'สตูล',
            code: 'Satun',
            local_code: 'สตูล',
            type: 'province',
            iso_code: 'TH-91',
        },
        {
            name: 'Samut Prakan',
            local_name: 'สมุทรปราการ',
            code: 'Samut Prakan',
            local_code: 'สมุทรปราการ',
            type: 'province',
            iso_code: 'TH-11',
        },
        {
            name: 'Samut Songkhram',
            local_name: 'สมุทรสงคราม',
            code: 'Samut Songkhram',
            local_code: 'สมุทรสงคราม',
            type: 'province',
            iso_code: 'TH-75',
        },
        {
            name: 'Samut Sakhon',
            local_name: 'สมุทรสาคร',
            code: 'Samut Sakhon',
            local_code: 'สมุทรสาคร',
            type: 'province',
            iso_code: 'TH-74',
        },
        {
            name: 'Sa Kaeo',
            local_name: 'สระแก้ว',
            code: 'Sa Kaeo',
            local_code: 'สระแก้ว',
            type: 'province',
            iso_code: 'TH-27',
        },
        {
            name: 'Saraburi',
            local_name: 'สระบุรี',
            code: 'Saraburi',
            local_code: 'สระบุรี',
            type: 'province',
            iso_code: 'TH-19',
        },
        {
            name: 'Sing Buri',
            local_name: 'สิงห์บุรี',
            code: 'Sing Buri',
            local_code: 'สิงห์บุรี',
            type: 'province',
            iso_code: 'TH-17',
        },
        {
            name: 'Sukhothai',
            local_name: 'สุโขทัย',
            code: 'Sukhothai',
            local_code: 'สุโขทัย',
            type: 'province',
            iso_code: 'TH-64',
        },
        {
            name: 'Suphanburi',
            local_name: 'สุพรรณบุรี',
            code: 'Suphanburi',
            local_code: 'สุพรรณบุรี',
            type: 'province',
            iso_code: 'TH-72',
        },
        {
            name: 'Surat Thani',
            local_name: 'สุราษฎร์ธานี',
            code: 'Surat Thani',
            local_code: 'สุราษฎร์ธานี',
            type: 'province',
            iso_code: 'TH-84',
        },
        {
            name: 'Surin',
            local_name: 'สุรินทร์',
            code: 'Surin',
            local_code: 'สุรินทร์',
            type: 'province',
            iso_code: 'TH-32',
        },
        {
            name: 'Nong Khai',
            local_name: 'หนองคาย',
            code: 'Nong Khai',
            local_code: 'หนองคาย',
            type: 'province',
            iso_code: 'TH-43',
        },
        {
            name: 'Nong Bua Lam Phu',
            local_name: 'หนองบัวลำภู',
            code: 'Nong Bua Lam Phu',
            local_code: 'หนองบัวลำภู',
            type: 'province',
            iso_code: 'TH-39',
        },
        {
            name: 'Ang Thong',
            local_name: 'อ่างทอง',
            code: 'Ang Thong',
            local_code: 'อ่างทอง',
            type: 'province',
            iso_code: 'TH-15',
        },
        {
            name: 'Amnat Charoen',
            local_name: 'อำนาจเจริญ',
            code: 'Amnat Charoen',
            local_code: 'อำนาจเจริญ',
            type: 'province',
            iso_code: 'TH-37',
        },
        {
            name: 'Udon Thani',
            local_name: 'อุดรธานี',
            code: 'Udon Thani',
            local_code: 'อุดรธานี',
            type: 'province',
            iso_code: 'TH-41',
        },
        {
            name: 'Uttaradit',
            local_name: 'อุตรดิตถ์',
            code: 'Uttaradit',
            local_code: 'อุตรดิตถ์',
            type: 'province',
            iso_code: 'TH-53',
        },
        {
            name: 'Uthai Thani',
            local_name: 'อุทัยธานี',
            code: 'Uthai Thani',
            local_code: 'อุทัยธานี',
            type: 'province',
            iso_code: 'TH-61',
        },
        {
            name: 'Ubon Ratchathani',
            local_name: 'อุบลราชธานี',
            code: 'Ubon Ratchathani',
            local_code: 'อุบลราชธานี',
            type: 'province',
            iso_code: 'TH-34',
        },
    ],
    TJ: [],
    TK: [],
    TL: [],
    TM: [],
    TN: [],
    TO: [],
    TR: [
        { name: 'Adana', code: 'Adana', type: 'province', iso_code: 'TR-01' },
        { name: 'Adıyaman', code: 'Adıyaman', type: 'province', iso_code: 'TR-02' },
        { name: 'Afyon', code: 'Afyon', type: 'province', iso_code: 'TR-03' },
        { name: 'Ağrı', code: 'Ağrı', type: 'province', iso_code: 'TR-04' },
        { name: 'Aksaray', code: 'Aksaray', type: 'province', iso_code: 'TR-68' },
        { name: 'Amasya', code: 'Amasya', type: 'province', iso_code: 'TR-05' },
        { name: 'Ankara', code: 'Ankara', type: 'province', iso_code: 'TR-06' },
        { name: 'Antalya', code: 'Antalya', type: 'province', iso_code: 'TR-07' },
        { name: 'Ardahan', code: 'Ardahan', type: 'province', iso_code: 'TR-75' },
        { name: 'Artvin', code: 'Artvin', type: 'province', iso_code: 'TR-08' },
        { name: 'Aydın', code: 'Aydın', type: 'province', iso_code: 'TR-09' },
        {
            name: 'Balıkesir',
            code: 'Balıkesir',
            type: 'province',
            iso_code: 'TR-10',
        },
        { name: 'Bartın', code: 'Bartın', type: 'province', iso_code: 'TR-74' },
        { name: 'Batman', code: 'Batman', type: 'province', iso_code: 'TR-72' },
        { name: 'Bayburt', code: 'Bayburt', type: 'province', iso_code: 'TR-69' },
        { name: 'Bilecik', code: 'Bilecik', type: 'province', iso_code: 'TR-11' },
        { name: 'Bingöl', code: 'Bingöl', type: 'province', iso_code: 'TR-12' },
        { name: 'Bitlis', code: 'Bitlis', type: 'province', iso_code: 'TR-13' },
        { name: 'Bolu', code: 'Bolu', type: 'province', iso_code: 'TR-14' },
        { name: 'Burdur', code: 'Burdur', type: 'province', iso_code: 'TR-15' },
        { name: 'Bursa', code: 'Bursa', type: 'province', iso_code: 'TR-16' },
        {
            name: 'Çanakkale',
            code: 'Çanakkale',
            type: 'province',
            iso_code: 'TR-17',
        },
        { name: 'Çankırı', code: 'Çankırı', type: 'province', iso_code: 'TR-18' },
        { name: 'Çorum', code: 'Çorum', type: 'province', iso_code: 'TR-19' },
        { name: 'Denizli', code: 'Denizli', type: 'province', iso_code: 'TR-20' },
        {
            name: 'Diyarbakır',
            code: 'Diyarbakır',
            type: 'province',
            iso_code: 'TR-21',
        },
        { name: 'Düzce', code: 'Düzce', type: 'province', iso_code: 'TR-81' },
        { name: 'Edirne', code: 'Edirne', type: 'province', iso_code: 'TR-22' },
        { name: 'Elazığ', code: 'Elazığ', type: 'province', iso_code: 'TR-23' },
        { name: 'Erzincan', code: 'Erzincan', type: 'province', iso_code: 'TR-24' },
        { name: 'Erzurum', code: 'Erzurum', type: 'province', iso_code: 'TR-25' },
        {
            name: 'Eskişehir',
            code: 'Eskişehir',
            type: 'province',
            iso_code: 'TR-26',
        },
        {
            name: 'Gaziantep',
            code: 'Gaziantep',
            type: 'province',
            iso_code: 'TR-27',
        },
        { name: 'Giresun', code: 'Giresun', type: 'province', iso_code: 'TR-28' },
        {
            name: 'Gümüşhane',
            code: 'Gümüşhane',
            type: 'province',
            iso_code: 'TR-29',
        },
        { name: 'Hakkari', code: 'Hakkari', type: 'province', iso_code: 'TR-30' },
        { name: 'Hatay', code: 'Hatay', type: 'province', iso_code: 'TR-31' },
        { name: 'Iğdır', code: 'Iğdır', type: 'province', iso_code: 'TR-76' },
        { name: 'Isparta', code: 'Isparta', type: 'province', iso_code: 'TR-32' },
        { name: 'İstanbul', code: 'İstanbul', type: 'province', iso_code: 'TR-34' },
        { name: 'İzmir', code: 'İzmir', type: 'province', iso_code: 'TR-35' },
        {
            name: 'Kahramanmaraş',
            code: 'Kahramanmaraş',
            type: 'province',
            iso_code: 'TR-46',
        },
        { name: 'Karabük', code: 'Karabük', type: 'province', iso_code: 'TR-78' },
        { name: 'Karaman', code: 'Karaman', type: 'province', iso_code: 'TR-70' },
        { name: 'Kars', code: 'Kars', type: 'province', iso_code: 'TR-36' },
        {
            name: 'Kastamonu',
            code: 'Kastamonu',
            type: 'province',
            iso_code: 'TR-37',
        },
        { name: 'Kayseri', code: 'Kayseri', type: 'province', iso_code: 'TR-38' },
        {
            name: 'Kırıkkale',
            code: 'Kırıkkale',
            type: 'province',
            iso_code: 'TR-71',
        },
        {
            name: 'Kırklareli',
            code: 'Kırklareli',
            type: 'province',
            iso_code: 'TR-39',
        },
        { name: 'Kırşehir', code: 'Kırşehir', type: 'province', iso_code: 'TR-40' },
        { name: 'Kilis', code: 'Kilis', type: 'province', iso_code: 'TR-79' },
        { name: 'Kocaeli', code: 'Kocaeli', type: 'province', iso_code: 'TR-41' },
        { name: 'Konya', code: 'Konya', type: 'province', iso_code: 'TR-42' },
        { name: 'Kütahya', code: 'Kütahya', type: 'province', iso_code: 'TR-43' },
        { name: 'Malatya', code: 'Malatya', type: 'province', iso_code: 'TR-44' },
        { name: 'Manisa', code: 'Manisa', type: 'province', iso_code: 'TR-45' },
        { name: 'Mardin', code: 'Mardin', type: 'province', iso_code: 'TR-47' },
        { name: 'Mersin', code: 'Mersin', type: 'province', iso_code: 'TR-33' },
        { name: 'Muğla', code: 'Muğla', type: 'province', iso_code: 'TR-48' },
        { name: 'Muş', code: 'Muş', type: 'province', iso_code: 'TR-49' },
        { name: 'Nevşehir', code: 'Nevşehir', type: 'province', iso_code: 'TR-50' },
        { name: 'Niğde', code: 'Niğde', type: 'province', iso_code: 'TR-51' },
        { name: 'Ordu', code: 'Ordu', type: 'province', iso_code: 'TR-52' },
        { name: 'Osmaniye', code: 'Osmaniye', type: 'province', iso_code: 'TR-80' },
        { name: 'Rize', code: 'Rize', type: 'province', iso_code: 'TR-53' },
        { name: 'Sakarya', code: 'Sakarya', type: 'province', iso_code: 'TR-54' },
        { name: 'Samsun', code: 'Samsun', type: 'province', iso_code: 'TR-55' },
        { name: 'Siirt', code: 'Siirt', type: 'province', iso_code: 'TR-56' },
        { name: 'Sinop', code: 'Sinop', type: 'province', iso_code: 'TR-57' },
        { name: 'Sivas', code: 'Sivas', type: 'province', iso_code: 'TR-58' },
        {
            name: 'Şanlıurfa',
            code: 'Şanlıurfa',
            type: 'province',
            iso_code: 'TR-63',
        },
        { name: 'Şırnak', code: 'Şırnak', type: 'province', iso_code: 'TR-73' },
        { name: 'Tekirdağ', code: 'Tekirdağ', type: 'province', iso_code: 'TR-59' },
        { name: 'Tokat', code: 'Tokat', type: 'province', iso_code: 'TR-60' },
        { name: 'Trabzon', code: 'Trabzon', type: 'province', iso_code: 'TR-61' },
        { name: 'Tunceli', code: 'Tunceli', type: 'province', iso_code: 'TR-62' },
        { name: 'Uşak', code: 'Uşak', type: 'province', iso_code: 'TR-64' },
        { name: 'Van', code: 'Van', type: 'province', iso_code: 'TR-65' },
        { name: 'Yalova', code: 'Yalova', type: 'province', iso_code: 'TR-77' },
        { name: 'Yozgat', code: 'Yozgat', type: 'province', iso_code: 'TR-66' },
        {
            name: 'Zonguldak',
            code: 'Zonguldak',
            type: 'province',
            iso_code: 'TR-67',
        },
    ],
    TT: [],
    TV: [
        { name: 'Funafuti', code: 'Funafuti', type: 'island', iso_code: 'TV-FUN' },
        {
            name: 'Nanumanga',
            code: 'Nanumanga',
            type: 'island',
            iso_code: 'TV-NMG',
        },
        { name: 'Nanumea', code: 'Nanumea', type: 'island', iso_code: 'TV-NMA' },
        { name: 'Niulakita', code: 'Niulakita', type: 'island' },
        { name: 'Niutao', code: 'Niutao', type: 'island', iso_code: 'TV-NIT' },
        { name: 'Nui', code: 'Nui', type: 'island', iso_code: 'TV-NUI' },
        {
            name: 'Nukufetau',
            code: 'Nukufetau',
            type: 'island',
            iso_code: 'TV-NKF',
        },
        {
            name: 'Nukulaelae',
            code: 'Nukulaelae',
            type: 'island',
            iso_code: 'TV-NKL',
        },
        { name: 'Vaitupu', code: 'Vaitupu', type: 'island', iso_code: 'TV-VAI' },
    ],
    TW: [
        {
            name: 'Taichung City',
            local_name: '台中市',
            code: 'Taichung City',
            local_code: '台中市',
            type: 'county',
            iso_code: 'TW-TXG',
        },
        {
            name: 'Taipei City',
            local_name: '台北市',
            code: 'Taipei City',
            local_code: '台北市',
            type: 'county',
            iso_code: 'TW-TPE',
        },
        {
            name: 'Taitung County',
            local_name: '台東縣',
            code: 'Taitung County',
            local_code: '台東縣',
            type: 'county',
            iso_code: 'TW-TTT',
        },
        {
            name: 'Tainan City',
            local_name: '台南市',
            code: 'Tainan City',
            local_code: '台南市',
            type: 'county',
            iso_code: 'TW-TNN',
        },
        {
            name: 'Yilan County',
            local_name: '宜蘭縣',
            code: 'Yilan County',
            local_code: '宜蘭縣',
            type: 'county',
            iso_code: 'TW-ILA',
        },
        {
            name: 'Hualien County',
            local_name: '花蓮縣',
            code: 'Hualien County',
            local_code: '花蓮縣',
            type: 'county',
            iso_code: 'TW-HUA',
        },
        {
            name: 'Kinmen County',
            local_name: '金門縣',
            code: 'Kinmen County',
            local_code: '金門縣',
            type: 'county',
        },
        {
            name: 'Nantou County',
            local_name: '南投縣',
            code: 'Nantou County',
            local_code: '南投縣',
            type: 'county',
            iso_code: 'TW-NAN',
        },
        {
            name: 'Pingtung County',
            local_name: '屏東縣',
            code: 'Pingtung County',
            local_code: '屏東縣',
            type: 'county',
            iso_code: 'TW-PIF',
        },
        {
            name: 'Miaoli County',
            local_name: '苗栗縣',
            code: 'Miaoli County',
            local_code: '苗栗縣',
            type: 'county',
            iso_code: 'TW-MIA',
        },
        {
            name: 'Taoyuan City',
            local_name: '桃園市',
            code: 'Taoyuan City',
            local_code: '桃園市',
            type: 'county',
            iso_code: 'TW-TAO',
        },
        {
            name: 'Kaohsiung City',
            local_name: '高雄市',
            code: 'Kaohsiung City',
            local_code: '高雄市',
            type: 'county',
            iso_code: 'TW-KHH',
        },
        {
            name: 'Keelung City',
            local_name: '基隆市',
            code: 'Keelung City',
            local_code: '基隆市',
            type: 'county',
            iso_code: 'TW-KEE',
        },
        {
            name: 'Lienchiang County',
            local_name: '連江縣',
            code: 'Lienchiang County',
            local_code: '連江縣',
            type: 'county',
        },
        {
            name: 'Yunlin County',
            local_name: '雲林縣',
            code: 'Yunlin County',
            local_code: '雲林縣',
            type: 'county',
            iso_code: 'TW-YUN',
        },
        {
            name: 'New Taipei City',
            local_name: '新北市',
            code: 'New Taipei City',
            local_code: '新北市',
            type: 'county',
            iso_code: 'TW-NWT',
        },
        {
            name: 'Hsinchu City',
            local_name: '新竹市',
            code: 'Hsinchu City',
            local_code: '新竹市',
            type: 'county',
            iso_code: 'TW-HSZ',
        },
        {
            name: 'Hsinchu County',
            local_name: '新竹縣',
            code: 'Hsinchu County',
            local_code: '新竹縣',
            type: 'county',
            iso_code: 'TW-HSQ',
        },
        {
            name: 'Chiayi City',
            local_name: '嘉義市',
            code: 'Chiayi City',
            local_code: '嘉義市',
            type: 'county',
            iso_code: 'TW-CYI',
        },
        {
            name: 'Chiayi County',
            local_name: '嘉義縣',
            code: 'Chiayi County',
            local_code: '嘉義縣',
            type: 'county',
            iso_code: 'TW-CYQ',
        },
        {
            name: 'Changhua County',
            local_name: '彰化縣',
            code: 'Changhua County',
            local_code: '彰化縣',
            type: 'county',
            iso_code: 'TW-CHA',
        },
        {
            name: 'Penghu County',
            local_name: '澎湖縣',
            code: 'Penghu County',
            local_code: '澎湖縣',
            type: 'county',
            iso_code: 'TW-PEN',
        },
    ],
    TZ: [],
    UA: [
        {
            name: 'Crimea',
            local_name: 'Автономна Республіка Крим',
            code: 'Crimea',
            local_code: 'Автономна Республіка Крим',
            type: 'oblast',
            iso_code: 'UA-43',
        },
        {
            name: "Vinnyts'ka oblast",
            local_name: 'Вінницька область',
            code: "Vinnyts'ka oblast",
            local_code: 'Вінницька область',
            type: 'oblast',
            iso_code: 'UA-05',
        },
        {
            name: "Volyns'ka oblast",
            local_name: 'Волинська область',
            code: "Volyns'ka oblast",
            local_code: 'Волинська область',
            type: 'oblast',
            iso_code: 'UA-07',
        },
        {
            name: 'Dnipropetrovsk oblast',
            local_name: 'Дніпропетровська область',
            code: 'Dnipropetrovsk oblast',
            local_code: 'Дніпропетровська область',
            type: 'oblast',
            iso_code: 'UA-12',
        },
        {
            name: 'Donetsk oblast',
            local_name: 'Донецька область',
            code: 'Donetsk oblast',
            local_code: 'Донецька область',
            type: 'oblast',
            iso_code: 'UA-14',
        },
        {
            name: "Zhytomyrs'ka oblast",
            local_name: 'Житомирська область',
            code: "Zhytomyrs'ka oblast",
            local_code: 'Житомирська область',
            type: 'oblast',
            iso_code: 'UA-18',
        },
        {
            name: "Zakarpats'ka oblast",
            local_name: 'Закарпатська область',
            code: "Zakarpats'ka oblast",
            local_code: 'Закарпатська область',
            type: 'oblast',
            iso_code: 'UA-21',
        },
        {
            name: "Zaporiz'ka oblast",
            local_name: 'Запорізька область',
            code: "Zaporiz'ka oblast",
            local_code: 'Запорізька область',
            type: 'oblast',
            iso_code: 'UA-23',
        },
        {
            name: "Ivano-Frankivs'ka oblast",
            local_name: 'Івано-Франківська область',
            code: "Ivano-Frankivs'ka oblast",
            local_code: 'Івано-Франківська область',
            type: 'oblast',
            iso_code: 'UA-26',
        },
        {
            name: 'Kyiv city',
            local_name: 'Київ',
            code: 'Kyiv city',
            local_code: 'місто Київ',
            type: 'oblast',
            iso_code: 'UA-30',
        },
        {
            name: 'Kiev oblast',
            local_name: 'Київська область',
            code: 'Kiev oblast',
            local_code: 'Київська область',
            type: 'oblast',
            iso_code: 'UA-32',
        },
        {
            name: "Kirovohrads'ka oblast",
            local_name: 'Кіровоградська область',
            code: "Kirovohrads'ka oblast",
            local_code: 'Кіровоградська область',
            type: 'oblast',
            iso_code: 'UA-35',
        },
        {
            name: "Luhans'ka oblast",
            local_name: 'Луганська область',
            code: "Luhans'ka oblast",
            local_code: 'Луганська область',
            type: 'oblast',
            iso_code: 'UA-09',
        },
        {
            name: 'Lviv oblast',
            local_name: 'Львівська область',
            code: 'Lviv oblast',
            local_code: 'Львівська область',
            type: 'oblast',
            iso_code: 'UA-46',
        },
        {
            name: "Mykolaivs'ka oblast",
            local_name: 'Миколаївська область',
            code: "Mykolaivs'ka oblast",
            local_code: 'Миколаївська область',
            type: 'oblast',
            iso_code: 'UA-48',
        },
        {
            name: 'Odessa oblast',
            local_name: 'Одеська область',
            code: 'Odessa oblast',
            local_code: 'Одеська область',
            type: 'oblast',
            iso_code: 'UA-51',
        },
        {
            name: "Poltavs'ka oblast",
            local_name: 'Полтавська область',
            code: "Poltavs'ka oblast",
            local_code: 'Полтавська область',
            type: 'oblast',
            iso_code: 'UA-53',
        },
        {
            name: "Rivnens'ka oblast",
            local_name: 'Рівненська область',
            code: "Rivnens'ka oblast",
            local_code: 'Рівненська область',
            type: 'oblast',
            iso_code: 'UA-56',
        },
        {
            name: "Sevastopol' city",
            local_name: 'Севастополь',
            code: "Sevastopol' city",
            local_code: 'місто Севастополь',
            type: 'oblast',
            iso_code: 'UA-40',
        },
        {
            name: "Sums'ka oblast",
            local_name: 'Сумська область',
            code: "Sums'ka oblast",
            local_code: 'Сумська область',
            type: 'oblast',
            iso_code: 'UA-59',
        },
        {
            name: "Ternopil's'ka oblast",
            local_name: 'Тернопільська область',
            code: "Ternopil's'ka oblast",
            local_code: 'Тернопільська область',
            type: 'oblast',
            iso_code: 'UA-61',
        },
        {
            name: 'Kharkiv oblast',
            local_name: 'Харківська область',
            code: 'Kharkiv oblast',
            local_code: 'Харківська область',
            type: 'oblast',
            iso_code: 'UA-63',
        },
        {
            name: "Khersons'ka oblast",
            local_name: 'Херсонська область',
            code: "Khersons'ka oblast",
            local_code: 'Херсонська область',
            type: 'oblast',
            iso_code: 'UA-65',
        },
        {
            name: "Khmel'nyts'ka oblast",
            local_name: 'Хмельницька область',
            code: "Khmel'nyts'ka oblast",
            local_code: 'Хмельницька область',
            type: 'oblast',
            iso_code: 'UA-68',
        },
        {
            name: "Cherkas'ka oblast",
            local_name: 'Черкаська область',
            code: "Cherkas'ka oblast",
            local_code: 'Черкаська область',
            type: 'oblast',
            iso_code: 'UA-71',
        },
        {
            name: "Chernivets'ka oblast",
            local_name: 'Чернівецька область',
            code: "Chernivets'ka oblast",
            local_code: 'Чернівецька область',
            type: 'oblast',
            iso_code: 'UA-77',
        },
        {
            name: "Chernihivs'ka oblast",
            local_name: 'Чернігівська область',
            code: "Chernihivs'ka oblast",
            local_code: 'Чернігівська область',
            type: 'oblast',
            iso_code: 'UA-74',
        },
    ],
    UG: [],
    UM: [],
    US: [
        { name: 'Alabama', code: 'AL', type: 'state', iso_code: 'US-AL' },
        { name: 'Alaska', code: 'AK', type: 'state', iso_code: 'US-AK' },
        { name: 'American Samoa', code: 'AS', type: 'state' },
        { name: 'Arizona', code: 'AZ', type: 'state', iso_code: 'US-AZ' },
        { name: 'Arkansas', code: 'AR', type: 'state', iso_code: 'US-AR' },
        { name: 'Armed Forces (AA)', code: 'AA', type: 'state' },
        { name: 'Armed Forces (AE)', code: 'AE', type: 'state' },
        { name: 'Armed Forces (AP)', code: 'AP', type: 'state' },
        { name: 'California', code: 'CA', type: 'state', iso_code: 'US-CA' },
        { name: 'Colorado', code: 'CO', type: 'state', iso_code: 'US-CO' },
        { name: 'Connecticut', code: 'CT', type: 'state', iso_code: 'US-CT' },
        { name: 'Delaware', code: 'DE', type: 'state', iso_code: 'US-DE' },
        {
            name: 'District of Columbia',
            code: 'DC',
            type: 'state',
            iso_code: 'US-DC',
        },
        { name: 'Florida', code: 'FL', type: 'state', iso_code: 'US-FL' },
        { name: 'Georgia', code: 'GA', type: 'state', iso_code: 'US-GA' },
        { name: 'Guam', code: 'GU', type: 'state' },
        { name: 'Hawaii', code: 'HI', type: 'state', iso_code: 'US-HI' },
        { name: 'Idaho', code: 'ID', type: 'state', iso_code: 'US-ID' },
        { name: 'Illinois', code: 'IL', type: 'state', iso_code: 'US-IL' },
        { name: 'Indiana', code: 'IN', type: 'state', iso_code: 'US-IN' },
        { name: 'Iowa', code: 'IA', type: 'state', iso_code: 'US-IA' },
        { name: 'Kansas', code: 'KS', type: 'state', iso_code: 'US-KS' },
        { name: 'Kentucky', code: 'KY', type: 'state', iso_code: 'US-KY' },
        { name: 'Louisiana', code: 'LA', type: 'state', iso_code: 'US-LA' },
        { name: 'Maine', code: 'ME', type: 'state', iso_code: 'US-ME' },
        { name: 'Marshall Islands', code: 'MH', type: 'state' },
        { name: 'Maryland', code: 'MD', type: 'state', iso_code: 'US-MD' },
        { name: 'Massachusetts', code: 'MA', type: 'state', iso_code: 'US-MA' },
        { name: 'Michigan', code: 'MI', type: 'state', iso_code: 'US-MI' },
        { name: 'Micronesia', code: 'FM', type: 'state' },
        { name: 'Minnesota', code: 'MN', type: 'state', iso_code: 'US-MN' },
        { name: 'Mississippi', code: 'MS', type: 'state', iso_code: 'US-MS' },
        { name: 'Missouri', code: 'MO', type: 'state', iso_code: 'US-MO' },
        { name: 'Montana', code: 'MT', type: 'state', iso_code: 'US-MT' },
        { name: 'Nebraska', code: 'NE', type: 'state', iso_code: 'US-NE' },
        { name: 'Nevada', code: 'NV', type: 'state', iso_code: 'US-NV' },
        { name: 'New Hampshire', code: 'NH', type: 'state', iso_code: 'US-NH' },
        { name: 'New Jersey', code: 'NJ', type: 'state', iso_code: 'US-NJ' },
        { name: 'New Mexico', code: 'NM', type: 'state', iso_code: 'US-NM' },
        { name: 'New York', code: 'NY', type: 'state', iso_code: 'US-NY' },
        { name: 'North Carolina', code: 'NC', type: 'state', iso_code: 'US-NC' },
        { name: 'North Dakota', code: 'ND', type: 'state', iso_code: 'US-ND' },
        { name: 'Northern Mariana Islands', code: 'MP', type: 'state' },
        { name: 'Ohio', code: 'OH', type: 'state', iso_code: 'US-OH' },
        { name: 'Oklahoma', code: 'OK', type: 'state', iso_code: 'US-OK' },
        { name: 'Oregon', code: 'OR', type: 'state', iso_code: 'US-OR' },
        { name: 'Palau', code: 'PW', type: 'state' },
        { name: 'Pennsylvania', code: 'PA', type: 'state', iso_code: 'US-PA' },
        { name: 'Puerto Rico', code: 'PR', type: 'state' },
        { name: 'Rhode Island', code: 'RI', type: 'state', iso_code: 'US-RI' },
        { name: 'South Carolina', code: 'SC', type: 'state', iso_code: 'US-SC' },
        { name: 'South Dakota', code: 'SD', type: 'state', iso_code: 'US-SD' },
        { name: 'Tennessee', code: 'TN', type: 'state', iso_code: 'US-TN' },
        { name: 'Texas', code: 'TX', type: 'state', iso_code: 'US-TX' },
        { name: 'Utah', code: 'UT', type: 'state', iso_code: 'US-UT' },
        { name: 'Vermont', code: 'VT', type: 'state', iso_code: 'US-VT' },
        { name: 'Virgin Islands', code: 'VI', type: 'state' },
        { name: 'Virginia', code: 'VA', type: 'state', iso_code: 'US-VA' },
        { name: 'Washington', code: 'WA', type: 'state', iso_code: 'US-WA' },
        { name: 'West Virginia', code: 'WV', type: 'state', iso_code: 'US-WV' },
        { name: 'Wisconsin', code: 'WI', type: 'state', iso_code: 'US-WI' },
        { name: 'Wyoming', code: 'WY', type: 'state', iso_code: 'US-WY' },
    ],
    UY: [
        { name: 'Artigas', code: 'Artigas', type: 'province', iso_code: 'UY-AR' },
        {
            name: 'Canelones',
            code: 'Canelones',
            type: 'province',
            iso_code: 'UY-CA',
        },
        {
            name: 'Cerro Largo',
            code: 'Cerro Largo',
            type: 'province',
            iso_code: 'UY-CL',
        },
        { name: 'Colonia', code: 'Colonia', type: 'province', iso_code: 'UY-CO' },
        { name: 'Durazno', code: 'Durazno', type: 'province', iso_code: 'UY-DU' },
        { name: 'Flores', code: 'Flores', type: 'province', iso_code: 'UY-FS' },
        { name: 'Florida', code: 'Florida', type: 'province', iso_code: 'UY-FD' },
        {
            name: 'Lavalleja',
            code: 'Lavalleja',
            type: 'province',
            iso_code: 'UY-LA',
        },
        {
            name: 'Maldonado',
            code: 'Maldonado',
            type: 'province',
            iso_code: 'UY-MA',
        },
        {
            name: 'Montevideo',
            code: 'Montevideo',
            type: 'province',
            iso_code: 'UY-MO',
        },
        { name: 'Paysandú', code: 'Paysandú', type: 'province', iso_code: 'UY-PA' },
        {
            name: 'Río Negro',
            code: 'Río Negro',
            type: 'province',
            iso_code: 'UY-RN',
        },
        { name: 'Rivera', code: 'Rivera', type: 'province', iso_code: 'UY-RV' },
        { name: 'Rocha', code: 'Rocha', type: 'province', iso_code: 'UY-RO' },
        { name: 'Salto', code: 'Salto', type: 'province', iso_code: 'UY-SA' },
        { name: 'San José', code: 'San José', type: 'province', iso_code: 'UY-SJ' },
        { name: 'Soriano', code: 'Soriano', type: 'province', iso_code: 'UY-SO' },
        {
            name: 'Tacuarembó',
            code: 'Tacuarembó',
            type: 'province',
            iso_code: 'UY-TA',
        },
        {
            name: 'Treinta y Tres',
            code: 'Treinta y Tres',
            type: 'province',
            iso_code: 'UY-TT',
        },
    ],
    UZ: [],
    VA: [],
    VC: [],
    VE: [
        { name: 'Amazonas', code: 'Amazonas', type: 'state', iso_code: 'VE-Z' },
        { name: 'Anzoátegui', code: 'Anzoátegui', type: 'state', iso_code: 'VE-B' },
        { name: 'Apure', code: 'Apure', type: 'state', iso_code: 'VE-C' },
        { name: 'Aragua', code: 'Aragua', type: 'state', iso_code: 'VE-D' },
        { name: 'Barinas', code: 'Barinas', type: 'state', iso_code: 'VE-E' },
        { name: 'Bolívar', code: 'Bolívar', type: 'state', iso_code: 'VE-F' },
        { name: 'Carabobo', code: 'Carabobo', type: 'state', iso_code: 'VE-G' },
        { name: 'Cojedes', code: 'Cojedes', type: 'state', iso_code: 'VE-H' },
        {
            name: 'Delta Amacuro',
            code: 'Delta Amacuro',
            type: 'state',
            iso_code: 'VE-Y',
        },
        {
            name: 'Dependencias Federales',
            code: 'Dependencias Federales',
            type: 'state',
            iso_code: 'VE-W',
        },
        {
            name: 'Distrito Federal',
            code: 'Distrito Federal',
            type: 'state',
            iso_code: 'VE-A',
        },
        { name: 'Falcón', code: 'Falcón', type: 'state', iso_code: 'VE-I' },
        { name: 'Guárico', code: 'Guárico', type: 'state', iso_code: 'VE-J' },
        { name: 'Lara', code: 'Lara', type: 'state', iso_code: 'VE-K' },
        { name: 'Mérida', code: 'Mérida', type: 'state', iso_code: 'VE-L' },
        { name: 'Miranda', code: 'Miranda', type: 'state', iso_code: 'VE-M' },
        { name: 'Monagas', code: 'Monagas', type: 'state', iso_code: 'VE-N' },
        {
            name: 'Nueva Esparta',
            code: 'Nueva Esparta',
            type: 'state',
            iso_code: 'VE-O',
        },
        { name: 'Portuguesa', code: 'Portuguesa', type: 'state', iso_code: 'VE-P' },
        { name: 'Sucre', code: 'Sucre', type: 'state', iso_code: 'VE-R' },
        { name: 'Táchira', code: 'Táchira', type: 'state', iso_code: 'VE-S' },
        { name: 'Trujillo', code: 'Trujillo', type: 'state', iso_code: 'VE-T' },
        { name: 'Vargas', code: 'Vargas', type: 'state', iso_code: 'VE-X' },
        { name: 'Yaracuy', code: 'Yaracuy', type: 'state', iso_code: 'VE-U' },
        { name: 'Zulia', code: 'Zulia', type: 'state', iso_code: 'VE-V' },
    ],
    VG: [],
    VI: [],
    VN: [
        {
            name: 'An Giang Province',
            local_name: 'An Giang',
            code: 'An Giang Province',
            local_code: 'An Giang',
            type: 'province',
            iso_code: 'VN-44',
        },
        {
            name: 'Ba Ria-Vung Tau Province',
            local_name: 'Bà Rịa–Vũng Tàu',
            code: 'Ba Ria-Vung Tau Province',
            local_code: 'Bà Rịa–Vũng Tàu',
            type: 'province',
            iso_code: 'VN-43',
        },
        {
            name: 'Bac Lieu Province',
            local_name: 'Bạc Liêu',
            code: 'Bac Lieu Province',
            local_code: 'Bạc Liêu',
            type: 'province',
            iso_code: 'VN-55',
        },
        {
            name: 'Bac Giang Province',
            local_name: 'Bắc Giang',
            code: 'Bac Giang Province',
            local_code: 'Bắc Giang',
            type: 'province',
            iso_code: 'VN-54',
        },
        {
            name: 'Bac Kan Province',
            local_name: 'Bắc Kạn',
            code: 'Bac Kan Province',
            local_code: 'Bắc Kạn',
            type: 'province',
            iso_code: 'VN-53',
        },
        {
            name: 'Bac Ninh Province',
            local_name: 'Bắc Ninh',
            code: 'Bac Ninh Province',
            local_code: 'Bắc Ninh',
            type: 'province',
            iso_code: 'VN-56',
        },
        {
            name: 'Ben Tre Province',
            local_name: 'Bến Tre',
            code: 'Ben Tre Province',
            local_code: 'Bến Tre',
            type: 'province',
            iso_code: 'VN-50',
        },
        {
            name: 'Binh Duong Province',
            local_name: 'Bình Dương',
            code: 'Binh Duong Province',
            local_code: 'Bình Dương',
            type: 'province',
            iso_code: 'VN-57',
        },
        {
            name: 'Binh Dinh Province',
            local_name: 'Bình Định',
            code: 'Binh Dinh Province',
            local_code: 'Bình Định',
            type: 'province',
            iso_code: 'VN-31',
        },
        {
            name: 'Binh Phuoc Province',
            local_name: 'Bình Phước',
            code: 'Binh Phuoc Province',
            local_code: 'Bình Phước',
            type: 'province',
            iso_code: 'VN-58',
        },
        {
            name: 'Binh Thuan Province',
            local_name: 'Bình Thuận',
            code: 'Binh Thuan Province',
            local_code: 'Bình Thuận',
            type: 'province',
            iso_code: 'VN-40',
        },
        {
            name: 'Ca Mau Province',
            local_name: 'Cà Mau',
            code: 'Ca Mau Province',
            local_code: 'Cà Mau',
            type: 'province',
            iso_code: 'VN-59',
        },
        {
            name: 'Cao Bang Province',
            local_name: 'Cao Bằng',
            code: 'Cao Bang Province',
            local_code: 'Cao Bằng',
            type: 'province',
            iso_code: 'VN-04',
        },
        {
            name: 'Can Tho City',
            local_name: 'Cần Thơ',
            code: 'Can Tho City',
            local_code: 'Cần Thơ',
            type: 'province',
            iso_code: 'VN-CT',
        },
        {
            name: 'Da Nang City',
            local_name: 'Đà Nẵng',
            code: 'Da Nang City',
            local_code: 'Đà Nẵng',
            type: 'province',
            iso_code: 'VN-DN',
        },
        {
            name: 'Dak Lak Province',
            local_name: 'Đắk Lắk',
            code: 'Dak Lak Province',
            local_code: 'Đắk Lắk',
            type: 'province',
            iso_code: 'VN-33',
        },
        {
            name: 'Dak Nong Province',
            local_name: 'Đăk Nông',
            code: 'Dak Nong Province',
            local_code: 'Đăk Nông',
            type: 'province',
            iso_code: 'VN-72',
        },
        {
            name: 'Dien Bien Province',
            local_name: 'Điện Biên',
            code: 'Dien Bien Province',
            local_code: 'Điện Biên',
            type: 'province',
            iso_code: 'VN-71',
        },
        {
            name: 'Dong Nai Province',
            local_name: 'Đồng Nai',
            code: 'Dong Nai Province',
            local_code: 'Đồng Nai',
            type: 'province',
            iso_code: 'VN-39',
        },
        {
            name: 'Dong Thap Province',
            local_name: 'Đồng Tháp',
            code: 'Dong Thap Province',
            local_code: 'Đồng Tháp',
            type: 'province',
            iso_code: 'VN-45',
        },
        {
            name: 'Gia Lai Province',
            local_name: 'Gia Lai',
            code: 'Gia Lai Province',
            local_code: 'Gia Lai',
            type: 'province',
            iso_code: 'VN-30',
        },
        {
            name: 'Ha Giang Province',
            local_name: 'Hà Giang',
            code: 'Ha Giang Province',
            local_code: 'Hà Giang',
            type: 'province',
            iso_code: 'VN-03',
        },
        {
            name: 'Ha Nam Province',
            local_name: 'Hà Nam',
            code: 'Ha Nam Province',
            local_code: 'Hà Nam',
            type: 'province',
            iso_code: 'VN-63',
        },
        {
            name: 'Hanoi City',
            local_name: 'Hà Nội',
            code: 'Hanoi City',
            local_code: 'Hà Nội',
            type: 'province',
            iso_code: 'VN-HN',
        },
        {
            name: 'Ha Tinh Province',
            local_name: 'Hà Tĩnh',
            code: 'Ha Tinh Province',
            local_code: 'Hà Tĩnh',
            type: 'province',
            iso_code: 'VN-23',
        },
        {
            name: 'Hai Duong Province',
            local_name: 'Hải Dương',
            code: 'Hai Duong Province',
            local_code: 'Hải Dương',
            type: 'province',
            iso_code: 'VN-61',
        },
        {
            name: 'Haiphong City',
            local_name: 'Hải Phòng',
            code: 'Haiphong City',
            local_code: 'Hải Phòng',
            type: 'province',
            iso_code: 'VN-HP',
        },
        {
            name: 'Hau Giang Province',
            local_name: 'Hậu Giang',
            code: 'Hau Giang Province',
            local_code: 'Hậu Giang',
            type: 'province',
            iso_code: 'VN-73',
        },
        {
            name: 'Hoa Binh Province',
            local_name: 'Hòa Bình',
            code: 'Hoa Binh Province',
            local_code: 'Hòa Bình',
            type: 'province',
            iso_code: 'VN-14',
        },
        {
            name: 'Hung Yen Province',
            local_name: 'Hưng Yên',
            code: 'Hung Yen Province',
            local_code: 'Hưng Yên',
            type: 'province',
            iso_code: 'VN-66',
        },
        {
            name: 'Khanh Hoa Province',
            local_name: 'Khánh Hòa',
            code: 'Khanh Hoa Province',
            local_code: 'Khánh Hòa',
            type: 'province',
            iso_code: 'VN-34',
        },
        {
            name: 'Kien Giang Province',
            local_name: 'Kiên Giang',
            code: 'Kien Giang Province',
            local_code: 'Kiên Giang',
            type: 'province',
            iso_code: 'VN-47',
        },
        {
            name: 'Kon Tum Province',
            local_name: 'Kon Tum',
            code: 'Kon Tum Province',
            local_code: 'Kon Tum',
            type: 'province',
            iso_code: 'VN-28',
        },
        {
            name: 'Lai Chau Province',
            local_name: 'Lai Châu',
            code: 'Lai Chau Province',
            local_code: 'Lai Châu',
            type: 'province',
            iso_code: 'VN-01',
        },
        {
            name: 'Lang Song Province',
            local_name: 'Lạng Sơn',
            code: 'Lang Song Province',
            local_code: 'Lạng Sơn',
            type: 'province',
            iso_code: 'VN-09',
        },
        {
            name: 'Lao Cai Province',
            local_name: 'Lào Cai',
            code: 'Lao Cai Province',
            local_code: 'Lào Cai',
            type: 'province',
            iso_code: 'VN-02',
        },
        {
            name: 'Lam Dong Province',
            local_name: 'Lâm Đồng',
            code: 'Lam Dong Province',
            local_code: 'Lâm Đồng',
            type: 'province',
            iso_code: 'VN-35',
        },
        {
            name: 'Long An Province',
            local_name: 'Long An',
            code: 'Long An Province',
            local_code: 'Long An',
            type: 'province',
            iso_code: 'VN-41',
        },
        {
            name: 'Nam Dinh Province',
            local_name: 'Nam Định',
            code: 'Nam Dinh Province',
            local_code: 'Nam Định',
            type: 'province',
            iso_code: 'VN-67',
        },
        {
            name: 'Nghe An Province',
            local_name: 'Nghệ An',
            code: 'Nghe An Province',
            local_code: 'Nghệ An',
            type: 'province',
            iso_code: 'VN-22',
        },
        {
            name: 'Ninh Binh Province',
            local_name: 'Ninh Bình',
            code: 'Ninh Binh Province',
            local_code: 'Ninh Bình',
            type: 'province',
            iso_code: 'VN-18',
        },
        {
            name: 'Ninh Thuan Province',
            local_name: 'Ninh Thuận',
            code: 'Ninh Thuan Province',
            local_code: 'Ninh Thuận',
            type: 'province',
            iso_code: 'VN-36',
        },
        {
            name: 'Phu Tho Province',
            local_name: 'Phú Thọ',
            code: 'Phu Tho Province',
            local_code: 'Phú Thọ',
            type: 'province',
            iso_code: 'VN-68',
        },
        {
            name: 'Phu Yen Province',
            local_name: 'Phú Yên',
            code: 'Phu Yen Province',
            local_code: 'Phú Yên',
            type: 'province',
            iso_code: 'VN-32',
        },
        {
            name: 'Quang Binh Province',
            local_name: 'Quảng Bình',
            code: 'Quang Binh Province',
            local_code: 'Quảng Bình',
            type: 'province',
            iso_code: 'VN-24',
        },
        {
            name: 'Quang Nam Province',
            local_name: 'Quảng Nam',
            code: 'Quang Nam Province',
            local_code: 'Quảng Nam',
            type: 'province',
            iso_code: 'VN-27',
        },
        {
            name: 'Quang Ngai Province',
            local_name: 'Quảng Ngãi',
            code: 'Quang Ngai Province',
            local_code: 'Quảng Ngãi',
            type: 'province',
            iso_code: 'VN-29',
        },
        {
            name: 'Quang Ninh Province',
            local_name: 'Quảng Ninh',
            code: 'Quang Ninh Province',
            local_code: 'Quảng Ninh',
            type: 'province',
            iso_code: 'VN-13',
        },
        {
            name: 'Quang Tri Province',
            local_name: 'Quảng Trị',
            code: 'Quang Tri Province',
            local_code: 'Quảng Trị',
            type: 'province',
            iso_code: 'VN-25',
        },
        {
            name: 'Soc Trang Province',
            local_name: 'Sóc Trăng',
            code: 'Soc Trang Province',
            local_code: 'Sóc Trăng',
            type: 'province',
            iso_code: 'VN-52',
        },
        {
            name: 'Son La Province',
            local_name: 'Sơn La',
            code: 'Son La Province',
            local_code: 'Sơn La',
            type: 'province',
            iso_code: 'VN-05',
        },
        {
            name: 'Tay Ninh Province',
            local_name: 'Tây Ninh',
            code: 'Tay Ninh Province',
            local_code: 'Tây Ninh',
            type: 'province',
            iso_code: 'VN-37',
        },
        {
            name: 'Thai Binh Province',
            local_name: 'Thái Bình',
            code: 'Thai Binh Province',
            local_code: 'Thái Bình',
            type: 'province',
            iso_code: 'VN-20',
        },
        {
            name: 'Thai Nguyen Province',
            local_name: 'Thái Nguyên',
            code: 'Thai Nguyen Province',
            local_code: 'Thái Nguyên',
            type: 'province',
            iso_code: 'VN-69',
        },
        {
            name: 'Thanh Hoa Province',
            local_name: 'Thanh Hóa',
            code: 'Thanh Hoa Province',
            local_code: 'Thanh Hóa',
            type: 'province',
            iso_code: 'VN-21',
        },
        {
            name: 'Ho Chi Minh City',
            local_name: 'Thành phố Hồ Chí Minh',
            code: 'Ho Chi Minh City',
            local_code: 'Thành phố Hồ Chí Minh',
            type: 'province',
            iso_code: 'VN-SG',
        },
        {
            name: 'Thua Thien-Hue Province',
            local_name: 'Thừa Thiên–Huế',
            code: 'Thua Thien-Hue Province',
            local_code: 'Thừa Thiên–Huế',
            type: 'province',
            iso_code: 'VN-26',
        },
        {
            name: 'Tien Giang Province',
            local_name: 'Tiền Giang',
            code: 'Tien Giang Province',
            local_code: 'Tiền Giang',
            type: 'province',
            iso_code: 'VN-46',
        },
        {
            name: 'Tra Vinh Province',
            local_name: 'Trà Vinh',
            code: 'Tra Vinh Province',
            local_code: 'Trà Vinh',
            type: 'province',
            iso_code: 'VN-51',
        },
        {
            name: 'Tuyen Quang Province',
            local_name: 'Tuyên Quang',
            code: 'Tuyen Quang Province',
            local_code: 'Tuyên Quang',
            type: 'province',
            iso_code: 'VN-07',
        },
        {
            name: 'Vinh Long Province',
            local_name: 'Vĩnh Long',
            code: 'Vinh Long Province',
            local_code: 'Vĩnh Long',
            type: 'province',
            iso_code: 'VN-49',
        },
        {
            name: 'Vinh Phuc Province',
            local_name: 'Vĩnh Phúc',
            code: 'Vinh Phuc Province',
            local_code: 'Vĩnh Phúc',
            type: 'province',
            iso_code: 'VN-70',
        },
        {
            name: 'Yen Bai Province',
            local_name: 'Yên Bái',
            code: 'Yen Bai Province',
            local_code: 'Yên Bái',
            type: 'province',
            iso_code: 'VN-06',
        },
    ],
    VU: [],
    WF: [],
    WS: [],
    YE: [],
    YT: [],
    ZA: [],
    ZM: [],
    ZW: [],
};
var getStatesByCountryCode = function (countryCode) {
    var _a;
    return ((_a = exports.STATE_OPTIONS_BY_COUNTRY[countryCode.trim().toUpperCase()]) !== null && _a !== void 0 ? _a : []).map(function (area) { return ({
        value: area.code,
        label: area.name,
    }); });
};
exports.getStatesByCountryCode = getStatesByCountryCode;
var getAllStates = function () {
    var uniqueStates = new Map();
    Object.values(exports.STATE_OPTIONS_BY_COUNTRY)
        .flat()
        .forEach(function (area) {
        var state = { value: area.code, label: area.name };
        uniqueStates.set("".concat(state.value, ":").concat(state.label), state);
    });
    return Array.from(uniqueStates.values());
};
exports.getAllStates = getAllStates;
